const translations = {
  en: {
    // Navigation groups
    nav_operations: 'Operations', nav_finance: 'Finance', nav_people: 'People',
    nav_stock: 'Stock', nav_reports: 'Reports', nav_assets: 'Assets', nav_admin: 'Admin',
    nav_sales_revenue: 'Sales & Revenue', nav_expenses_payables: 'Expenses & Payables',
    nav_hr_workforce: 'HR & Workforce', nav_pos_inventory: 'POS & Inventory',
    nav_accounting: 'Accounting',
    // Nav items
    nav_dashboard: 'Dashboard', nav_quick_entry: 'Quick Entry', nav_live_analytics: 'Live Analytics',
    nav_sales: 'Sales', nav_invoices: 'Invoices', nav_expenses: 'Expenses',
    nav_supplier_payments: 'Supplier Payments', nav_cash_transfers: 'Cash Transfers',
    nav_customers: 'Customers', nav_suppliers: 'Suppliers', nav_employees: 'Employees',
    nav_leave_approvals: 'Leave Approvals', nav_schedule: 'Schedule',
    nav_inventory: 'Inventory', nav_transfers: 'Transfers', nav_kitchen: 'Kitchen',
    nav_analytics: 'Analytics', nav_visualizations: 'Visualizations', nav_reports_page: 'Reports',
    nav_credit_report: 'Credit Report', nav_supplier_report: 'Supplier Report',
    nav_category_report: 'Category Report', nav_bank_statements: 'Bank Statements',
    nav_reconciliation: 'Reconciliation', nav_branches: 'Branches', nav_documents: 'Documents',
    nav_fines: 'Fines & Penalties', nav_partners: 'Partners', nav_company_loans: 'Company Loans',
    nav_users: 'Users', nav_settings: 'Settings', nav_help: 'Help & Guide',
    // Section Help Text
    help_sales: 'Record daily sales, track cash/card/credit payments',
    help_expenses: 'Track expenses by category, supplier and payment mode',
    help_hr: 'Manage employees, payroll, leave, attendance and documents',
    help_pos: 'Configure your POS for your business type',
    help_accounting: 'Journal entries, balance sheet and income statement',
    help_reports: 'Advanced analytics, forecasts and custom reports',
    // Dashboard
    dash_title: 'Dashboard', dash_subtitle: 'Business overview at a glance',
    total_sales: 'Total Sales', total_expenses: 'Total Expenses', supplier_payments: 'Supplier Payments',
    net_profit: 'Net Profit', pending_credits: 'Pending Credits', today_vs_yesterday: 'vs yesterday',
    recent_sales: 'Recent Sales', expense_breakdown: 'Expense Breakdown',
    quick_actions: 'Quick Actions', new_sale: 'New Sale', new_expense: 'New Expense',
    view_reports: 'View Reports', cash_balance: 'Cash Balance', bank_balance: 'Bank Balance',
    customize_widgets: 'Customize Widgets', reset_layout: 'Reset Layout',
    add_widget: 'Add Widget', remove_widget: 'Remove',
    // Reconciliation Wizard
    wiz_title: 'Reconciliation in 3 steps',
    wiz_subtitle: 'Turn raw bank statements into auto-matched, audit-ready, AI-narrated forensic stories.',
    wiz_step: 'Step', wiz_done: 'Done',
    wiz_upload_title: 'Upload statement',
    wiz_upload_desc: 'Drop a CSV / XLSX bank statement to feed the smart-match engine.',
    wiz_upload_cta: 'Upload',
    wiz_review_title: 'Review auto-matches',
    wiz_review_desc: "Confirm or reject the engine's suggestions — every action lands in the audit log.",
    wiz_review_cta: 'Review',
    wiz_narrate_title: 'Generate audit story',
    wiz_narrate_desc: 'Click "Replay this match as a story" to get an AI-narrated forensic summary.',
    wiz_narrate_cta: 'Open log',
    // Sales
    sales_title: 'Sales Management', sales_subtitle: 'Track and manage all sales transactions',
    add_new_sale: 'Add New Sale', sale_date: 'Sale Date', sale_amount: 'Amount',
    payment_details: 'Payment Details', payment_mode: 'Payment Mode',
    customer_name: 'Customer Name', sale_items: 'Items', sale_notes: 'Notes',
    credit_amount: 'Credit Amount', all_sales: 'All Sales',
    // Expenses
    expenses_title: 'Expenses', expenses_subtitle: 'Track business expenditures',
    add_expense: 'Add Expense', expense_date: 'Date', expense_amount: 'Amount',
    expense_category: 'Category', expense_description: 'Description',
    all_expenses: 'All Expenses', total_label: 'Total',
    // Employees
    employees_title: 'Employees', employees_subtitle: 'Manage your team',
    add_employee: 'Add Employee', employee_name: 'Name', employee_phone: 'Phone',
    employee_email: 'Email', employee_role: 'Role', employee_salary: 'Salary',
    employee_branch: 'Branch', employee_status: 'Status', job_titles: 'Job Titles',
    active: 'Active', inactive: 'Inactive',
    // Stock
    stock_title: 'Stock Management', stock_subtitle: 'Inventory tracking and control',
    add_item: 'Add Item', item_name: 'Item Name', item_category: 'Category',
    item_unit: 'Unit', unit_price: 'Unit Price', cost_price: 'Cost Price',
    min_stock: 'Min Stock', current_stock: 'Current Stock', stock_in: 'Stock In',
    stock_out: 'Stock Out', stock_value: 'Stock Value',
    // Invoices
    invoices_title: 'Invoices', invoices_subtitle: 'Create and manage ZATCA-compliant invoices',
    create_invoice: 'Create Invoice', invoice_number: 'Invoice #', invoice_date: 'Date',
    invoice_customer: 'Customer', invoice_items: 'Items', invoice_total: 'Total',
    invoice_status: 'Status', invoice_paid: 'Paid', invoice_unpaid: 'Unpaid',
    scan_invoice: 'Scan Invoice',
    // Customers
    customers_title: 'Customers', customers_subtitle: 'Customer database and credit management',
    add_customer: 'Add Customer', customer_phone: 'Phone', customer_balance: 'Balance',
    total_customers: 'Total Customers', total_credit: 'Total Credit',
    // Suppliers
    suppliers_title: 'Suppliers', suppliers_subtitle: 'Supplier management and payments',
    add_supplier: 'Add Supplier', supplier_name: 'Supplier Name', supplier_phone: 'Phone',
    supplier_balance: 'Balance', total_suppliers: 'Total Suppliers',
    // POS
    pos_title: 'Quick Entry', pos_customer: 'Customer', pos_item: 'Item',
    pos_quantity: 'Quantity', pos_price: 'Price', pos_discount: 'Discount',
    pos_total: 'Total', pos_add_item: 'Add Item', pos_submit: 'Submit Sale',
    pos_clear: 'Clear', pos_payment_mode: 'Payment Mode',
    pos_cash: 'Cash', pos_bank: 'Bank', pos_online: 'Online', pos_credit: 'Credit',
    // Settings
    settings_title: 'Settings', settings_subtitle: 'Application configuration',
    email_config: 'Email SMTP Configuration', whatsapp_config: 'WhatsApp Configuration',
    company_branding: 'Company Branding', scheduler_config: 'Scheduled Reports',
    data_management: 'Data Management', notification_settings: 'Notification Settings',
    // Partners
    partners_title: 'Partners', partners_subtitle: 'Partner investments and profit sharing',
    add_partner: 'Add Partner', partner_name: 'Partner Name',
    share_percentage: 'Share %', total_invested: 'Total Invested',
    total_withdrawn: 'Total Withdrawn', partner_balance: 'Balance',
    // Reports
    reports_title: 'Reports', eod_summary: 'EOD Summary', partner_pnl: 'Partner P&L',
    reports_center: 'Reports center',
    pos_search_categories: 'Search categories or items...', pos_search_items: 'Search menu items...',
    pos_current_order: 'Current Order', pos_editing: 'Editing', pos_save_changes: 'Save Changes to',
    pos_dine_in: 'Dine In', pos_takeaway: 'Takeaway', pos_delivery: 'Delivery', pos_table_no: 'Table #',
    pos_cart_empty: 'Cart is empty', pos_tap_items: 'Tap items to add',
    pos_confirm_payment: 'Confirm Payment', pos_items: 'Items', pos_payment: 'Payment',
    pos_complete_order: 'Complete Order', pos_notes_optional: 'Notes (optional)', pos_notes_ph: 'Any special instructions...',
    qe_sales: 'Sales', qe_expenses: 'Expenses', qe_add_bills: 'Add Bills', qe_pay_credit: 'Pay Credit',
    qe_regular_sale: 'Regular Sale', qe_online_sales: 'Online Sales', qe_scan_qr: 'Scan Bill QR (auto-fill vendor, VAT & amount)',
    qe_record_sale: 'Record Sale', qe_record_expenses: 'Record Expenses', qe_record_biz_expenses: 'Record Business Expenses',
    qe_supplier_bills: 'Supplier Purchase Bills', qe_pay_credit_suppliers: 'Pay Credit to Suppliers',
    qe_platform_amounts: 'Enter amounts for each platform', qe_payment_amounts: 'PAYMENT AMOUNTS', qe_last_recorded: 'Last Recorded',
    qe_amount: 'Amount', qe_amount_sr: 'Amount (SR)', qe_desc_optional: 'Description (optional)',
    qe_desc_invoice_optional: 'Description / Invoice # (optional)', qe_invoice_or_desc: 'Invoice # or description (optional)',
    qe_expense_type: 'Expense Type', qe_search_customer: 'Search customer for credit...', qe_search_supplier: 'Search supplier...',
    qe_select_branch: 'Select Branch', qe_paid_cash: 'Paid by Cash', qe_paid_bank: 'Paid by Bank',
    reports_sec_financial: 'Financial Reports', reports_sec_analytics: 'Analytics & Insights',
    reports_sec_operations: 'Operations', reports_sec_customers: 'Customer Reports', reports_sec_tools: 'Tools',
    daily_summary: 'Daily Summary', top_customers: 'Top Customers',
    cashier_performance: 'Cashier Performance', generate: 'Generate',
    print_report: 'Print Report',
    // Analytics
    analytics_title: 'Advanced Analytics', analytics_subtitle: 'AI-powered business insights',
    predictive_hub: 'Predictive Analytics Hub',
    expense_forecast: 'Expense Forecast', stock_reorder: 'Stock Reorder',
    revenue_trends: 'Revenue Trends', customer_churn: 'Customer Churn',
    margin_optimizer: 'Margin Optimizer', sales_forecast: 'Sales Forecast',
    // Visualizations
    viz_title: 'Visualizations', viz_subtitle: 'Advanced charts and data exploration',
    viz_heatmap: 'Heatmap', viz_funnel: 'Funnel', viz_treemap: 'Treemap',
    viz_gauges: 'Gauges', viz_radar: 'Radar', viz_waterfall: 'Waterfall',
    viz_money_flow: 'Money Flow', viz_compare: 'Compare',
    viz_export_png: 'Export as PNG', viz_click_drill: 'Click to drill down',
    // Common
    loading: 'Loading...', save: 'Save', cancel: 'Cancel', delete: 'Delete',
    edit: 'Edit', add: 'Add', search: 'Search', filter: 'Filter',
    export_btn: 'Export', print: 'Print', refresh: 'Refresh', close: 'Close',
    confirm: 'Confirm', actions: 'Actions', status: 'Status', date: 'Date',
    amount: 'Amount', description: 'Description', category: 'Category',
    branch: 'Branch', all_branches: 'All Branches', no_data: 'No data available',
    name: 'Name', phone: 'Phone', email: 'Email', address: 'Address',
    submit: 'Submit', update: 'Update', view: 'View', download: 'Download',
    // Layout
    dark: 'Dark', light: 'Light', shortcuts: 'Shortcuts', logout: 'Logout',
    language: 'Language',
    // Stock alerts
    stock_alert_title: 'item(s) below minimum stock level',
    stock_alert_view: 'View Details', stock_alert_hide: 'Hide',
    go_to_inventory: 'Go to Inventory',
    // Misc
    transactions: 'transactions', items: 'items', payments: 'payments',
    overview: 'Overview', period: 'Period', compare: 'Compare', trends: 'Trends',
    item_pnl: 'Item P&L',
    // Common UI
    loading: 'Loading...', no_data: 'No data available', error_occurred: 'An error occurred',
    try_again: 'Try again', confirm: 'Confirm', cancel: 'Cancel', save: 'Save', delete: 'Delete',
    edit: 'Edit', view: 'View', add: 'Add', back: 'Back', next: 'Next', previous: 'Previous',
    search: 'Search', filter: 'Filter', sort: 'Sort', export: 'Export', import: 'Import',
    refresh: 'Refresh', reset: 'Reset', apply: 'Apply', clear: 'Clear',
    date: 'Date', time: 'Time', branch: 'Branch', status: 'Status', orders: 'orders',
    period: 'Period', notes: 'Notes', payment_mode: 'Payment Mode', payment_date: 'Payment Date',
    all_branches: 'All Branches', start_date: 'Start Date', end_date: 'End Date',
    // Status messages
    success: 'Success', failed: 'Failed', pending: 'Pending', completed: 'Completed',
    in_progress: 'In Progress', cancelled: 'Cancelled',
    // Shift Report
    shift_report_title: 'Daily Shift Report', shift_report_subtitle: 'Cashier shifts, sales breakdown, and cash reconciliation',
    daily_report: 'Daily Report', date_range: 'Date Range', total_shifts: 'Total Shifts',
    opening_cash: 'Opening Cash', closing_cash: 'Closing Cash', expected_cash: 'Expected Cash',
    cash_difference: 'Cash Difference', shortage: 'Shortage', overage: 'Overage', balanced: 'Balanced',
    payment_breakdown: 'Payment Method Breakdown', sales_by_branch: 'Sales by Branch',
    shift_details: 'Shift Details', top_selling_items: 'Top Selling Items',
    daily_trend: 'Daily Sales Trend', daily_breakdown: 'Daily Breakdown',
    avg_sales_day: 'Avg Sales/Day', duration: 'Duration', cashier: 'Cashier',
    // Bulk Salary
    bulk_salary_title: 'Bulk Salary Payment', bulk_payment_info: 'Pay salaries to all eligible employees at once. This will create salary payments and corresponding expense records automatically.',
    preview_select: 'Preview & Select Employees', to_pay: 'To Pay', already_paid: 'Already Paid',
    total_amount: 'Total Amount', employees_to_pay: 'Employees to Pay', select_all: 'Select All',
    pay_employees: 'Pay Employees', payment_completed: 'Payment Completed', by_branch: 'By Branch',
    skipped_failed: 'Skipped / Failed', monthly_salary_payment: 'Monthly salary payment',
    // Expense Categories
    cat_salary: 'Salary', cat_rent: 'Rent', cat_utilities: 'Utilities', cat_vehicle: 'Vehicle',
    cat_maintenance: 'Maintenance', cat_supplier: 'Supplier', cat_tickets: 'Tickets', 
    cat_id_card: 'ID Card', cat_other: 'Other',
    cat_basic_salary: 'Basic Salary', cat_overtime: 'Overtime', cat_bonus: 'Bonus',
    cat_office_rent: 'Office Rent', cat_warehouse_rent: 'Warehouse Rent', cat_shop_rent: 'Shop Rent',
    cat_electricity: 'Electricity', cat_water: 'Water', cat_internet: 'Internet', cat_phone: 'Phone',
    cat_fuel: 'Fuel', cat_insurance: 'Insurance', cat_office_maintenance: 'Office Maintenance',
    cat_equipment_repair: 'Equipment Repair',
    // Dashboard Tour
    take_tour: 'Take Tour', tour_completed: 'Tour completed! Explore your dashboard.',
    tour_welcome: 'Welcome to Smarto!', tour_welcome_desc: 'Let us show you around your new business management dashboard.',
    tour_skip: 'Skip Tour', tour_next: 'Next', tour_back: 'Back', tour_finish: 'Finish',
    tour_step: 'Step {current} of {total}',
    // Widget names
    widget_stats: 'Main Statistics', widget_charts: 'Quick Charts', widget_cash_bank: 'Cash & Bank',
    widget_payment_mode: 'Payment Modes', widget_spending: 'Spending Details', 
    widget_dues: 'Dues & Alerts', widget_branch_dues: 'Branch Dues', widget_vat: 'VAT Summary',
    widget_desc_stats: 'Sales, expenses, profit overview', widget_desc_charts: 'Expense distribution & comparison',
    widget_desc_cash: 'Cash and bank balances', widget_desc_payment: 'Cash, bank, credit breakdown',
    widget_desc_spending: 'Expense categories & spending', widget_desc_dues: 'Supplier dues, fines, alerts',
    widget_desc_branch: 'Inter-branch balances', widget_desc_vat: 'VAT calculations',
    show_all: 'Show All', minimize: 'Minimize', done: 'Done',
    // AI Widget translations
    ai_low_stock: 'AI: Low Stock Alerts', ai_low_stock_desc: 'Items predicted to run low',
    ai_peak_hours: 'AI: Peak Hours', ai_peak_hours_desc: 'Optimal staffing insights',
    ai_customer_clv: 'AI: Customer Value', ai_customer_clv_desc: 'Customer lifetime value predictions',
    ai_profit_analysis: 'AI: Profit Analysis', ai_profit_analysis_desc: 'Daily profit trends',
    items_at_risk: 'Items at risk of running low', all_stock_healthy: 'All stock levels healthy',
    days_left: 'days left', stock_level: 'Stock', reorder_point: 'Reorder',
    based_on_transactions: 'Based on {count} transactions', peak_hours_staff: 'Consider extra staff during these hours',
    of_traffic: 'of traffic', projected_revenue: 'Projected 12-month revenue',
    lifetime_value: 'lifetime value', orders_active: 'orders', days_active: 'days active',
    add_customers_clv: 'Add customers to see CLV insights', avg_daily_profit: 'Avg Daily Profit',
    trend: 'Trend', improving: 'Improving', declining: 'Declining', stable: 'Stable',
    best_day: 'Best', worst_day: 'Worst', not_enough_data: 'Not enough data for analysis',
    // Quick Actions
    quick_actions: 'Quick Actions', qa_record_sale: 'Record Sale', qa_add_expense: 'Add Expense',
    qa_pay_supplier: 'Pay Supplier', qa_new_invoice: 'New Invoice', qa_approve_leave: 'Approve Leave',
    qa_pay_salary: 'Pay Salary', qa_add_customer: 'Add Customer', qa_view_reports: 'View Reports',
    qa_stock_entry: 'Stock Entry', qa_cctv_live: 'CCTV Live', qa_available: 'available',
    qa_no_actions: 'No quick actions available for your role',
    // Menu Items
    menu_items: 'Menu Items', nav_menu_items: 'Menu Items',
    // Order Status
    order_status: 'Order Status', preparing: 'Preparing', ready_pickup: 'Ready for Pickup',
    // Other pages
    documents_title: 'Documents', fines_title: 'Fines & Penalties',
    company_loans_title: 'Company Loans', users_title: 'Users',
    branches_title: 'Branches', schedule_title: 'Shift Schedule',
    leave_title: 'Leave Approvals', cash_transfers_title: 'Cash Transfers',
    bank_statements_title: 'Bank Statements', reconciliation_title: 'Reconciliation',
    credit_report_title: 'Credit Report', supplier_report_title: 'Supplier Report',
    category_report_title: 'Category Report', kitchen_title: 'Kitchen Display',
    notifications_title: 'Notifications', help_title: 'Help & Guide',
    portal_title: 'Employee Portal',
    // CCTV
    cctv_title: 'CCTV Security', cctv_subtitle: 'AI-powered video surveillance and analytics',
    live_view: 'Live View', face_recognition: 'Face Recognition', object_detection: 'Object Detection',
    people_count: 'People Count', motion_analysis: 'Motion Analysis', alerts: 'Alerts',
    devices: 'Devices', register_face: 'Register Face', registered_faces: 'Registered Faces',
    face_attendance: 'Face Recognition Attendance', detect_objects: 'Detect Objects',
    count_people: 'Count People', analyze_motion: 'Analyze Motion',
    crowd_density: 'Crowd Density', motion_detected: 'Motion Detected', security_concern: 'Security Concern',
    no_cameras: 'No cameras configured', upload_image: 'Upload Image', run_analysis: 'Run Analysis',
    // Scheduled Monitoring
    scheduled_monitoring: 'Scheduled AI Monitoring', monitoring_interval: 'Monitoring Interval',
    enable_monitoring: 'Enable Scheduled Monitoring', run_now: 'Run Now',
    notification_channels: 'Notification Channels', in_app: 'In-App', whatsapp: 'WhatsApp',
    // Partner P&L
    partner_pl_title: 'Partner P&L Report', partner_pl_subtitle: 'Profit & Loss breakdown by partner ownership',
    company_summary: 'Company Summary', partner_breakdown: 'Partner Breakdown',
    expense_categories: 'Expense Categories', payment_modes: 'Payment Modes',
    revenue: 'Revenue', gross_profit: 'Gross Profit', operating_expenses: 'Operating Expenses',
    profit_share: 'Profit Share', ownership_percentage: 'Ownership %', investments: 'Investments',
    withdrawals: 'Withdrawals', current_balance: 'Current Balance', available_withdrawal: 'Available for Withdrawal',
    // ZATCA Phase 2
    zatca_phase2: 'ZATCA Phase 2', zatca_compliance: 'ZATCA Compliance',
    generate_xml: 'Generate XML Invoice', submit_zatca: 'Submit to ZATCA',
    xml_invoice: 'XML Invoice', qr_code: 'QR Code', invoice_uuid: 'Invoice UUID',
    digital_signature: 'Digital Signature', csid_required: 'CSID Required',
    b2b_invoice: 'B2B Tax Invoice', b2c_invoice: 'Simplified Tax Invoice',
    // Mobile Navigation
    customize_nav: 'Customize Bottom Navigation', reset_default: 'Reset to Default',
    select_items: 'Select up to 5 items', more: 'More',
    // AI Hub
    ai_hub_title: 'AI Business Hub', ai_hub_subtitle: 'AI-powered business intelligence & optimization',
    ai_hub_load_error: 'Failed to load data', ai_insights: 'AI Insights',
    ai_supplier_intel: 'Supplier Intelligence', ai_pricing_opt: 'Pricing Optimization',
    ai_churn: 'Customer Churn', ai_marketing: 'Marketing',
    ai_top_suppliers: 'Top Suppliers by Spend', ai_supplier_perf: 'Supplier Performance',
    ai_total_paid: 'Total Paid', ai_avg_order: 'Avg Order',
    ai_items_analyzed: 'Items Analyzed', ai_avg_margin: 'Avg Margin',
    ai_price_increase: 'Increase', ai_revenue_impact: '30d Revenue Impact',
    ai_pricing_recs: 'Pricing Recommendations', ai_item: 'Item',
    ai_current: 'Current', ai_cost: 'Cost', ai_margin: 'Margin',
    ai_sold_90d: 'Sold (90d)', ai_suggested: 'Suggested', ai_action: 'Action', ai_keep: 'Keep',
    ai_total_customers: 'Total Customers', ai_churned: 'Churned', ai_high_risk: 'High Risk',
    ai_at_risk_revenue: 'At-Risk Revenue', ai_risk_distribution: 'Risk Distribution',
    ai_customer_risk: 'Customer Risk Analysis', ai_total_spent: 'Total Spent',
    ai_transactions: 'Transactions', ai_days_inactive: 'Days Inactive', ai_risk_level: 'Risk',
    ai_revenue_90d: 'Revenue (90d)', ai_vip_customers: 'VIP Customers', ai_avg_value: 'Avg Customer Value',
    ai_best_day: 'Best Day', ai_worst_day: 'Worst Day', ai_top_products: 'Top Products (90d)',
    ai_campaign_suggestions: 'Campaign Suggestions', ai_target: 'Target', ai_channel: 'Channel', ai_audience: 'Audience',
    active: 'Active', inactive: 'Inactive',
    // Inventory Forecast
    inv_forecast_title: 'AI Inventory Forecast', inv_forecast_subtitle: 'AI-powered demand prediction & reorder suggestions',
    inv_avg_daily: 'Avg Daily Sales', inv_items_tracked: 'Items Tracked', inv_need_reorder: 'Need Reorder',
    inv_demand_reorder: 'Demand & Reorder Suggestions', inv_projected_sales: 'Projected Sales',
    inv_daily_demand: 'Daily Demand', inv_days_left: 'Days Left', inv_stock: 'Stock',
    inv_reorder_qty: 'Reorder Qty',
    // Cross-Branch Report
    cross_branch_title: 'Multi-Branch Financial Report', cross_branch_subtitle: 'Cross-country branch comparison',
    cross_branch_comparison: 'Branch Comparison', cross_branch_breakdown: 'Branch-by-Branch Breakdown',
    cross_branch_revenue_share: 'Revenue Share by Branch', cross_branch_local_sales: 'Local Sales',
    cross_branch_local_expenses: 'Local Expenses', cross_branch_converted_sales: 'Converted Sales',
    cross_branch_converted_profit: 'Converted Profit', cross_branch_rate: 'Rate',
    // Nav labels for new pages
    nav_ai_hub: 'AI Hub', nav_ai_forecast: 'AI Forecast', nav_cross_branch: 'Cross-Branch Report',
    nav_anomaly_detection: 'Anomaly Detection',
    // Page titles & subtitles (i18n audit)
    attendance_title: 'Attendance Dashboard', payroll_title: 'Payroll Management',
    performance_title: 'Performance & Reviews', performance_subtitle: 'Track reviews, goals, and disciplinary actions',
    training_title: 'Training Management', recruitment_title: 'Recruitment',
    recruitment_subtitle: 'Job postings, applicant tracking, and interview management',
    leave_cal_title: 'Leave Management', leave_cal_subtitle: 'Calendar view of all leaves with balance tracking',
    emp_docs_title: 'Employee Documents', hr_analytics_title: 'HR Analytics & Reports',
    balance_sheet_title: 'Balance Sheet', pnl_title: 'Profit & Loss Statement',
    journal_title: 'Journal Entries', journal_subtitle: 'Manual debit and credit entries',
    coa_title: 'Chart of Accounts', coa_subtitle: 'Manage your accounting structure',
    bills_title: 'Bills', bills_subtitle: 'Manage supplier bills and payments',
    daily_summary_title: 'Daily Summary', cashier_pos_title: 'Restaurant POS',
    stock_reorder_title: 'AI Stock Analysis', sales_forecast_title: 'AI Sales Analysis',
    sales_alerts_title: 'Sales Alerts', activity_logs_title: 'Activity Logs',
    activity_logs_subtitle: 'Track user actions and system events',
    audit_trail_title: 'Audit Trail', currency_settings_title: 'Currency Settings',
    role_mgmt_title: 'Roles & Permissions', country_laws_title: 'Country Labor Laws',
    loan_mgmt_title: 'Loan Management', loan_mgmt_subtitle: 'Track and manage employee loans and installments',
    staff_perf_title: 'Staff Performance', staff_perf_subtitle: 'Track reliability, attendance & assign AI-powered duties',
    anomaly_title: 'Anomaly Detection', anomaly_subtitle: 'AI-powered anomaly scanning for sales and expenses',
    pos_config_title: 'POS Configuration', data_mgmt_title: 'Data Management',
    data_export_title: 'Data Export', scheduled_reports_title: 'Scheduled Reports',
    menu_analytics_title: 'Menu Analytics', bi_dashboard_title: 'BI Dashboard',
    financial_dashboard_title: 'Financial Dashboard',
    financial_ratios_title: 'Financial Health Dashboard',
    // Common table/form labels
    total_employees: 'Total Employees', active_employees: 'Active Employees',
    total_documents: 'Total Documents', total_headcount: 'Total Headcount',
    as_of_date: 'As of Date', today: 'Today', yesterday: 'Yesterday',
    this_week: 'This Week', this_month: 'This Month', last_month: 'Last Month',
    custom_range: 'Custom Range', from_date: 'From', to_date: 'To',
    total_amount: 'Total Amount', grand_total: 'Grand Total',
    subtotal: 'Subtotal', discount: 'Discount', tax: 'VAT',
    excl_vat: 'Excl. VAT', vat_amount: 'VAT Amount', incl_vat: 'incl. VAT',
    quantity: 'Quantity', unit_price: 'Unit Price', total: 'Total',
    paid: 'Paid', unpaid: 'Unpaid', overdue: 'Overdue', partial: 'Partial',
    approved: 'Approved', rejected: 'Rejected', pending: 'Pending',
    planned: 'Planned', in_progress: 'In Progress', completed: 'Completed',
    debit: 'Debit', credit: 'Credit', balance: 'Balance',
    revenue: 'Revenue', expenses: 'Expenses', profit: 'Profit', loss: 'Loss',
    open: 'Open', closed: 'Closed', draft: 'Draft',
    monthly: 'Monthly', weekly: 'Weekly', daily: 'Daily', yearly: 'Yearly',
    no_results: 'No results found', showing: 'Showing', of: 'of', entries: 'entries',
    select_branch: 'Select Branch', select_date: 'Select Date',
    select_category: 'Select Category', select_status: 'Select Status',
    created_at: 'Created At', updated_at: 'Updated At', created_by: 'Created By',
    details: 'Details', summary: 'Summary', history: 'History',
    confirm_delete: 'Are you sure you want to delete this?',
    success_saved: 'Saved successfully', success_deleted: 'Deleted successfully',
    success_updated: 'Updated successfully', success_created: 'Created successfully',
    // Rate Limit Dashboard
    nav_rate_limits: 'Rate Limits',
    rate_limit_title: 'API Rate Limits',
    rate_limit_subtitle: 'Monitor and configure API usage limits',
    rate_limit_your_status: 'Your Rate Limit Status',
    rate_limit_plan: 'Plan', rate_limit_role: 'Role',
    rate_limit_your_limit: 'Your Limit', rate_limit_current_usage: 'Current Usage',
    rate_limit_tiers: 'Rate Limit Tiers',
    rate_limit_override: 'Custom Rate Limit Override',
    rate_limit_top_users: 'Top API Consumers (Current Window)',
    rate_limit_user_breakdown: 'User Breakdown',
    // Accounting pages
    trial_balance_title: 'Trial Balance',
    cash_flow_title: 'Cash Flow Statement',
    general_ledger_title: 'General Ledger',
    aging_title: 'Aging Reports',
    pnl_compare_title: 'P&L Comparison',
    recurring_entries_title: 'Recurring Journal Entries',
    // Accounting nav items
    nav_trial_balance: 'Trial Balance',
    nav_cash_flow: 'Cash Flow',
    nav_general_ledger: 'General Ledger',
    nav_aging_reports: 'AR/AP Aging',
    nav_pnl_compare: 'P&L Compare',
    nav_recurring_entries: 'Recurring Entries',
  },
  ar: {
    nav_operations: 'العمليات', nav_finance: 'المالية', nav_people: 'الأشخاص',
    nav_stock: 'المخزون', nav_reports: 'التقارير', nav_assets: 'الأصول', nav_admin: 'الإدارة',
    nav_dashboard: 'لوحة القيادة', nav_quick_entry: 'إدخال سريع', nav_live_analytics: 'تحليلات مباشرة',
    nav_sales: 'المبيعات', nav_invoices: 'الفواتير', nav_expenses: 'المصروفات',
    nav_supplier_payments: 'مدفوعات الموردين', nav_cash_transfers: 'تحويلات نقدية',
    nav_customers: 'العملاء', nav_suppliers: 'الموردون', nav_employees: 'الموظفون',
    nav_leave_approvals: 'الموافقة على الإجازات', nav_schedule: 'الجدول',
    nav_inventory: 'المخزون', nav_transfers: 'التحويلات', nav_kitchen: 'المطبخ',
    nav_analytics: 'التحليلات', nav_visualizations: 'الرسوم البيانية', nav_reports_page: 'التقارير',
    nav_credit_report: 'تقرير الائتمان', nav_supplier_report: 'تقرير الموردين',
    nav_category_report: 'تقرير الفئات', nav_bank_statements: 'كشوفات البنك',
    nav_reconciliation: 'التسوية', nav_branches: 'الفروع', nav_documents: 'المستندات',
    nav_fines: 'الغرامات والعقوبات', nav_partners: 'الشركاء', nav_company_loans: 'قروض الشركة',
    nav_users: 'المستخدمون', nav_settings: 'الإعدادات', nav_help: 'المساعدة والدليل',
    nav_sales_revenue: 'المبيعات والإيرادات', nav_expenses_payables: 'المصروفات والمدفوعات',
    nav_hr_workforce: 'الموارد البشرية', nav_pos_inventory: 'نقاط البيع والمخزون',
    nav_accounting: 'المحاسبة',
    nav_trial_balance: 'ميزان المراجعة',
    nav_cash_flow: 'التدفقات النقدية',
    nav_general_ledger: 'الأستاذ العام',
    nav_aging_reports: 'تقادم الذمم',
    nav_pnl_compare: 'مقارنة الربح والخسارة',
    nav_recurring_entries: 'القيود المتكررة',
    help_sales: 'سجل المبيعات اليومية، تتبع المدفوعات النقدية/البطاقة/الائتمان',
    help_expenses: 'تتبع المصروفات حسب الفئة والمورد وطريقة الدفع',
    help_hr: 'إدارة الموظفين والرواتب والإجازات والحضور والمستندات',
    help_pos: 'قم بتهيئة نقطة البيع وفقاً لنوع نشاطك التجاري',
    help_accounting: 'القيود اليومية والميزانية وقائمة الدخل',
    help_reports: 'تحليلات متقدمة وتوقعات وتقارير مخصصة',
    dash_title: 'لوحة القيادة', dash_subtitle: 'نظرة عامة على الأعمال',
    total_sales: 'إجمالي المبيعات', total_expenses: 'إجمالي المصروفات',
    supplier_payments: 'مدفوعات الموردين', net_profit: 'صافي الربح',
    pending_credits: 'الائتمان المعلق', today_vs_yesterday: 'مقارنة بالأمس',
    recent_sales: 'المبيعات الأخيرة', expense_breakdown: 'تفصيل المصروفات',
    quick_actions: 'إجراءات سريعة', new_sale: 'بيع جديد', new_expense: 'مصروف جديد',
    view_reports: 'عرض التقارير', cash_balance: 'رصيد النقد', bank_balance: 'رصيد البنك',
    customize_widgets: 'تخصيص الأقسام', reset_layout: 'إعادة الترتيب',
    // Reconciliation Wizard
    wiz_title: 'التسوية في 3 خطوات',
    wiz_subtitle: 'حوّل كشوف البنك الخام إلى مطابقات تلقائية وسجلات تدقيق وقصص جنائية مروية بالذكاء الاصطناعي.',
    wiz_step: 'الخطوة', wiz_done: 'تم',
    wiz_upload_title: 'رفع الكشف',
    wiz_upload_desc: 'اسحب ملف CSV / XLSX لكشف البنك لتشغيل محرك المطابقة الذكي.',
    wiz_upload_cta: 'رفع',
    wiz_review_title: 'مراجعة المطابقات التلقائية',
    wiz_review_desc: 'أكد أو ارفض اقتراحات المحرك — كل إجراء يُسجَّل في سجل التدقيق.',
    wiz_review_cta: 'مراجعة',
    wiz_narrate_title: 'إنشاء قصة التدقيق',
    wiz_narrate_desc: 'اضغط "إعادة تشغيل المطابقة كقصة" للحصول على ملخص جنائي مُروى بالذكاء الاصطناعي.',
    wiz_narrate_cta: 'فتح السجل',
    add_widget: 'إضافة قسم', remove_widget: 'إزالة',
    sales_title: 'إدارة المبيعات', sales_subtitle: 'تتبع وإدارة جميع معاملات البيع',
    add_new_sale: 'إضافة بيع جديد', sale_date: 'تاريخ البيع', sale_amount: 'المبلغ',
    payment_details: 'تفاصيل الدفع', payment_mode: 'طريقة الدفع',
    customer_name: 'اسم العميل', sale_items: 'المنتجات', sale_notes: 'ملاحظات',
    credit_amount: 'مبلغ الائتمان', all_sales: 'جميع المبيعات',
    expenses_title: 'المصروفات', expenses_subtitle: 'تتبع مصروفات الشركة',
    add_expense: 'إضافة مصروف', expense_date: 'التاريخ', expense_amount: 'المبلغ',
    expense_category: 'الفئة', expense_description: 'الوصف',
    all_expenses: 'جميع المصروفات', total_label: 'الإجمالي',
    employees_title: 'الموظفون', employees_subtitle: 'إدارة فريق العمل',
    add_employee: 'إضافة موظف', employee_name: 'الاسم', employee_phone: 'الهاتف',
    employee_email: 'البريد الإلكتروني', employee_role: 'الدور', employee_salary: 'الراتب',
    employee_branch: 'الفرع', employee_status: 'الحالة', job_titles: 'المسميات الوظيفية',
    active: 'نشط', inactive: 'غير نشط',
    stock_title: 'إدارة المخزون', stock_subtitle: 'تتبع ومراقبة المخزون',
    add_item: 'إضافة منتج', item_name: 'اسم المنتج', item_category: 'الفئة',
    item_unit: 'الوحدة', unit_price: 'سعر البيع', cost_price: 'سعر التكلفة',
    min_stock: 'الحد الأدنى', current_stock: 'المخزون الحالي', stock_in: 'إدخال مخزون',
    stock_out: 'إخراج مخزون', stock_value: 'قيمة المخزون',
    invoices_title: 'الفواتير', invoices_subtitle: 'إنشاء وإدارة فواتير متوافقة مع زاتكا',
    create_invoice: 'إنشاء فاتورة', invoice_number: 'رقم الفاتورة', invoice_date: 'التاريخ',
    invoice_customer: 'العميل', invoice_items: 'المنتجات', invoice_total: 'الإجمالي',
    invoice_status: 'الحالة', invoice_paid: 'مدفوعة', invoice_unpaid: 'غير مدفوعة',
    scan_invoice: 'مسح الفاتورة',
    customers_title: 'العملاء', customers_subtitle: 'قاعدة بيانات العملاء وإدارة الائتمان',
    add_customer: 'إضافة عميل', customer_phone: 'الهاتف', customer_balance: 'الرصيد',
    total_customers: 'إجمالي العملاء', total_credit: 'إجمالي الائتمان',
    suppliers_title: 'الموردون', suppliers_subtitle: 'إدارة الموردين والمدفوعات',
    add_supplier: 'إضافة مورد', supplier_name: 'اسم المورد', supplier_phone: 'الهاتف',
    supplier_balance: 'الرصيد', total_suppliers: 'إجمالي الموردين',
    pos_title: 'إدخال سريع', pos_customer: 'العميل', pos_item: 'المنتج',
    pos_quantity: 'الكمية', pos_price: 'السعر', pos_discount: 'الخصم',
    pos_total: 'الإجمالي', pos_add_item: 'إضافة منتج', pos_submit: 'تسجيل البيع',
    pos_clear: 'مسح', pos_payment_mode: 'طريقة الدفع',
    pos_cash: 'نقدي', pos_bank: 'بنك', pos_online: 'إلكتروني', pos_credit: 'آجل',
    settings_title: 'الإعدادات', settings_subtitle: 'إعدادات التطبيق',
    email_config: 'إعداد البريد الإلكتروني', whatsapp_config: 'إعداد الواتساب',
    company_branding: 'العلامة التجارية', scheduler_config: 'التقارير المجدولة',
    data_management: 'إدارة البيانات', notification_settings: 'إعدادات الإشعارات',
    partners_title: 'الشركاء', partners_subtitle: 'استثمارات الشركاء وتقاسم الأرباح',
    add_partner: 'إضافة شريك', partner_name: 'اسم الشريك',
    share_percentage: 'نسبة الحصة', total_invested: 'إجمالي الاستثمار',
    total_withdrawn: 'إجمالي السحب', partner_balance: 'الرصيد',
    reports_title: 'التقارير',
    reports_center: 'مركز التقارير',
    pos_search_categories: 'ابحث في الفئات أو الأصناف...', pos_search_items: 'ابحث في الأصناف...',
    pos_current_order: 'الطلب الحالي', pos_editing: 'تعديل', pos_save_changes: 'حفظ التعديلات على',
    pos_dine_in: 'محلي', pos_takeaway: 'سفري', pos_delivery: 'توصيل', pos_table_no: 'رقم الطاولة',
    pos_cart_empty: 'السلة فارغة', pos_tap_items: 'اضغط على الأصناف للإضافة',
    pos_confirm_payment: 'تأكيد الدفع', pos_items: 'الأصناف', pos_payment: 'الدفع',
    pos_complete_order: 'إتمام الطلب', pos_notes_optional: 'ملاحظات (اختياري)', pos_notes_ph: 'أي تعليمات خاصة...',
    qe_sales: 'المبيعات', qe_expenses: 'المصروفات', qe_add_bills: 'إضافة فواتير', qe_pay_credit: 'سداد الآجل',
    qe_regular_sale: 'بيع عادي', qe_online_sales: 'مبيعات أونلاين', qe_scan_qr: 'مسح QR للفاتورة (تعبئة تلقائية للمورد والضريبة والمبلغ)',
    qe_record_sale: 'تسجيل البيع', qe_record_expenses: 'تسجيل المصروفات', qe_record_biz_expenses: 'تسجيل مصروفات العمل',
    qe_supplier_bills: 'فواتير مشتريات الموردين', qe_pay_credit_suppliers: 'سداد آجل الموردين',
    qe_platform_amounts: 'أدخل المبالغ لكل منصة', qe_payment_amounts: 'مبالغ الدفع', qe_last_recorded: 'آخر تسجيل',
    qe_amount: 'المبلغ', qe_amount_sr: 'المبلغ (ر.س)', qe_desc_optional: 'الوصف (اختياري)',
    qe_desc_invoice_optional: 'الوصف / رقم الفاتورة (اختياري)', qe_invoice_or_desc: 'رقم الفاتورة أو الوصف (اختياري)',
    qe_expense_type: 'نوع المصروف', qe_search_customer: 'ابحث عن عميل آجل...', qe_search_supplier: 'ابحث عن مورد...',
    qe_select_branch: 'اختر الفرع', qe_paid_cash: 'دفع نقدي', qe_paid_bank: 'دفع بنكي',
    reports_sec_financial: 'التقارير المالية', reports_sec_analytics: 'التحليلات والرؤى',
    reports_sec_operations: 'العمليات', reports_sec_customers: 'تقارير العملاء', reports_sec_tools: 'الأدوات',
    eod_summary: 'ملخص نهاية اليوم', partner_pnl: 'أرباح وخسائر الشركاء',
    daily_summary: 'الملخص اليومي', top_customers: 'أفضل العملاء',
    cashier_performance: 'أداء الكاشير', generate: 'إنشاء', print_report: 'طباعة التقرير',
    analytics_title: 'التحليلات المتقدمة', analytics_subtitle: 'رؤى أعمال مدعومة بالذكاء الاصطناعي',
    predictive_hub: 'مركز التحليلات التنبؤية',
    expense_forecast: 'توقعات المصروفات', stock_reorder: 'إعادة طلب المخزون',
    revenue_trends: 'اتجاهات الإيرادات', customer_churn: 'مخاطر فقدان العملاء',
    margin_optimizer: 'محسّن هامش الربح', sales_forecast: 'توقعات المبيعات',
    viz_title: 'الرسوم البيانية', viz_subtitle: 'رسوم بيانية متقدمة واستكشاف البيانات',
    viz_heatmap: 'خريطة حرارية', viz_funnel: 'قمع المبيعات', viz_treemap: 'خريطة شجرية',
    viz_gauges: 'مؤشرات', viz_radar: 'رادار', viz_waterfall: 'شلال',
    viz_money_flow: 'تدفق الأموال', viz_compare: 'مقارنة',
    viz_export_png: 'تصدير كصورة', viz_click_drill: 'انقر للتفصيل',
    loading: 'جاري التحميل...', save: 'حفظ', cancel: 'إلغاء', delete: 'حذف',
    edit: 'تعديل', add: 'إضافة', search: 'بحث', filter: 'تصفية',
    export_btn: 'تصدير', print: 'طباعة', refresh: 'تحديث', close: 'إغلاق',
    confirm: 'تأكيد', actions: 'الإجراءات', status: 'الحالة', date: 'التاريخ',
    amount: 'المبلغ', description: 'الوصف', category: 'الفئة',
    branch: 'الفرع', all_branches: 'جميع الفروع', no_data: 'لا توجد بيانات',
    name: 'الاسم', phone: 'الهاتف', email: 'البريد', address: 'العنوان',
    submit: 'إرسال', update: 'تحديث', view: 'عرض', download: 'تحميل',
    dark: 'داكن', light: 'فاتح', shortcuts: 'اختصارات', logout: 'تسجيل الخروج',
    language: 'اللغة',
    stock_alert_title: 'منتج(ات) أقل من الحد الأدنى',
    stock_alert_view: 'عرض التفاصيل', stock_alert_hide: 'إخفاء',
    go_to_inventory: 'الذهاب للمخزون',
    transactions: 'معاملات', items: 'عناصر', payments: 'مدفوعات',
    overview: 'نظرة عامة', period: 'الفترة', compare: 'مقارنة', trends: 'الاتجاهات',
    item_pnl: 'أرباح المنتجات',
    // Common UI
    loading: 'جاري التحميل...', no_data: 'لا توجد بيانات', error_occurred: 'حدث خطأ',
    try_again: 'حاول مرة أخرى', confirm: 'تأكيد', cancel: 'إلغاء', save: 'حفظ', delete: 'حذف',
    edit: 'تعديل', view: 'عرض', add: 'إضافة', back: 'رجوع', next: 'التالي', previous: 'السابق',
    search: 'بحث', filter: 'تصفية', sort: 'ترتيب', export: 'تصدير', import: 'استيراد',
    refresh: 'تحديث', reset: 'إعادة تعيين', apply: 'تطبيق', clear: 'مسح',
    // Status messages
    success: 'نجاح', failed: 'فشل', pending: 'معلق', completed: 'مكتمل',
    in_progress: 'قيد التنفيذ', cancelled: 'ملغى',
    // Shift Report
    shift_report_title: 'تقرير الوردية اليومي', shift_report_subtitle: 'ورديات الكاشير وتفصيل المبيعات والتسوية النقدية',
    daily_report: 'التقرير اليومي', date_range: 'نطاق التاريخ', total_shifts: 'إجمالي الورديات',
    opening_cash: 'النقد الافتتاحي', closing_cash: 'النقد الختامي', expected_cash: 'النقد المتوقع',
    cash_difference: 'فرق النقد', shortage: 'نقص', overage: 'زيادة', balanced: 'متوازن',
    payment_breakdown: 'تفصيل طرق الدفع', sales_by_branch: 'المبيعات حسب الفرع',
    shift_details: 'تفاصيل الوردية', top_selling_items: 'الأصناف الأكثر مبيعاً',
    daily_trend: 'اتجاه المبيعات اليومي', daily_breakdown: 'التفصيل اليومي',
    avg_sales_day: 'متوسط المبيعات/يوم', duration: 'المدة', cashier: 'الكاشير',
    // Bulk Salary
    bulk_salary_title: 'دفع الرواتب الجماعي', bulk_payment_info: 'ادفع رواتب جميع الموظفين المؤهلين دفعة واحدة. سيتم إنشاء سجلات الرواتب والمصروفات تلقائياً.',
    preview_select: 'معاينة واختيار الموظفين', to_pay: 'للدفع', already_paid: 'تم الدفع',
    total_amount: 'المبلغ الإجمالي', employees_to_pay: 'الموظفون للدفع', select_all: 'تحديد الكل',
    pay_employees: 'دفع للموظفين', payment_completed: 'تم الدفع', by_branch: 'حسب الفرع',
    skipped_failed: 'تم تخطيه / فشل', monthly_salary_payment: 'دفع الراتب الشهري',
    // Expense Categories
    cat_salary: 'الراتب', cat_rent: 'الإيجار', cat_utilities: 'المرافق', cat_vehicle: 'المركبة',
    cat_maintenance: 'الصيانة', cat_supplier: 'المورد', cat_tickets: 'التذاكر',
    cat_id_card: 'بطاقة الهوية', cat_other: 'أخرى',
    cat_basic_salary: 'الراتب الأساسي', cat_overtime: 'العمل الإضافي', cat_bonus: 'المكافأة',
    cat_office_rent: 'إيجار المكتب', cat_warehouse_rent: 'إيجار المستودع', cat_shop_rent: 'إيجار المحل',
    cat_electricity: 'الكهرباء', cat_water: 'الماء', cat_internet: 'الإنترنت', cat_phone: 'الهاتف',
    cat_fuel: 'الوقود', cat_insurance: 'التأمين', cat_office_maintenance: 'صيانة المكتب',
    cat_equipment_repair: 'إصلاح المعدات',
    // Widget names
    widget_stats: 'الإحصائيات الرئيسية', widget_charts: 'الرسوم البيانية السريعة', widget_cash_bank: 'النقد والبنك',
    widget_payment_mode: 'طرق الدفع', widget_spending: 'تفاصيل الإنفاق',
    widget_dues: 'المستحقات والتنبيهات', widget_branch_dues: 'مستحقات الفروع', widget_vat: 'ملخص الضريبة',
    widget_desc_stats: 'نظرة عامة على المبيعات والمصروفات والأرباح', widget_desc_charts: 'توزيع ومقارنة المصروفات',
    widget_desc_cash: 'أرصدة النقد والبنك', widget_desc_payment: 'تفصيل النقد والبنك والائتمان',
    widget_desc_spending: 'فئات المصروفات والإنفاق', widget_desc_dues: 'مستحقات الموردين والغرامات والتنبيهات',
    widget_desc_branch: 'الأرصدة بين الفروع', widget_desc_vat: 'حسابات الضريبة',
    show_all: 'إظهار الكل', minimize: 'تصغير', done: 'تم',
    // AI Widget translations
    ai_low_stock: 'الذكاء الاصطناعي: تنبيهات المخزون', ai_low_stock_desc: 'المنتجات المتوقع نفادها',
    ai_peak_hours: 'الذكاء الاصطناعي: ساعات الذروة', ai_peak_hours_desc: 'رؤى التوظيف المثالي',
    ai_customer_clv: 'الذكاء الاصطناعي: قيمة العملاء', ai_customer_clv_desc: 'توقعات قيمة العميل مدى الحياة',
    ai_profit_analysis: 'الذكاء الاصطناعي: تحليل الأرباح', ai_profit_analysis_desc: 'اتجاهات الربح اليومية',
    items_at_risk: 'منتجات معرضة للنفاد', all_stock_healthy: 'جميع مستويات المخزون سليمة',
    days_left: 'أيام متبقية', stock_level: 'المخزون', reorder_point: 'نقطة إعادة الطلب',
    based_on_transactions: 'بناءً على {count} معاملة', peak_hours_staff: 'فكر في موظفين إضافيين خلال هذه الساعات',
    of_traffic: 'من حركة المرور', projected_revenue: 'الإيرادات المتوقعة لـ 12 شهر',
    lifetime_value: 'قيمة مدى الحياة', orders_active: 'طلبات', days_active: 'أيام نشاط',
    add_customers_clv: 'أضف عملاء لرؤية تحليلات CLV', avg_daily_profit: 'متوسط الربح اليومي',
    trend: 'الاتجاه', improving: 'تحسن', declining: 'تراجع', stable: 'مستقر',
    best_day: 'الأفضل', worst_day: 'الأسوأ', not_enough_data: 'بيانات غير كافية للتحليل',
    // Quick Actions
    quick_actions: 'إجراءات سريعة', qa_record_sale: 'تسجيل بيع', qa_add_expense: 'إضافة مصروف',
    qa_pay_supplier: 'دفع مورد', qa_new_invoice: 'فاتورة جديدة', qa_approve_leave: 'اعتماد إجازة',
    qa_pay_salary: 'دفع راتب', qa_add_customer: 'إضافة عميل', qa_view_reports: 'عرض التقارير',
    qa_stock_entry: 'إدخال مخزون', qa_cctv_live: 'كاميرات مباشر', qa_available: 'متاح',
    qa_no_actions: 'لا توجد إجراءات سريعة متاحة لدورك',
    // Menu Items
    menu_items: 'عناصر القائمة', nav_menu_items: 'عناصر القائمة',
    // Order Status
    order_status: 'حالة الطلب', preparing: 'قيد التحضير', ready_pickup: 'جاهز للاستلام',
    documents_title: 'المستندات', fines_title: 'الغرامات والعقوبات',
    company_loans_title: 'قروض الشركة', users_title: 'المستخدمون',
    branches_title: 'الفروع', schedule_title: 'جدول المناوبات',
    leave_title: 'الموافقة على الإجازات', cash_transfers_title: 'التحويلات النقدية',
    bank_statements_title: 'كشوفات البنك', reconciliation_title: 'التسوية البنكية',
    credit_report_title: 'تقرير الائتمان', supplier_report_title: 'تقرير الموردين',
    category_report_title: 'تقرير الفئات', kitchen_title: 'شاشة المطبخ',
    notifications_title: 'الإشعارات', help_title: 'المساعدة والدليل',
    portal_title: 'بوابة الموظف',
    // CCTV
    cctv_title: 'كاميرات المراقبة', cctv_subtitle: 'مراقبة فيديو وتحليلات بالذكاء الاصطناعي',
    live_view: 'العرض المباشر', face_recognition: 'التعرف على الوجوه', object_detection: 'كشف الأجسام',
    people_count: 'عدد الأشخاص', motion_analysis: 'تحليل الحركة', alerts: 'التنبيهات',
    devices: 'الأجهزة', register_face: 'تسجيل وجه', registered_faces: 'الوجوه المسجلة',
    face_attendance: 'حضور بالتعرف على الوجه', detect_objects: 'كشف الأجسام',
    count_people: 'عد الأشخاص', analyze_motion: 'تحليل الحركة',
    crowd_density: 'كثافة الحشد', motion_detected: 'تم كشف حركة', security_concern: 'تنبيه أمني',
    no_cameras: 'لا توجد كاميرات مهيأة', upload_image: 'رفع صورة', run_analysis: 'تشغيل التحليل',
    // Scheduled Monitoring
    scheduled_monitoring: 'المراقبة المجدولة بالذكاء الاصطناعي', monitoring_interval: 'فترة المراقبة',
    enable_monitoring: 'تفعيل المراقبة المجدولة', run_now: 'تشغيل الآن',
    notification_channels: 'قنوات الإشعار', in_app: 'داخل التطبيق', whatsapp: 'واتساب',
    // Partner P&L
    partner_pl_title: 'تقرير أرباح وخسائر الشركاء', partner_pl_subtitle: 'تفصيل الأرباح والخسائر حسب نسبة الملكية',
    company_summary: 'ملخص الشركة', partner_breakdown: 'تفصيل الشركاء',
    expense_categories: 'فئات المصروفات', payment_modes: 'طرق الدفع',
    revenue: 'الإيرادات', gross_profit: 'الربح الإجمالي', operating_expenses: 'مصروفات التشغيل',
    profit_share: 'حصة الأرباح', ownership_percentage: 'نسبة الملكية', investments: 'الاستثمارات',
    withdrawals: 'المسحوبات', current_balance: 'الرصيد الحالي', available_withdrawal: 'متاح للسحب',
    // ZATCA Phase 2
    zatca_phase2: 'زاتكا المرحلة الثانية', zatca_compliance: 'التوافق مع زاتكا',
    generate_xml: 'إنشاء فاتورة XML', submit_zatca: 'إرسال لزاتكا',
    xml_invoice: 'فاتورة XML', qr_code: 'رمز QR', invoice_uuid: 'معرف الفاتورة',
    digital_signature: 'التوقيع الرقمي', csid_required: 'مطلوب CSID',
    b2b_invoice: 'فاتورة ضريبية B2B', b2c_invoice: 'فاتورة ضريبية مبسطة',
    // Mobile Navigation
    customize_nav: 'تخصيص شريط التنقل السفلي', reset_default: 'إعادة التعيين',
    select_items: 'اختر حتى 5 عناصر', more: 'المزيد',
    // AI Hub
    ai_hub_title: 'مركز الذكاء الاصطناعي', ai_hub_subtitle: 'ذكاء أعمال وتحسين مدعوم بالذكاء الاصطناعي',
    ai_hub_load_error: 'فشل تحميل البيانات', ai_insights: 'رؤى الذكاء الاصطناعي',
    ai_supplier_intel: 'ذكاء الموردين', ai_pricing_opt: 'تحسين الأسعار',
    ai_churn: 'تراجع العملاء', ai_marketing: 'التسويق',
    ai_top_suppliers: 'أعلى الموردين حسب الإنفاق', ai_supplier_perf: 'أداء الموردين',
    ai_total_paid: 'إجمالي المدفوع', ai_avg_order: 'متوسط الطلب',
    ai_items_analyzed: 'العناصر المحللة', ai_avg_margin: 'متوسط الهامش',
    ai_price_increase: 'زيادة', ai_revenue_impact: 'تأثير الإيرادات 30 يوم',
    ai_pricing_recs: 'توصيات الأسعار', ai_item: 'العنصر',
    ai_current: 'الحالي', ai_cost: 'التكلفة', ai_margin: 'الهامش',
    ai_sold_90d: 'المبيع (90 يوم)', ai_suggested: 'المقترح', ai_action: 'الإجراء', ai_keep: 'إبقاء',
    ai_total_customers: 'إجمالي العملاء', ai_churned: 'مفقودون', ai_high_risk: 'مخاطر عالية',
    ai_at_risk_revenue: 'إيرادات معرضة للخطر', ai_risk_distribution: 'توزيع المخاطر',
    ai_customer_risk: 'تحليل مخاطر العملاء', ai_total_spent: 'إجمالي الإنفاق',
    ai_transactions: 'المعاملات', ai_days_inactive: 'أيام الخمول', ai_risk_level: 'المخاطر',
    ai_revenue_90d: 'الإيرادات (90 يوم)', ai_vip_customers: 'عملاء VIP', ai_avg_value: 'متوسط قيمة العميل',
    ai_best_day: 'أفضل يوم', ai_worst_day: 'أسوأ يوم', ai_top_products: 'أفضل المنتجات (90 يوم)',
    ai_campaign_suggestions: 'اقتراحات الحملات', ai_target: 'الهدف', ai_channel: 'القناة', ai_audience: 'الجمهور',
    active: 'نشط', inactive: 'غير نشط',
    inv_forecast_title: 'توقعات المخزون بالذكاء الاصطناعي', inv_forecast_subtitle: 'تنبؤ الطلب واقتراحات إعادة الطلب',
    inv_avg_daily: 'متوسط المبيعات اليومية', inv_items_tracked: 'العناصر المتتبعة', inv_need_reorder: 'تحتاج إعادة طلب',
    cross_branch_title: 'التقرير المالي متعدد الفروع', cross_branch_subtitle: 'مقارنة الفروع عبر البلدان',
    nav_ai_hub: 'مركز الذكاء الاصطناعي', nav_ai_forecast: 'توقعات AI', nav_cross_branch: 'تقرير الفروع',
    nav_anomaly_detection: 'كشف الشذوذ',
    // Page titles
    attendance_title: 'لوحة الحضور', payroll_title: 'إدارة الرواتب',
    performance_title: 'الأداء والتقييمات', performance_subtitle: 'تتبع التقييمات والأهداف والإجراءات التأديبية',
    training_title: 'إدارة التدريب', recruitment_title: 'التوظيف',
    recruitment_subtitle: 'إعلانات الوظائف وتتبع المتقدمين وإدارة المقابلات',
    leave_cal_title: 'إدارة الإجازات', leave_cal_subtitle: 'عرض تقويمي لجميع الإجازات مع تتبع الرصيد',
    emp_docs_title: 'مستندات الموظفين', hr_analytics_title: 'تحليلات الموارد البشرية',
    balance_sheet_title: 'الميزانية العمومية', pnl_title: 'بيان الأرباح والخسائر',
    journal_title: 'القيود اليومية', journal_subtitle: 'إدخالات مدين ودائن يدوية',
    coa_title: 'دليل الحسابات', coa_subtitle: 'إدارة هيكل المحاسبة',
    bills_title: 'الفواتير', bills_subtitle: 'إدارة فواتير الموردين والمدفوعات',
    daily_summary_title: 'الملخص اليومي', cashier_pos_title: 'نقطة البيع',
    stock_reorder_title: 'تحليل المخزون بالذكاء الاصطناعي', sales_forecast_title: 'تحليل المبيعات بالذكاء الاصطناعي',
    sales_alerts_title: 'تنبيهات المبيعات', activity_logs_title: 'سجل الأنشطة',
    activity_logs_subtitle: 'تتبع إجراءات المستخدم وأحداث النظام',
    audit_trail_title: 'سجل المراجعة', currency_settings_title: 'إعدادات العملة',
    role_mgmt_title: 'الأدوار والصلاحيات', country_laws_title: 'قوانين العمل',
    loan_mgmt_title: 'إدارة القروض', loan_mgmt_subtitle: 'تتبع وإدارة قروض الموظفين والأقساط',
    staff_perf_title: 'أداء الموظفين', staff_perf_subtitle: 'تتبع الموثوقية والحضور وتعيين المهام',
    anomaly_title: 'كشف الشذوذ', anomaly_subtitle: 'فحص ذكي للمبيعات والمصروفات',
    pos_config_title: 'إعدادات نقطة البيع', data_mgmt_title: 'إدارة البيانات',
    data_export_title: 'تصدير البيانات', scheduled_reports_title: 'التقارير المجدولة',
    menu_analytics_title: 'تحليلات القائمة', bi_dashboard_title: 'لوحة BI',
    financial_dashboard_title: 'لوحة المالية',
    financial_ratios_title: 'لوحة الصحة المالية',
    // Common
    total_employees: 'إجمالي الموظفين', active_employees: 'الموظفون النشطون',
    total_documents: 'إجمالي المستندات', total_headcount: 'إجمالي عدد الموظفين',
    as_of_date: 'حتى تاريخ', today: 'اليوم', yesterday: 'أمس',
    this_week: 'هذا الأسبوع', this_month: 'هذا الشهر', last_month: 'الشهر الماضي',
    custom_range: 'نطاق مخصص', from_date: 'من', to_date: 'إلى',
    total_amount: 'المبلغ الإجمالي', grand_total: 'المجموع الكلي',
    subtotal: 'المجموع الفرعي', discount: 'خصم', tax: 'ضريبة القيمة المضافة',
    excl_vat: 'غير شامل الضريبة', vat_amount: 'مبلغ الضريبة', incl_vat: 'شامل الضريبة',
    quantity: 'الكمية', unit_price: 'سعر الوحدة', total: 'الإجمالي',
    paid: 'مدفوع', unpaid: 'غير مدفوع', overdue: 'متأخر', partial: 'جزئي',
    approved: 'موافق', rejected: 'مرفوض',
    planned: 'مخطط', debit: 'مدين', credit: 'دائن', balance: 'الرصيد',
    revenue: 'الإيرادات', expenses: 'المصروفات', profit: 'الربح', loss: 'الخسارة',
    open: 'مفتوح', closed: 'مغلق', draft: 'مسودة',
    monthly: 'شهري', weekly: 'أسبوعي', daily: 'يومي', yearly: 'سنوي',
    no_results: 'لا توجد نتائج', showing: 'عرض', of: 'من', entries: 'سجلات',
    select_branch: 'اختر الفرع', select_date: 'اختر التاريخ',
    select_category: 'اختر الفئة', select_status: 'اختر الحالة',
    created_at: 'تاريخ الإنشاء', updated_at: 'تاريخ التحديث', created_by: 'أنشئ بواسطة',
    details: 'التفاصيل', summary: 'الملخص', history: 'السجل',
    confirm_delete: 'هل أنت متأكد من حذف هذا؟',
    success_saved: 'تم الحفظ بنجاح', success_deleted: 'تم الحذف بنجاح',
    success_updated: 'تم التحديث بنجاح', success_created: 'تم الإنشاء بنجاح',
    nav_rate_limits: 'حدود API',
    rate_limit_title: 'حدود معدل API', rate_limit_subtitle: 'مراقبة وتكوين حدود الاستخدام',
    rate_limit_your_status: 'حالة حد المعدل الخاص بك', rate_limit_plan: 'الخطة',
    rate_limit_role: 'الدور', rate_limit_your_limit: 'حدك', rate_limit_current_usage: 'الاستخدام الحالي',
    rate_limit_tiers: 'مستويات حدود المعدل', rate_limit_override: 'تجاوز مخصص',
    rate_limit_top_users: 'أكبر المستخدمين', rate_limit_user_breakdown: 'تفاصيل المستخدمين',
  },
  ur: {
    nav_operations: 'آپریشنز', nav_finance: 'مالیات', nav_people: 'لوگ',
    nav_stock: 'اسٹاک', nav_reports: 'رپورٹس', nav_assets: 'اثاثے', nav_admin: 'ایڈمن',
    nav_dashboard: 'ڈیش بورڈ', nav_quick_entry: 'فوری اندراج', nav_live_analytics: 'لائیو تجزیات',
    nav_sales: 'فروخت', nav_invoices: 'انوائسز', nav_expenses: 'اخراجات',
    nav_supplier_payments: 'سپلائر ادائیگیاں', nav_cash_transfers: 'نقد منتقلی',
    nav_customers: 'گاہک', nav_suppliers: 'سپلائرز', nav_employees: 'ملازمین',
    nav_leave_approvals: 'چھٹی کی منظوری', nav_schedule: 'شیڈول',
    nav_inventory: 'انوینٹری', nav_transfers: 'منتقلی', nav_kitchen: 'کچن',
    nav_analytics: 'تجزیات', nav_visualizations: 'گراف', nav_reports_page: 'رپورٹس',
    nav_credit_report: 'کریڈٹ رپورٹ', nav_supplier_report: 'سپلائر رپورٹ',
    nav_category_report: 'کیٹگری رپورٹ', nav_bank_statements: 'بینک سٹیٹمنٹس',
    nav_reconciliation: 'ریکنسلیشن', nav_branches: 'برانچز', nav_documents: 'دستاویزات',
    nav_fines: 'جرمانے', nav_partners: 'پارٹنرز', nav_company_loans: 'کمپنی قرضے',
    nav_users: 'صارفین', nav_settings: 'ترتیبات', nav_help: 'مدد',
    nav_sales_revenue: 'فروخت اور آمدنی', nav_expenses_payables: 'اخراجات اور ادائیگیاں',
    nav_hr_workforce: 'ایچ آر اور عملہ', nav_pos_inventory: 'پی او ایس اور انوینٹری',
    nav_accounting: 'اکاؤنٹنگ',
    help_sales: 'روزانہ فروخت ریکارڈ کریں، نقد/کارڈ/ادھار ادائیگیوں کا سراغ لگائیں',
    help_expenses: 'زمرے، سپلائر اور ادائیگی کے طریقے کے مطابق اخراجات ٹریک کریں',
    help_hr: 'ملازمین، تنخواہ، چھٹی، حاضری اور دستاویزات کا انتظام کریں',
    help_pos: 'اپنے کاروبار کی قسم کے مطابق POS ترتیب دیں',
    help_accounting: 'جرنل اندراجات، بیلنس شیٹ اور آمدنی کا بیان',
    help_reports: 'ایڈوانس تجزیات، پیشگوئیاں اور حسب ضرورت رپورٹس',
    dash_title: 'ڈیش بورڈ', dash_subtitle: 'کاروباری جائزہ',
    total_sales: 'کل فروخت', total_expenses: 'کل اخراجات',
    supplier_payments: 'سپلائر ادائیگیاں', net_profit: 'خالص منافع',
    pending_credits: 'واجب الادا', today_vs_yesterday: 'کل کے مقابلے',
    recent_sales: 'حالیہ فروخت', expense_breakdown: 'اخراجات کی تفصیل',
    quick_actions: 'فوری اقدامات', new_sale: 'نئی فروخت', new_expense: 'نیا خرچ',
    view_reports: 'رپورٹس دیکھیں', cash_balance: 'نقد بیلنس', bank_balance: 'بینک بیلنس',
    customize_widgets: 'سیکشن کسٹمائز', reset_layout: 'ترتیب ری سیٹ',
    // Reconciliation Wizard
    wiz_title: 'مفاہمت 3 مراحل میں',
    wiz_subtitle: 'خام بینک سٹیٹمنٹس کو خودکار میچنگ، آڈٹ ٹریل اور AI سے بیان کردہ فرانزک کہانیوں میں تبدیل کریں۔',
    wiz_step: 'مرحلہ', wiz_done: 'مکمل',
    wiz_upload_title: 'سٹیٹمنٹ اپ لوڈ کریں',
    wiz_upload_desc: 'اسمارٹ میچ انجن چلانے کے لیے CSV / XLSX بینک سٹیٹمنٹ ڈالیں۔',
    wiz_upload_cta: 'اپ لوڈ',
    wiz_review_title: 'خودکار میچز کا جائزہ لیں',
    wiz_review_desc: 'انجن کی تجاویز کی تصدیق یا انکار کریں — ہر عمل آڈٹ لاگ میں ریکارڈ ہوتا ہے۔',
    wiz_review_cta: 'جائزہ',
    wiz_narrate_title: 'آڈٹ کہانی بنائیں',
    wiz_narrate_desc: '"اس میچ کو کہانی کے طور پر چلائیں" پر کلک کریں تاکہ AI سے بیان کردہ فرانزک خلاصہ حاصل ہو۔',
    wiz_narrate_cta: 'لاگ کھولیں',
    add_widget: 'سیکشن شامل کریں', remove_widget: 'ہٹائیں',
    sales_title: 'فروخت کا انتظام', sales_subtitle: 'فروخت کی تمام لین دین کو ٹریک کریں',
    add_new_sale: 'نئی فروخت شامل کریں', sale_date: 'تاریخ', sale_amount: 'رقم',
    payment_details: 'ادائیگی کی تفصیلات', payment_mode: 'ادائیگی کا طریقہ',
    customer_name: 'گاہک کا نام', sale_items: 'آئٹمز', sale_notes: 'نوٹس',
    credit_amount: 'اُدھار', all_sales: 'تمام فروخت',
    expenses_title: 'اخراجات', expenses_subtitle: 'کاروباری اخراجات کو ٹریک کریں',
    add_expense: 'خرچ شامل کریں', expense_date: 'تاریخ', expense_amount: 'رقم',
    expense_category: 'کیٹگری', expense_description: 'تفصیل',
    all_expenses: 'تمام اخراجات', total_label: 'کل',
    employees_title: 'ملازمین', employees_subtitle: 'اپنی ٹیم کا انتظام',
    add_employee: 'ملازم شامل کریں', employee_name: 'نام', employee_phone: 'فون',
    employee_email: 'ای میل', employee_role: 'عہدہ', employee_salary: 'تنخواہ',
    employee_branch: 'برانچ', employee_status: 'حیثیت', job_titles: 'عہدے',
    active: 'فعال', inactive: 'غیر فعال',
    stock_title: 'اسٹاک مینجمنٹ', stock_subtitle: 'انوینٹری ٹریکنگ اور کنٹرول',
    add_item: 'آئٹم شامل کریں', item_name: 'آئٹم کا نام', item_category: 'کیٹگری',
    item_unit: 'یونٹ', unit_price: 'فروخت قیمت', cost_price: 'لاگت قیمت',
    min_stock: 'کم از کم', current_stock: 'موجودہ اسٹاک', stock_in: 'اسٹاک ان',
    stock_out: 'اسٹاک آؤٹ', stock_value: 'اسٹاک کی قیمت',
    invoices_title: 'انوائسز', invoices_subtitle: 'زاتکا مطابق انوائسز',
    create_invoice: 'انوائس بنائیں', invoice_number: 'نمبر', invoice_date: 'تاریخ',
    invoice_customer: 'گاہک', invoice_items: 'آئٹمز', invoice_total: 'کل',
    invoice_status: 'حیثیت', invoice_paid: 'ادا شدہ', invoice_unpaid: 'بقایا',
    scan_invoice: 'انوائس سکین',
    customers_title: 'گاہک', customers_subtitle: 'گاہکوں کا ڈیٹا بیس',
    add_customer: 'گاہک شامل کریں', customer_phone: 'فون', customer_balance: 'بیلنس',
    total_customers: 'کل گاہک', total_credit: 'کل اُدھار',
    suppliers_title: 'سپلائرز', suppliers_subtitle: 'سپلائر مینجمنٹ',
    add_supplier: 'سپلائر شامل کریں', supplier_name: 'سپلائر نام', supplier_phone: 'فون',
    supplier_balance: 'بیلنس', total_suppliers: 'کل سپلائرز',
    pos_title: 'فوری اندراج', pos_customer: 'گاہک', pos_item: 'آئٹم',
    pos_quantity: 'مقدار', pos_price: 'قیمت', pos_discount: 'ڈسکاؤنٹ',
    pos_total: 'کل', pos_add_item: 'آئٹم شامل کریں', pos_submit: 'فروخت درج کریں',
    pos_clear: 'صاف کریں', pos_payment_mode: 'ادائیگی کا طریقہ',
    pos_cash: 'نقد', pos_bank: 'بینک', pos_online: 'آن لائن', pos_credit: 'اُدھار',
    settings_title: 'ترتیبات', settings_subtitle: 'ایپلیکیشن ترتیبات',
    email_config: 'ای میل ترتیب', whatsapp_config: 'واٹس ایپ ترتیب',
    company_branding: 'کمپنی برانڈنگ', scheduler_config: 'شیڈولڈ رپورٹس',
    data_management: 'ڈیٹا مینجمنٹ', notification_settings: 'نوٹیفکیشن ترتیبات',
    partners_title: 'پارٹنرز', partners_subtitle: 'سرمایہ کاری اور منافع',
    add_partner: 'پارٹنر شامل کریں', partner_name: 'نام',
    share_percentage: 'حصص %', total_invested: 'کل سرمایہ کاری',
    total_withdrawn: 'کل واپسی', partner_balance: 'بیلنس',
    reports_title: 'رپورٹس', eod_summary: 'دن کا خلاصہ', partner_pnl: 'پارٹنر نفع نقصان',
    daily_summary: 'روزانہ خلاصہ', top_customers: 'اعلی گاہک',
    cashier_performance: 'کیشیئر کارکردگی', generate: 'بنائیں', print_report: 'پرنٹ رپورٹ',
    analytics_title: 'تجزیات', analytics_subtitle: 'AI سے چلنے والی بصیرت',
    predictive_hub: 'پیشن گوئی تجزیات',
    expense_forecast: 'اخراجات کی پیشن گوئی', stock_reorder: 'اسٹاک ری آرڈر',
    revenue_trends: 'آمدنی کے رجحانات', customer_churn: 'گاہک کا خطرہ',
    margin_optimizer: 'مارجن آپٹمائزر', sales_forecast: 'فروخت کی پیشن گوئی',
    viz_title: 'گراف', viz_subtitle: 'جدید چارٹس اور ڈیٹا',
    viz_heatmap: 'ہیٹ میپ', viz_funnel: 'فنل', viz_treemap: 'ٹری میپ',
    viz_gauges: 'گیجز', viz_radar: 'ریڈار', viz_waterfall: 'واٹرفال',
    viz_money_flow: 'رقم کا بہاؤ', viz_compare: 'موازنہ',
    viz_export_png: 'تصویر ایکسپورٹ', viz_click_drill: 'تفصیل کے لیے کلک کریں',
    loading: 'لوڈ ہو رہا ہے...', save: 'محفوظ', cancel: 'منسوخ', delete: 'حذف',
    edit: 'ترمیم', add: 'شامل کریں', search: 'تلاش', filter: 'فلٹر',
    export_btn: 'ایکسپورٹ', print: 'پرنٹ', refresh: 'تازہ کریں', close: 'بند',
    confirm: 'تصدیق', actions: 'اقدامات', status: 'حیثیت', date: 'تاریخ',
    amount: 'رقم', description: 'تفصیل', category: 'کیٹگری',
    branch: 'برانچ', all_branches: 'تمام برانچز', no_data: 'کوئی ڈیٹا نہیں',
    name: 'نام', phone: 'فون', email: 'ای میل', address: 'پتہ',
    submit: 'جمع کریں', update: 'اپ ڈیٹ', view: 'دیکھیں', download: 'ڈاؤن لوڈ',
    dark: 'ڈارک', light: 'لائٹ', shortcuts: 'شارٹ کٹس', logout: 'لاگ آؤٹ',
    language: 'زبان',
    stock_alert_title: 'آئٹم(ز) کم از کم سے نیچے',
    stock_alert_view: 'تفصیلات', stock_alert_hide: 'چھپائیں',
    go_to_inventory: 'انوینٹری پر جائیں',
    transactions: 'لین دین', items: 'آئٹمز', payments: 'ادائیگیاں',
    overview: 'جائزہ', period: 'مدت', compare: 'موازنہ', trends: 'رجحانات',
    item_pnl: 'آئٹم منافع',
    // Common UI
    loading: 'لوڈ ہو رہا ہے...', no_data: 'کوئی ڈیٹا نہیں', error_occurred: 'خرابی ہوئی',
    try_again: 'دوبارہ کوشش کریں', confirm: 'تصدیق', cancel: 'منسوخ', save: 'محفوظ کریں', delete: 'حذف کریں',
    edit: 'ترمیم', view: 'دیکھیں', add: 'شامل کریں', back: 'واپس', next: 'اگلا', previous: 'پچھلا',
    search: 'تلاش', filter: 'فلٹر', sort: 'ترتیب', export: 'برآمد', import: 'درآمد',
    refresh: 'تازہ کریں', reset: 'ری سیٹ', apply: 'لاگو کریں', clear: 'صاف کریں',
    // Status messages
    success: 'کامیابی', failed: 'ناکام', pending: 'زیر التواء', completed: 'مکمل',
    in_progress: 'جاری', cancelled: 'منسوخ',
    // Shift Report
    shift_report_title: 'روزانہ شفٹ رپورٹ', shift_report_subtitle: 'کیشیئر شفٹس، فروخت کی تفصیل اور نقد تصفیہ',
    daily_report: 'روزانہ رپورٹ', date_range: 'تاریخ کی حد', total_shifts: 'کل شفٹس',
    opening_cash: 'ابتدائی نقد', closing_cash: 'اختتامی نقد', expected_cash: 'متوقع نقد',
    cash_difference: 'نقد فرق', shortage: 'کمی', overage: 'زیادتی', balanced: 'متوازن',
    payment_breakdown: 'ادائیگی کے طریقوں کی تفصیل', sales_by_branch: 'برانچ کے مطابق فروخت',
    shift_details: 'شفٹ کی تفصیلات', top_selling_items: 'سب سے زیادہ فروخت ہونے والی اشیاء',
    daily_trend: 'روزانہ فروخت کا رجحان', daily_breakdown: 'روزانہ تفصیل',
    avg_sales_day: 'اوسط فروخت/دن', duration: 'دورانیہ', cashier: 'کیشیئر',
    // Bulk Salary
    bulk_salary_title: 'بلک تنخواہ ادائیگی', bulk_payment_info: 'تمام اہل ملازمین کو ایک ساتھ تنخواہ ادا کریں۔ یہ خود بخود تنخواہ اور اخراجات کے ریکارڈ بنائے گا۔',
    preview_select: 'پیش نظارہ اور ملازمین منتخب کریں', to_pay: 'ادا کرنا', already_paid: 'پہلے ادا',
    total_amount: 'کل رقم', employees_to_pay: 'ادائیگی کے لیے ملازمین', select_all: 'سب منتخب کریں',
    pay_employees: 'ملازمین کو ادا کریں', payment_completed: 'ادائیگی مکمل', by_branch: 'برانچ کے مطابق',
    skipped_failed: 'چھوڑا / ناکام', monthly_salary_payment: 'ماہانہ تنخواہ کی ادائیگی',
    // Expense Categories
    cat_salary: 'تنخواہ', cat_rent: 'کرایہ', cat_utilities: 'یوٹیلیٹیز', cat_vehicle: 'گاڑی',
    cat_maintenance: 'دیکھ بھال', cat_supplier: 'سپلائر', cat_tickets: 'ٹکٹ',
    cat_id_card: 'شناختی کارڈ', cat_other: 'دیگر',
    cat_basic_salary: 'بنیادی تنخواہ', cat_overtime: 'اوور ٹائم', cat_bonus: 'بونس',
    cat_office_rent: 'دفتر کرایہ', cat_warehouse_rent: 'گودام کرایہ', cat_shop_rent: 'دکان کرایہ',
    cat_electricity: 'بجلی', cat_water: 'پانی', cat_internet: 'انٹرنیٹ', cat_phone: 'فون',
    cat_fuel: 'ایندھن', cat_insurance: 'انشورنس', cat_office_maintenance: 'دفتر کی دیکھ بھال',
    cat_equipment_repair: 'سامان کی مرمت',
    // Widget names
    widget_stats: 'اہم اعداد و شمار', widget_charts: 'فوری چارٹس', widget_cash_bank: 'نقد اور بینک',
    widget_payment_mode: 'ادائیگی کے طریقے', widget_spending: 'خرچ کی تفصیلات',
    widget_dues: 'واجبات اور الرٹس', widget_branch_dues: 'برانچ واجبات', widget_vat: 'ٹیکس کا خلاصہ',
    widget_desc_stats: 'فروخت، اخراجات، منافع کا جائزہ', widget_desc_charts: 'اخراجات کی تقسیم اور موازنہ',
    widget_desc_cash: 'نقد اور بینک بیلنس', widget_desc_payment: 'نقد، بینک، کریڈٹ کی تفصیل',
    widget_desc_spending: 'اخراجات کی اقسام اور خرچ', widget_desc_dues: 'سپلائر واجبات، جرمانے، الرٹس',
    widget_desc_branch: 'برانچوں کے درمیان بیلنس', widget_desc_vat: 'ٹیکس کے حسابات',
    show_all: 'سب دکھائیں', minimize: 'کم کریں', done: 'ہو گیا',
    // AI Widget translations
    ai_low_stock: 'AI: سٹاک الرٹس', ai_low_stock_desc: 'ختم ہونے والی اشیاء',
    ai_peak_hours: 'AI: مصروف اوقات', ai_peak_hours_desc: 'عملے کی منصوبہ بندی',
    ai_customer_clv: 'AI: گاہک کی قدر', ai_customer_clv_desc: 'گاہک کی عمر بھر کی قیمت',
    ai_profit_analysis: 'AI: منافع تجزیہ', ai_profit_analysis_desc: 'روزانہ منافع کے رجحانات',
    items_at_risk: 'خطرے میں اشیاء', all_stock_healthy: 'تمام سٹاک ٹھیک',
    days_left: 'دن باقی', stock_level: 'سٹاک', reorder_point: 'ری آرڈر',
    based_on_transactions: '{count} ٹرانزیکشنز کی بنیاد پر', peak_hours_staff: 'ان اوقات میں اضافی عملہ رکھیں',
    of_traffic: 'ٹریفک', projected_revenue: '12 ماہ کی متوقع آمدنی',
    lifetime_value: 'عمر بھر کی قیمت', orders_active: 'آرڈرز', days_active: 'دن فعال',
    add_customers_clv: 'CLV دیکھنے کے لیے گاہک شامل کریں', avg_daily_profit: 'اوسط روزانہ منافع',
    trend: 'رجحان', improving: 'بہتری', declining: 'کمی', stable: 'مستحکم',
    best_day: 'بہترین', worst_day: 'بدترین', not_enough_data: 'تجزیے کے لیے کافی ڈیٹا نہیں',
    // Quick Actions
    quick_actions: 'فوری اقدامات', qa_record_sale: 'فروخت درج کریں', qa_add_expense: 'خرچ شامل کریں',
    qa_pay_supplier: 'سپلائر ادائیگی', qa_new_invoice: 'نئی انوائس', qa_approve_leave: 'چھٹی منظور کریں',
    qa_pay_salary: 'تنخواہ ادا کریں', qa_add_customer: 'گاہک شامل کریں', qa_view_reports: 'رپورٹس دیکھیں',
    qa_stock_entry: 'سٹاک انٹری', qa_cctv_live: 'لائیو کیمرے', qa_available: 'دستیاب',
    qa_no_actions: 'آپ کے کردار کے لیے کوئی فوری اقدام دستیاب نہیں',
    // Menu Items
    menu_items: 'مینو آئٹمز', nav_menu_items: 'مینو آئٹمز',
    // Order Status
    order_status: 'آرڈر کی حیثیت', preparing: 'تیاری میں', ready_pickup: 'وصولی کے لیے تیار',
    documents_title: 'دستاویزات', fines_title: 'جرمانے',
    company_loans_title: 'کمپنی قرضے', users_title: 'صارفین', branches_title: 'برانچز',
    schedule_title: 'شفٹ شیڈول', leave_title: 'چھٹی منظوری',
    cash_transfers_title: 'نقد منتقلی', bank_statements_title: 'بینک سٹیٹمنٹس',
    reconciliation_title: 'ریکنسلیشن', credit_report_title: 'کریڈٹ رپورٹ',
    supplier_report_title: 'سپلائر رپورٹ', category_report_title: 'کیٹگری رپورٹ',
    kitchen_title: 'کچن ڈسپلے', notifications_title: 'نوٹیفکیشنز',
    help_title: 'مدد', portal_title: 'ملازم پورٹل',
    // CCTV
    cctv_title: 'CCTV سیکیورٹی', cctv_subtitle: 'AI کے ساتھ ویڈیو نگرانی',
    live_view: 'لائیو ویو', face_recognition: 'چہرے کی شناخت', object_detection: 'آبجیکٹ ڈٹیکشن',
    people_count: 'لوگوں کی گنتی', motion_analysis: 'حرکت کا تجزیہ', alerts: 'الرٹس',
    devices: 'ڈیوائسز', register_face: 'چہرہ رجسٹر کریں', registered_faces: 'رجسٹرڈ چہرے',
    // Scheduled Monitoring
    scheduled_monitoring: 'شیڈولڈ AI مانیٹرنگ', monitoring_interval: 'مانیٹرنگ وقفہ',
    enable_monitoring: 'شیڈولڈ مانیٹرنگ فعال کریں', run_now: 'ابھی چلائیں',
    notification_channels: 'نوٹیفکیشن چینلز', in_app: 'ایپ میں', whatsapp: 'واٹس ایپ',
    // Partner P&L
    partner_pl_title: 'پارٹنر P&L رپورٹ', partner_pl_subtitle: 'ملکیت کے حساب سے نفع نقصان',
    company_summary: 'کمپنی کا خلاصہ', partner_breakdown: 'پارٹنر تفصیل',
    expense_categories: 'اخراجات کی اقسام', payment_modes: 'ادائیگی کے طریقے',
    revenue: 'آمدنی', gross_profit: 'مجموعی منافع', operating_expenses: 'آپریٹنگ اخراجات',
    profit_share: 'منافع کا حصہ', ownership_percentage: 'ملکیت %', investments: 'سرمایہ کاری',
    withdrawals: 'نکالی گئی رقم', current_balance: 'موجودہ بیلنس', available_withdrawal: 'نکالنے کے لیے دستیاب',
    // ZATCA Phase 2
    zatca_phase2: 'زاتکا فیز 2', zatca_compliance: 'زاتکا مطابقت',
    generate_xml: 'XML انوائس بنائیں', submit_zatca: 'زاتکا کو بھیجیں',
    // Mobile Navigation
    customize_nav: 'نیچے نیویگیشن کسٹمائز کریں', reset_default: 'ڈیفالٹ پر ری سیٹ',
    select_items: '5 آئٹمز تک منتخب کریں', more: 'مزید',
    // AI Hub
    ai_hub_title: 'AI بزنس ہب', ai_hub_subtitle: 'AI سے چلنے والی کاروباری ذہانت',
    ai_supplier_intel: 'سپلائر انٹیلیجنس', ai_pricing_opt: 'قیمتوں کی اصلاح',
    ai_churn: 'گاہک کا نقصان', ai_marketing: 'مارکیٹنگ',
    ai_insights: 'AI بصیرت', ai_hub_load_error: 'ڈیٹا لوڈ کرنے میں ناکامی',
    ai_total_customers: 'کل گاہک', ai_churned: 'کھوئے ہوئے', ai_high_risk: 'زیادہ خطرہ',
    ai_campaign_suggestions: 'مہم کی تجاویز', ai_best_day: 'بہترین دن', ai_worst_day: 'بدترین دن',
    active: 'فعال', inactive: 'غیر فعال',
    inv_forecast_title: 'AI انوینٹری پیشگوئی', cross_branch_title: 'ملٹی برانچ مالیاتی رپورٹ',
    nav_ai_hub: 'AI ہب', nav_ai_forecast: 'AI پیشگوئی', nav_cross_branch: 'کراس برانچ رپورٹ',
    // Page titles
    attendance_title: 'حاضری ڈیش بورڈ', payroll_title: 'تنخواہ کا انتظام',
    performance_title: 'کارکردگی اور جائزے', training_title: 'تربیت کا انتظام',
    recruitment_title: 'بھرتی', leave_cal_title: 'چھٹی کا انتظام',
    emp_docs_title: 'ملازمین کی دستاویزات', hr_analytics_title: 'HR تجزیات',
    balance_sheet_title: 'بیلنس شیٹ', pnl_title: 'آمدنی اور اخراجات',
    journal_title: 'جرنل اندراجات', coa_title: 'اکاؤنٹس کا چارٹ',
    bills_title: 'بل', daily_summary_title: 'روزانہ خلاصہ',
    cashier_pos_title: 'ریستوراں POS', stock_reorder_title: 'AI اسٹاک تجزیہ',
    sales_forecast_title: 'AI سیلز تجزیہ', activity_logs_title: 'سرگرمی لاگ',
    audit_trail_title: 'آڈٹ ٹریل', currency_settings_title: 'کرنسی سیٹنگز',
    role_mgmt_title: 'کردار اور اجازتیں', country_laws_title: 'ملکی لیبر قوانین',
    loan_mgmt_title: 'قرض کا انتظام', staff_perf_title: 'عملے کی کارکردگی',
    anomaly_title: 'غیر معمولی کا پتہ لگانا', pos_config_title: 'POS ترتیب',
    data_mgmt_title: 'ڈیٹا مینجمنٹ', data_export_title: 'ڈیٹا برآمد',
    // Common
    total_employees: 'کل ملازمین', today: 'آج', yesterday: 'کل',
    this_month: 'اس مہینے', paid: 'ادا شدہ', unpaid: 'غیر ادا شدہ',
    approved: 'منظور', rejected: 'مسترد', debit: 'ڈیبٹ', credit: 'کریڈٹ',
    balance: 'بیلنس', revenue: 'آمدنی', profit: 'منافع', loss: 'نقصان',
    monthly: 'ماہانہ', weekly: 'ہفتہ وار', daily: 'روزانہ',
    no_results: 'کوئی نتائج نہیں', select_branch: 'برانچ منتخب کریں',
    details: 'تفصیلات', summary: 'خلاصہ', history: 'تاریخ',
    confirm_delete: 'کیا آپ واقعی حذف کرنا چاہتے ہیں؟',
    success_saved: 'کامیابی سے محفوظ', success_deleted: 'کامیابی سے حذف',
    // Accounting & Reports
    active_employees: 'فعال ملازمین', activity_logs_subtitle: 'صارف کے اقدامات اور سسٹم ایونٹس کو ٹریک کریں',
    aging_title: 'عمر رسیدگی رپورٹس', ai_action: 'عمل', ai_at_risk_revenue: 'خطرے میں آمدنی',
    ai_audience: 'سامعین', ai_avg_margin: 'اوسط مارجن', ai_avg_order: 'اوسط آرڈر',
    ai_avg_value: 'اوسط گاہک قیمت', ai_best_day: 'بہترین دن', ai_campaign_suggestions: 'مہم تجاویز',
    ai_channel: 'چینل', ai_churned: 'چھوڑے ہوئے', ai_cost: 'لاگت', ai_current: 'موجودہ',
    ai_customer_risk: 'گاہک رسک تجزیہ', ai_days_inactive: 'غیرفعال دن', ai_high_risk: 'زیادہ خطرہ',
    ai_hub_load_error: 'ڈیٹا لوڈ نہیں ہوا', ai_hub_subtitle: 'AI کاروباری ذہانت اور اصلاح',
    ai_item: 'آئٹم', ai_items_analyzed: 'تجزیہ شدہ آئٹمز', ai_keep: 'رکھیں', ai_margin: 'مارجن',
    ai_price_increase: 'اضافہ', ai_pricing_recs: 'قیمت تجاویز', ai_revenue_90d: '90 دن آمدنی',
    ai_revenue_impact: '30 دن آمدنی اثر', ai_risk_distribution: 'خطرے کی تقسیم', ai_risk_level: 'خطرہ',
    ai_sold_90d: '90 دن فروخت', ai_suggested: 'تجویز کردہ', ai_supplier_perf: 'سپلائر کارکردگی',
    ai_target: 'ہدف', ai_top_products: 'اعلی مصنوعات (90 دن)', ai_top_suppliers: 'اعلی سپلائرز',
    ai_total_customers: 'کل گاہک', ai_total_paid: 'کل ادا شدہ', ai_total_spent: 'کل خرچ',
    ai_transactions: 'لین دین', ai_vip_customers: 'VIP گاہک', ai_worst_day: 'بدترین دن',
    analyze_motion: 'حرکت تجزیہ', anomaly_subtitle: 'AI فروخت اور اخراجات کا جائزہ', anomaly_title: 'بے ضابطگی کا پتہ',
    as_of_date: 'تاریخ تک', audit_trail_title: 'آڈٹ ٹریل',
    b2b_invoice: 'B2B ٹیکس انوائس', b2c_invoice: 'آسان ٹیکس انوائس',
    bi_dashboard_title: 'BI ڈیش بورڈ', bills_subtitle: 'سپلائر بل اور ادائیگیاں',
    cash_flow_title: 'نقد بہاؤ بیان', closed: 'بند', coa_subtitle: 'اکاؤنٹنگ ڈھانچہ منظم کریں',
    count_people: 'لوگوں کی گنتی', country_laws_title: 'ملکی مزدوری قوانین',
    created_at: 'بنایا گیا', created_by: 'بنانے والا',
    cross_branch_breakdown: 'شاخ بہ شاخ تفصیل', cross_branch_comparison: 'شاخ موازنہ',
    cross_branch_converted_profit: 'تبدیل شدہ منافع', cross_branch_converted_sales: 'تبدیل شدہ فروخت',
    cross_branch_local_expenses: 'مقامی اخراجات', cross_branch_local_sales: 'مقامی فروخت',
    cross_branch_rate: 'شرح', cross_branch_revenue_share: 'شاخ کے لحاظ سے آمدنی حصہ',
    cross_branch_subtitle: 'کراس ملک شاخ موازنہ', cross_branch_title: 'ملٹی برانچ مالی رپورٹ',
    crowd_density: 'ہجوم کثافت', csid_required: 'CSID ضروری',
    custom_range: 'اپنی مرضی', data_export_title: 'ڈیٹا ایکسپورٹ', data_mgmt_title: 'ڈیٹا انتظام',
    detect_objects: 'اشیاء کا پتہ', digital_signature: 'ڈیجیٹل دستخط', discount: 'رعایت',
    draft: 'مسودہ', end_date: 'اختتامی تاریخ', entries: 'اندراجات', expenses: 'اخراجات',
    face_attendance: 'چہرہ شناسی حاضری', financial_dashboard_title: 'مالی ڈیش بورڈ',
    financial_ratios_title: 'مالی صحت ڈیش بورڈ',
    from_date: 'سے', general_ledger_title: 'جنرل لیجر', grand_total: 'کل جمع',
    inv_avg_daily: 'اوسط یومیہ فروخت', inv_daily_demand: 'یومیہ طلب',
    inv_days_left: 'باقی دن', inv_demand_reorder: 'طلب اور ری آرڈر',
    inv_forecast_subtitle: 'AI طلب کی پیشگوئی', inv_forecast_title: 'AI انوینٹری پیشگوئی',
    inv_items_tracked: 'ٹریک شدہ آئٹمز', inv_need_reorder: 'ری آرڈر ضروری',
    inv_projected_sales: 'متوقع فروخت', inv_reorder_qty: 'ری آرڈر مقدار', inv_stock: 'اسٹاک',
    invoice_uuid: 'انوائس UUID', journal_subtitle: 'ڈیبٹ اور کریڈٹ اندراجات',
    last_month: 'پچھلا مہینہ', leave_cal_subtitle: 'چھٹیوں کا کیلنڈر ویو',
    loan_mgmt_subtitle: 'ملازمین کے قرضے اور اقساط', menu_analytics_title: 'مینو تجزیات',
    motion_detected: 'حرکت کا پتہ چلا',
    nav_aging_reports: 'عمر رپورٹس', nav_anomaly_detection: 'بے ضابطگی', nav_cash_flow: 'نقد بہاؤ',
    nav_general_ledger: 'جنرل لیجر', nav_pnl_compare: 'P&L موازنہ',
    nav_rate_limits: 'شرح حدود', nav_recurring_entries: 'بار بار اندراجات', nav_trial_balance: 'ٹرائل بیلنس',
    no_cameras: 'کوئی کیمرا نہیں', notes: 'نوٹس', of: 'کا', open: 'کھلا', orders: 'آرڈرز',
    overdue: 'واجب الادا', partial: 'جزوی', payment_date: 'ادائیگی تاریخ',
    performance_subtitle: 'جائزے، اہداف اور تادیبی کارروائیاں', planned: 'منصوبہ بند',
    pnl_compare_title: 'P&L موازنہ', pos_config_title: 'POS ترتیب',
    qr_code: 'QR کوڈ', quantity: 'مقدار',
    rate_limit_current_usage: 'موجودہ استعمال', rate_limit_override: 'حسب ضرورت حد',
    rate_limit_plan: 'پلان', rate_limit_role: 'کردار',
    rate_limit_subtitle: 'API استعمال کی نگرانی', rate_limit_tiers: 'شرح حد درجات',
    rate_limit_title: 'API شرح حدود', rate_limit_top_users: 'اعلی API صارفین',
    rate_limit_user_breakdown: 'صارف تفصیل', rate_limit_your_limit: 'آپ کی حد',
    rate_limit_your_status: 'آپ کی شرح حد',
    recruitment_subtitle: 'نوکری، درخواست اور انٹرویو', recurring_entries_title: 'بار بار جرنل اندراجات',
    role_mgmt_title: 'کردار اور اجازتیں', run_analysis: 'تجزیہ چلائیں',
    sales_alerts_title: 'فروخت الرٹس', sales_forecast_title: 'AI فروخت تجزیہ',
    scheduled_reports_title: 'شیڈولڈ رپورٹس', security_concern: 'سیکیورٹی تشویش',
    select_branch: 'شاخ منتخب کریں', select_category: 'زمرہ منتخب کریں',
    select_date: 'تاریخ منتخب کریں', select_status: 'حالت منتخب کریں',
    showing: 'دکھا رہا ہے', staff_perf_subtitle: 'حاضری اور ذمہ داریاں',
    staff_perf_title: 'عملے کی کارکردگی', start_date: 'شروع تاریخ',
    stock_reorder_title: 'AI اسٹاک تجزیہ', subtotal: 'ذیلی کل',
    success_created: 'کامیابی سے بنایا', success_updated: 'کامیابی سے اپڈیٹ',
    take_tour: 'ٹور لیں', tax: 'ٹیکس', this_month: 'اس مہینے', this_week: 'اس ہفتے',
    time: 'وقت', to_date: 'تک', total: 'کل', total_documents: 'کل دستاویزات',
    total_headcount: 'کل ملازمین', tour_back: 'واپس', tour_completed: 'ٹور مکمل! ڈیش بورڈ دریافت کریں',
    tour_finish: 'ختم', tour_next: 'اگلا', tour_skip: 'ٹور چھوڑیں',
    tour_step: 'مرحلہ {current} از {total}', tour_welcome: 'Smarto میں خوش آمدید!',
    tour_welcome_desc: 'آئیے آپ کو اپنے نئے کاروباری ڈیش بورڈ سے متعارف کرائیں',
    trial_balance_title: 'ٹرائل بیلنس', updated_at: 'اپڈیٹ شدہ',
    upload_image: 'تصویر اپلوڈ', xml_invoice: 'XML انوائس', yearly: 'سالانہ', yesterday: 'کل',
  },
  hi: {
    nav_operations: 'संचालन', nav_finance: 'वित्त', nav_people: 'लोग',
    nav_stock: 'स्टॉक', nav_reports: 'रिपोर्ट', nav_assets: 'संपत्ति', nav_admin: 'व्यवस्थापक',
    nav_dashboard: 'डैशबोर्ड', nav_quick_entry: 'त्वरित प्रविष्टि', nav_live_analytics: 'लाइव विश्लेषण',
    nav_sales: 'बिक्री', nav_invoices: 'चालान', nav_expenses: 'खर्च',
    nav_supplier_payments: 'आपूर्तिकर्ता भुगतान', nav_cash_transfers: 'नकद हस्तांतरण',
    nav_customers: 'ग्राहक', nav_suppliers: 'आपूर्तिकर्ता', nav_employees: 'कर्मचारी',
    nav_leave_approvals: 'छुट्टी स्वीकृति', nav_schedule: 'शेड्यूल',
    nav_inventory: 'इन्वेंटरी', nav_transfers: 'हस्तांतरण', nav_kitchen: 'रसोई',
    nav_analytics: 'विश्लेषण', nav_visualizations: 'चार्ट', nav_reports_page: 'रिपोर्ट',
    nav_credit_report: 'क्रेडिट रिपोर्ट', nav_supplier_report: 'आपूर्तिकर्ता रिपोर्ट',
    nav_category_report: 'श्रेणी रिपोर्ट', nav_bank_statements: 'बैंक विवरण',
    nav_reconciliation: 'मिलान', nav_branches: 'शाखाएँ', nav_documents: 'दस्तावेज़',
    nav_fines: 'जुर्माना', nav_partners: 'साझेदार', nav_company_loans: 'कंपनी ऋण',
    nav_users: 'उपयोगकर्ता', nav_settings: 'सेटिंग्स', nav_help: 'सहायता',
    nav_sales_revenue: 'बिक्री और राजस्व', nav_expenses_payables: 'खर्च और भुगतान',
    nav_hr_workforce: 'HR और कर्मचारी', nav_pos_inventory: 'POS और इन्वेंटरी',
    nav_accounting: 'लेखांकन',
    help_sales: 'दैनिक बिक्री रिकॉर्ड करें, नकद/कार्ड/क्रेडिट भुगतान ट्रैक करें',
    help_expenses: 'श्रेणी, आपूर्तिकर्ता और भुगतान मोड के अनुसार खर्च ट्रैक करें',
    help_hr: 'कर्मचारियों, वेतन, छुट्टी, उपस्थिति और दस्तावेज़ प्रबंधित करें',
    help_pos: 'अपने व्यवसाय प्रकार के अनुसार POS कॉन्फ़िगर करें',
    help_accounting: 'जर्नल प्रविष्टियाँ, बैलेंस शीट और आय विवरण',
    help_reports: 'उन्नत विश्लेषण, पूर्वानुमान और कस्टम रिपोर्ट',
    dash_title: 'डैशबोर्ड', dash_subtitle: 'व्यापार अवलोकन',
    total_sales: 'कुल बिक्री', total_expenses: 'कुल खर्च',
    supplier_payments: 'आपूर्तिकर्ता भुगतान', net_profit: 'शुद्ध लाभ',
    pending_credits: 'लंबित उधार', today_vs_yesterday: 'कल की तुलना',
    recent_sales: 'हालिया बिक्री', expense_breakdown: 'खर्च विवरण',
    quick_actions: 'त्वरित कार्य', new_sale: 'नई बिक्री', new_expense: 'नया खर्च',
    view_reports: 'रिपोर्ट देखें', cash_balance: 'नकद शेष', bank_balance: 'बैंक शेष',
    customize_widgets: 'विजेट अनुकूलित', reset_layout: 'रीसेट',
    // Reconciliation Wizard
    wiz_title: '3 चरणों में मिलान',
    wiz_subtitle: 'कच्चे बैंक स्टेटमेंट को स्वचालित मिलान, ऑडिट ट्रेल और AI द्वारा सुनाई गई फोरेंसिक कहानियों में बदलें।',
    wiz_step: 'चरण', wiz_done: 'पूर्ण',
    wiz_upload_title: 'स्टेटमेंट अपलोड करें',
    wiz_upload_desc: 'स्मार्ट-मैच इंजन चलाने के लिए CSV / XLSX बैंक स्टेटमेंट डालें।',
    wiz_upload_cta: 'अपलोड',
    wiz_review_title: 'स्वतः मिलान की समीक्षा',
    wiz_review_desc: 'इंजन के सुझावों की पुष्टि या अस्वीकार करें — हर क्रिया ऑडिट लॉग में दर्ज होती है।',
    wiz_review_cta: 'समीक्षा',
    wiz_narrate_title: 'ऑडिट कहानी बनाएं',
    wiz_narrate_desc: '"इस मिलान को कहानी के रूप में चलाएं" पर क्लिक करें और AI द्वारा सुनाई गई फोरेंसिक सारांश प्राप्त करें।',
    wiz_narrate_cta: 'लॉग खोलें',
    add_widget: 'विजेट जोड़ें', remove_widget: 'हटाएँ',
    sales_title: 'बिक्री प्रबंधन', sales_subtitle: 'सभी बिक्री लेनदेन ट्रैक करें',
    add_new_sale: 'नई बिक्री जोड़ें', sale_date: 'तारीख', sale_amount: 'राशि',
    payment_details: 'भुगतान विवरण', payment_mode: 'भुगतान मोड',
    customer_name: 'ग्राहक का नाम', sale_items: 'आइटम', sale_notes: 'टिप्पणी',
    credit_amount: 'उधार राशि', all_sales: 'सभी बिक्री',
    expenses_title: 'खर्च', expenses_subtitle: 'व्यावसायिक खर्चों को ट्रैक करें',
    add_expense: 'खर्च जोड़ें', expense_date: 'तारीख', expense_amount: 'राशि',
    expense_category: 'श्रेणी', expense_description: 'विवरण',
    all_expenses: 'सभी खर्च', total_label: 'कुल',
    employees_title: 'कर्मचारी', employees_subtitle: 'अपनी टीम का प्रबंधन',
    add_employee: 'कर्मचारी जोड़ें', employee_name: 'नाम', employee_phone: 'फोन',
    employee_email: 'ईमेल', employee_role: 'पद', employee_salary: 'वेतन',
    employee_branch: 'शाखा', employee_status: 'स्थिति', job_titles: 'पदनाम',
    active: 'सक्रिय', inactive: 'निष्क्रिय',
    stock_title: 'स्टॉक प्रबंधन', stock_subtitle: 'इन्वेंटरी ट्रैकिंग और नियंत्रण',
    add_item: 'आइटम जोड़ें', item_name: 'आइटम नाम', item_category: 'श्रेणी',
    item_unit: 'इकाई', unit_price: 'बिक्री मूल्य', cost_price: 'लागत मूल्य',
    min_stock: 'न्यूनतम', current_stock: 'वर्तमान स्टॉक', stock_in: 'स्टॉक इन',
    stock_out: 'स्टॉक आउट', stock_value: 'स्टॉक मूल्य',
    invoices_title: 'चालान', invoices_subtitle: 'ZATCA अनुरूप चालान बनाएँ',
    create_invoice: 'चालान बनाएँ', invoice_number: 'चालान नं', invoice_date: 'तारीख',
    invoice_customer: 'ग्राहक', invoice_items: 'आइटम', invoice_total: 'कुल',
    invoice_status: 'स्थिति', invoice_paid: 'भुगतान', invoice_unpaid: 'बकाया',
    scan_invoice: 'चालान स्कैन',
    customers_title: 'ग्राहक', customers_subtitle: 'ग्राहक डेटाबेस और क्रेडिट प्रबंधन',
    add_customer: 'ग्राहक जोड़ें', customer_phone: 'फोन', customer_balance: 'शेष',
    total_customers: 'कुल ग्राहक', total_credit: 'कुल उधार',
    suppliers_title: 'आपूर्तिकर्ता', suppliers_subtitle: 'आपूर्तिकर्ता प्रबंधन',
    add_supplier: 'आपूर्तिकर्ता जोड़ें', supplier_name: 'नाम', supplier_phone: 'फोन',
    supplier_balance: 'शेष', total_suppliers: 'कुल आपूर्तिकर्ता',
    pos_title: 'त्वरित प्रविष्टि', pos_customer: 'ग्राहक', pos_item: 'आइटम',
    pos_quantity: 'मात्रा', pos_price: 'कीमत', pos_discount: 'छूट',
    pos_total: 'कुल', pos_add_item: 'आइटम जोड़ें', pos_submit: 'बिक्री दर्ज करें',
    pos_clear: 'साफ़ करें', pos_payment_mode: 'भुगतान मोड',
    pos_cash: 'नकद', pos_bank: 'बैंक', pos_online: 'ऑनलाइन', pos_credit: 'उधार',
    settings_title: 'सेटिंग्स', settings_subtitle: 'एप्लिकेशन सेटिंग्स',
    email_config: 'ईमेल सेटिंग', whatsapp_config: 'व्हाट्सएप सेटिंग',
    company_branding: 'कंपनी ब्रांडिंग', scheduler_config: 'अनुसूचित रिपोर्ट',
    data_management: 'डेटा प्रबंधन', notification_settings: 'सूचना सेटिंग्स',
    partners_title: 'साझेदार', partners_subtitle: 'निवेश और लाभ साझाकरण',
    add_partner: 'साझेदार जोड़ें', partner_name: 'नाम',
    share_percentage: 'हिस्सा %', total_invested: 'कुल निवेश',
    total_withdrawn: 'कुल निकासी', partner_balance: 'शेष',
    reports_title: 'रिपोर्ट', eod_summary: 'दिन का सारांश', partner_pnl: 'साझेदार लाभ-हानि',
    daily_summary: 'दैनिक सारांश', top_customers: 'शीर्ष ग्राहक',
    cashier_performance: 'कैशियर प्रदर्शन', generate: 'बनाएँ', print_report: 'रिपोर्ट प्रिंट',
    analytics_title: 'उन्नत विश्लेषण', analytics_subtitle: 'AI-संचालित व्यापार अंतर्दृष्टि',
    predictive_hub: 'भविष्यवाणी विश्लेषण',
    expense_forecast: 'खर्च पूर्वानुमान', stock_reorder: 'स्टॉक रीऑर्डर',
    revenue_trends: 'राजस्व रुझान', customer_churn: 'ग्राहक जोखिम',
    margin_optimizer: 'मार्जिन ऑप्टिमाइज़र', sales_forecast: 'बिक्री पूर्वानुमान',
    viz_title: 'विज़ुअलाइज़ेशन', viz_subtitle: 'उन्नत चार्ट और डेटा',
    viz_heatmap: 'हीटमैप', viz_funnel: 'फ़नल', viz_treemap: 'ट्रीमैप',
    viz_gauges: 'गेज', viz_radar: 'रडार', viz_waterfall: 'वॉटरफ़ॉल',
    viz_money_flow: 'धन प्रवाह', viz_compare: 'तुलना',
    viz_export_png: 'छवि निर्यात', viz_click_drill: 'विवरण के लिए क्लिक करें',
    loading: 'लोड हो रहा है...', save: 'सहेजें', cancel: 'रद्द', delete: 'हटाएँ',
    edit: 'संपादन', add: 'जोड़ें', search: 'खोजें', filter: 'फ़िल्टर',
    export_btn: 'निर्यात', print: 'प्रिंट', refresh: 'ताज़ा करें', close: 'बंद',
    confirm: 'पुष्टि', actions: 'कार्य', status: 'स्थिति', date: 'तारीख',
    amount: 'राशि', description: 'विवरण', category: 'श्रेणी',
    branch: 'शाखा', all_branches: 'सभी शाखाएँ', no_data: 'कोई डेटा नहीं',
    name: 'नाम', phone: 'फोन', email: 'ईमेल', address: 'पता',
    submit: 'जमा करें', update: 'अपडेट', view: 'देखें', download: 'डाउनलोड',
    dark: 'डार्क', light: 'लाइट', shortcuts: 'शॉर्टकट', logout: 'लॉग आउट',
    language: 'भाषा',
    stock_alert_title: 'आइटम न्यूनतम से नीचे',
    stock_alert_view: 'विवरण', stock_alert_hide: 'छिपाएँ',
    go_to_inventory: 'इन्वेंटरी पर जाएँ',
    transactions: 'लेनदेन', items: 'आइटम', payments: 'भुगतान',
    overview: 'अवलोकन', period: 'अवधि', compare: 'तुलना', trends: 'रुझान',
    item_pnl: 'आइटम लाभ',
    // Common UI
    loading: 'लोड हो रहा है...', no_data: 'कोई डेटा नहीं', error_occurred: 'त्रुटि हुई',
    try_again: 'पुनः प्रयास करें', confirm: 'पुष्टि करें', cancel: 'रद्द करें', save: 'सहेजें', delete: 'हटाएँ',
    edit: 'संपादित करें', view: 'देखें', add: 'जोड़ें', back: 'वापस', next: 'अगला', previous: 'पिछला',
    search: 'खोजें', filter: 'फ़िल्टर', sort: 'क्रमबद्ध', export: 'निर्यात', import: 'आयात',
    refresh: 'रीफ्रेश', reset: 'रीसेट', apply: 'लागू करें', clear: 'साफ़ करें',
    // Status messages
    success: 'सफलता', failed: 'विफल', pending: 'लंबित', completed: 'पूर्ण',
    in_progress: 'प्रगति में', cancelled: 'रद्द',
    // Shift Report
    shift_report_title: 'दैनिक शिफ्ट रिपोर्ट', shift_report_subtitle: 'कैशियर शिफ्ट, बिक्री विवरण और नकद समाधान',
    daily_report: 'दैनिक रिपोर्ट', date_range: 'तारीख सीमा', total_shifts: 'कुल शिफ्ट',
    opening_cash: 'प्रारंभिक नकद', closing_cash: 'अंतिम नकद', expected_cash: 'अपेक्षित नकद',
    cash_difference: 'नकद अंतर', shortage: 'कमी', overage: 'अधिकता', balanced: 'संतुलित',
    payment_breakdown: 'भुगतान विधि विवरण', sales_by_branch: 'शाखा के अनुसार बिक्री',
    shift_details: 'शिफ्ट विवरण', top_selling_items: 'सबसे ज्यादा बिकने वाले आइटम',
    daily_trend: 'दैनिक बिक्री रुझान', daily_breakdown: 'दैनिक विवरण',
    avg_sales_day: 'औसत बिक्री/दिन', duration: 'अवधि', cashier: 'कैशियर',
    // Bulk Salary
    bulk_salary_title: 'बल्क वेतन भुगतान', bulk_payment_info: 'सभी पात्र कर्मचारियों को एक साथ वेतन दें। यह स्वचालित रूप से वेतन और खर्च रिकॉर्ड बनाएगा।',
    preview_select: 'पूर्वावलोकन और कर्मचारी चुनें', to_pay: 'भुगतान के लिए', already_paid: 'पहले से भुगतान',
    total_amount: 'कुल राशि', employees_to_pay: 'भुगतान के लिए कर्मचारी', select_all: 'सभी चुनें',
    pay_employees: 'कर्मचारियों को भुगतान', payment_completed: 'भुगतान पूर्ण', by_branch: 'शाखा के अनुसार',
    skipped_failed: 'छोड़ा / विफल', monthly_salary_payment: 'मासिक वेतन भुगतान',
    // Expense Categories
    cat_salary: 'वेतन', cat_rent: 'किराया', cat_utilities: 'उपयोगिताएँ', cat_vehicle: 'वाहन',
    cat_maintenance: 'रखरखाव', cat_supplier: 'आपूर्तिकर्ता', cat_tickets: 'टिकट',
    cat_id_card: 'पहचान पत्र', cat_other: 'अन्य',
    cat_basic_salary: 'मूल वेतन', cat_overtime: 'ओवरटाइम', cat_bonus: 'बोनस',
    cat_office_rent: 'कार्यालय किराया', cat_warehouse_rent: 'गोदाम किराया', cat_shop_rent: 'दुकान किराया',
    cat_electricity: 'बिजली', cat_water: 'पानी', cat_internet: 'इंटरनेट', cat_phone: 'फोन',
    cat_fuel: 'ईंधन', cat_insurance: 'बीमा', cat_office_maintenance: 'कार्यालय रखरखाव',
    cat_equipment_repair: 'उपकरण मरम्मत',
    // Widget names
    widget_stats: 'मुख्य आंकड़े', widget_charts: 'त्वरित चार्ट', widget_cash_bank: 'नकद और बैंक',
    widget_payment_mode: 'भुगतान मोड', widget_spending: 'खर्च विवरण',
    widget_dues: 'बकाया और अलर्ट', widget_branch_dues: 'शाखा बकाया', widget_vat: 'कर सारांश',
    widget_desc_stats: 'बिक्री, खर्च, लाभ अवलोकन', widget_desc_charts: 'खर्च वितरण और तुलना',
    widget_desc_cash: 'नकद और बैंक शेष', widget_desc_payment: 'नकद, बैंक, क्रेडिट विवरण',
    widget_desc_spending: 'खर्च श्रेणियाँ और व्यय', widget_desc_dues: 'आपूर्तिकर्ता बकाया, जुर्माना, अलर्ट',
    widget_desc_branch: 'शाखाओं के बीच शेष', widget_desc_vat: 'कर गणना',
    show_all: 'सभी दिखाएँ', minimize: 'न्यूनतम', done: 'हो गया',
    // AI Widget translations
    ai_low_stock: 'AI: स्टॉक अलर्ट', ai_low_stock_desc: 'कम होने वाले आइटम',
    ai_peak_hours: 'AI: व्यस्त समय', ai_peak_hours_desc: 'स्टाफ योजना',
    ai_customer_clv: 'AI: ग्राहक मूल्य', ai_customer_clv_desc: 'जीवनकाल मूल्य भविष्यवाणी',
    ai_profit_analysis: 'AI: लाभ विश्लेषण', ai_profit_analysis_desc: 'दैनिक लाभ रुझान',
    items_at_risk: 'जोखिम में आइटम', all_stock_healthy: 'सभी स्टॉक स्तर स्वस्थ',
    days_left: 'दिन शेष', stock_level: 'स्टॉक', reorder_point: 'रीऑर्डर',
    based_on_transactions: '{count} लेनदेन के आधार पर', peak_hours_staff: 'इन घंटों में अतिरिक्त स्टाफ रखें',
    of_traffic: 'ट्रैफिक का', projected_revenue: '12 महीने की अनुमानित आय',
    lifetime_value: 'जीवनकाल मूल्य', orders_active: 'ऑर्डर', days_active: 'दिन सक्रिय',
    add_customers_clv: 'CLV देखने के लिए ग्राहक जोड़ें', avg_daily_profit: 'औसत दैनिक लाभ',
    trend: 'रुझान', improving: 'सुधार', declining: 'गिरावट', stable: 'स्थिर',
    best_day: 'सर्वश्रेष्ठ', worst_day: 'सबसे खराब', not_enough_data: 'विश्लेषण के लिए पर्याप्त डेटा नहीं',
    // Quick Actions
    quick_actions: 'त्वरित कार्य', qa_record_sale: 'बिक्री दर्ज करें', qa_add_expense: 'खर्च जोड़ें',
    qa_pay_supplier: 'आपूर्तिकर्ता भुगतान', qa_new_invoice: 'नया इनवॉइस', qa_approve_leave: 'छुट्टी मंजूर करें',
    qa_pay_salary: 'वेतन दें', qa_add_customer: 'ग्राहक जोड़ें', qa_view_reports: 'रिपोर्ट देखें',
    qa_stock_entry: 'स्टॉक एंट्री', qa_cctv_live: 'लाइव कैमरा', qa_available: 'उपलब्ध',
    qa_no_actions: 'आपकी भूमिका के लिए कोई त्वरित कार्य उपलब्ध नहीं',
    // Menu Items
    menu_items: 'मेनू आइटम', nav_menu_items: 'मेनू आइटम',
    // Order Status
    order_status: 'ऑर्डर स्थिति', preparing: 'तैयारी में', ready_pickup: 'पिकअप के लिए तैयार',
    documents_title: 'दस्तावेज़', fines_title: 'जुर्माना',
    company_loans_title: 'कंपनी ऋण', users_title: 'उपयोगकर्ता', branches_title: 'शाखाएँ',
    schedule_title: 'शिफ्ट शेड्यूल', leave_title: 'छुट्टी स्वीकृति',
    cash_transfers_title: 'नकद हस्तांतरण', bank_statements_title: 'बैंक विवरण',
    reconciliation_title: 'मिलान', credit_report_title: 'क्रेडिट रिपोर्ट',
    supplier_report_title: 'आपूर्तिकर्ता रिपोर्ट', category_report_title: 'श्रेणी रिपोर्ट',
    kitchen_title: 'रसोई डिस्प्ले', notifications_title: 'सूचनाएँ',
    help_title: 'सहायता', portal_title: 'कर्मचारी पोर्टल',
    // CCTV
    cctv_title: 'CCTV सुरक्षा', cctv_subtitle: 'AI संचालित वीडियो निगरानी',
    live_view: 'लाइव व्यू', face_recognition: 'चेहरे की पहचान', object_detection: 'वस्तु पहचान',
    people_count: 'लोगों की गिनती', motion_analysis: 'गति विश्लेषण', alerts: 'अलर्ट',
    devices: 'डिवाइस', register_face: 'चेहरा पंजीकृत करें', registered_faces: 'पंजीकृत चेहरे',
    // Scheduled Monitoring
    scheduled_monitoring: 'शेड्यूल्ड AI मॉनिटरिंग', monitoring_interval: 'मॉनिटरिंग अंतराल',
    enable_monitoring: 'शेड्यूल्ड मॉनिटरिंग सक्षम करें', run_now: 'अभी चलाएं',
    notification_channels: 'सूचना चैनल', in_app: 'ऐप में', whatsapp: 'व्हाट्सऐप',
    // Partner P&L
    partner_pl_title: 'पार्टनर P&L रिपोर्ट', partner_pl_subtitle: 'स्वामित्व के अनुसार लाभ-हानि',
    company_summary: 'कंपनी सारांश', partner_breakdown: 'पार्टनर विवरण',
    expense_categories: 'खर्च श्रेणियाँ', payment_modes: 'भुगतान मोड',
    revenue: 'राजस्व', gross_profit: 'सकल लाभ', operating_expenses: 'परिचालन खर्च',
    profit_share: 'लाभ हिस्सा', ownership_percentage: 'स्वामित्व %', investments: 'निवेश',
    withdrawals: 'निकासी', current_balance: 'वर्तमान शेष', available_withdrawal: 'निकासी के लिए उपलब्ध',
    // ZATCA Phase 2
    zatca_phase2: 'ZATCA फेज 2', zatca_compliance: 'ZATCA अनुपालन',
    generate_xml: 'XML चालान बनाएं', submit_zatca: 'ZATCA को भेजें',
    // Mobile Navigation
    customize_nav: 'बॉटम नेविगेशन कस्टमाइज़ करें', reset_default: 'डिफ़ॉल्ट पर रीसेट',
    select_items: '5 आइटम तक चुनें', more: 'और',
    // AI Hub
    ai_hub_title: 'AI बिजनेस हब', ai_hub_subtitle: 'AI संचालित व्यापार बुद्धिमत्ता',
    ai_supplier_intel: 'आपूर्तिकर्ता बुद्धिमत्ता', ai_pricing_opt: 'मूल्य अनुकूलन',
    ai_churn: 'ग्राहक हानि', ai_marketing: 'मार्केटिंग',
    ai_insights: 'AI अंतर्दृष्टि', ai_hub_load_error: 'डेटा लोड करने में विफल',
    ai_total_customers: 'कुल ग्राहक', ai_churned: 'खोए हुए', ai_high_risk: 'उच्च जोखिम',
    ai_campaign_suggestions: 'अभियान सुझाव', ai_best_day: 'सबसे अच्छा दिन', ai_worst_day: 'सबसे खराब दिन',
    active: 'सक्रिय', inactive: 'निष्क्रिय',
    inv_forecast_title: 'AI इन्वेंटरी पूर्वानुमान', cross_branch_title: 'मल्टी-ब्रांच वित्तीय रिपोर्ट',
    nav_ai_hub: 'AI हब', nav_ai_forecast: 'AI पूर्वानुमान', nav_cross_branch: 'क्रॉस-ब्रांच रिपोर्ट',
    // Page titles
    attendance_title: 'उपस्थिति डैशबोर्ड', payroll_title: 'वेतन प्रबंधन',
    performance_title: 'प्रदर्शन और समीक्षा', training_title: 'प्रशिक्षण प्रबंधन',
    recruitment_title: 'भर्ती', leave_cal_title: 'अवकाश प्रबंधन',
    emp_docs_title: 'कर्मचारी दस्तावेज़', hr_analytics_title: 'HR विश्लेषण',
    balance_sheet_title: 'बैलेंस शीट', pnl_title: 'लाभ और हानि विवरण',
    journal_title: 'जर्नल प्रविष्टियां', coa_title: 'खातों का चार्ट',
    bills_title: 'बिल', daily_summary_title: 'दैनिक सारांश',
    cashier_pos_title: 'रेस्तरां POS', stock_reorder_title: 'AI स्टॉक विश्लेषण',
    sales_forecast_title: 'AI बिक्री विश्लेषण', activity_logs_title: 'गतिविधि लॉग',
    audit_trail_title: 'ऑडिट ट्रेल', currency_settings_title: 'मुद्रा सेटिंग्स',
    role_mgmt_title: 'भूमिकाएं और अनुमतियां', country_laws_title: 'देश श्रम कानून',
    loan_mgmt_title: 'ऋण प्रबंधन', staff_perf_title: 'कर्मचारी प्रदर्शन',
    anomaly_title: 'विसंगति का पता लगाना', pos_config_title: 'POS कॉन्फ़िगरेशन',
    data_mgmt_title: 'डेटा प्रबंधन', data_export_title: 'डेटा निर्यात',
    // Common
    total_employees: 'कुल कर्मचारी', today: 'आज', yesterday: 'कल',
    this_month: 'इस महीने', paid: 'भुगतान हुआ', unpaid: 'अवैतनिक',
    approved: 'स्वीकृत', rejected: 'अस्वीकृत', debit: 'डेबिट', credit: 'क्रेडिट',
    balance: 'शेष', revenue: 'राजस्व', profit: 'लाभ', loss: 'हानि',
    monthly: 'मासिक', weekly: 'साप्ताहिक', daily: 'दैनिक',
    no_results: 'कोई परिणाम नहीं', select_branch: 'शाखा चुनें',
    details: 'विवरण', summary: 'सारांश', history: 'इतिहास',
    confirm_delete: 'क्या आप सुनिश्चित हैं कि आप इसे हटाना चाहते हैं?',
    success_saved: 'सफलतापूर्वक सहेजा गया', success_deleted: 'सफलतापूर्वक हटाया गया',
    // Accounting & Reports
    active_employees: 'सक्रिय कर्मचारी', activity_logs_subtitle: 'उपयोगकर्ता गतिविधियां और सिस्टम ईवेंट ट्रैक करें',
    aging_title: 'एजिंग रिपोर्ट', ai_action: 'कार्रवाई', ai_at_risk_revenue: 'जोखिम में राजस्व',
    ai_audience: 'दर्शक', ai_avg_margin: 'औसत मार्जिन', ai_avg_order: 'औसत ऑर्डर',
    ai_avg_value: 'औसत ग्राहक मूल्य', ai_best_day: 'सबसे अच्छा दिन', ai_campaign_suggestions: 'अभियान सुझाव',
    ai_channel: 'चैनल', ai_churned: 'छोड़ गए', ai_cost: 'लागत', ai_current: 'वर्तमान',
    ai_customer_risk: 'ग्राहक जोखिम विश्लेषण', ai_days_inactive: 'निष्क्रिय दिन', ai_high_risk: 'उच्च जोखिम',
    ai_hub_load_error: 'डेटा लोड नहीं हुआ', ai_hub_subtitle: 'AI व्यापार बुद्धिमत्ता और अनुकूलन',
    ai_item: 'आइटम', ai_items_analyzed: 'विश्लेषित आइटम', ai_keep: 'रखें', ai_margin: 'मार्जिन',
    ai_price_increase: 'वृद्धि', ai_pricing_recs: 'मूल्य सुझाव', ai_revenue_90d: '90 दिन राजस्व',
    ai_revenue_impact: '30 दिन राजस्व प्रभाव', ai_risk_distribution: 'जोखिम वितरण', ai_risk_level: 'जोखिम',
    ai_sold_90d: '90 दिन बिक्री', ai_suggested: 'सुझाया गया', ai_supplier_perf: 'आपूर्तिकर्ता प्रदर्शन',
    ai_target: 'लक्ष्य', ai_top_products: 'शीर्ष उत्पाद (90 दिन)', ai_top_suppliers: 'शीर्ष आपूर्तिकर्ता',
    ai_total_customers: 'कुल ग्राहक', ai_total_paid: 'कुल भुगतान', ai_total_spent: 'कुल खर्च',
    ai_transactions: 'लेनदेन', ai_vip_customers: 'VIP ग्राहक', ai_worst_day: 'सबसे खराब दिन',
    analyze_motion: 'गति विश्लेषण', anomaly_subtitle: 'AI बिक्री और खर्च स्कैनिंग', anomaly_title: 'विसंगति पहचान',
    as_of_date: 'तिथि तक', audit_trail_title: 'ऑडिट ट्रेल',
    b2b_invoice: 'B2B कर चालान', b2c_invoice: 'सरल कर चालान',
    bi_dashboard_title: 'BI डैशबोर्ड', bills_subtitle: 'आपूर्तिकर्ता बिल और भुगतान',
    cash_flow_title: 'नकद प्रवाह विवरण', closed: 'बंद', coa_subtitle: 'लेखा संरचना प्रबंधित करें',
    count_people: 'लोगों की गिनती', country_laws_title: 'देश श्रम कानून',
    created_at: 'बनाया गया', created_by: 'बनाने वाला',
    cross_branch_breakdown: 'शाखा-वार विवरण', cross_branch_comparison: 'शाखा तुलना',
    cross_branch_converted_profit: 'परिवर्तित लाभ', cross_branch_converted_sales: 'परिवर्तित बिक्री',
    cross_branch_local_expenses: 'स्थानीय खर्च', cross_branch_local_sales: 'स्थानीय बिक्री',
    cross_branch_rate: 'दर', cross_branch_revenue_share: 'शाखा अनुसार राजस्व हिस्सा',
    cross_branch_subtitle: 'क्रॉस-देश शाखा तुलना', cross_branch_title: 'मल्टी-ब्रांच वित्तीय रिपोर्ट',
    crowd_density: 'भीड़ घनत्व', csid_required: 'CSID आवश्यक',
    custom_range: 'कस्टम रेंज', data_export_title: 'डेटा निर्यात', data_mgmt_title: 'डेटा प्रबंधन',
    detect_objects: 'ऑब्जेक्ट पहचान', digital_signature: 'डिजिटल हस्ताक्षर', discount: 'छूट',
    draft: 'मसौदा', end_date: 'अंतिम तिथि', entries: 'प्रविष्टियां', expenses: 'खर्च',
    face_attendance: 'चेहरा पहचान उपस्थिति', financial_dashboard_title: 'वित्तीय डैशबोर्ड',
    financial_ratios_title: 'वित्तीय स्वास्थ्य डैशबोर्ड',
    from_date: 'से', general_ledger_title: 'सामान्य खाता', grand_total: 'कुल योग',
    inv_avg_daily: 'औसत दैनिक बिक्री', inv_daily_demand: 'दैनिक मांग',
    inv_days_left: 'शेष दिन', inv_demand_reorder: 'मांग और री-ऑर्डर',
    inv_forecast_subtitle: 'AI मांग पूर्वानुमान', inv_forecast_title: 'AI इन्वेंटरी पूर्वानुमान',
    inv_items_tracked: 'ट्रैक किए गए आइटम', inv_need_reorder: 'री-ऑर्डर आवश्यक',
    inv_projected_sales: 'अनुमानित बिक्री', inv_reorder_qty: 'री-ऑर्डर मात्रा', inv_stock: 'स्टॉक',
    invoice_uuid: 'चालान UUID', journal_subtitle: 'डेबिट और क्रेडिट प्रविष्टियां',
    last_month: 'पिछला महीना', leave_cal_subtitle: 'छुट्टी कैलेंडर दृश्य',
    loan_mgmt_subtitle: 'कर्मचारी ऋण और किस्तें', menu_analytics_title: 'मेनू विश्लेषण',
    motion_detected: 'गति पहचानी गई',
    nav_aging_reports: 'एजिंग रिपोर्ट', nav_anomaly_detection: 'विसंगति पहचान', nav_cash_flow: 'नकद प्रवाह',
    nav_general_ledger: 'सामान्य खाता', nav_pnl_compare: 'P&L तुलना',
    nav_rate_limits: 'दर सीमा', nav_recurring_entries: 'आवर्ती प्रविष्टियां', nav_trial_balance: 'ट्रायल बैलेंस',
    no_cameras: 'कोई कैमरा नहीं', notes: 'नोट्स', of: 'का', open: 'खुला', orders: 'ऑर्डर',
    overdue: 'अतिदेय', partial: 'आंशिक', payment_date: 'भुगतान तिथि',
    performance_subtitle: 'समीक्षा, लक्ष्य और अनुशासनात्मक कार्रवाई', planned: 'नियोजित',
    pnl_compare_title: 'P&L तुलना', pos_config_title: 'POS कॉन्फ़िगरेशन',
    qr_code: 'QR कोड', quantity: 'मात्रा',
    rate_limit_current_usage: 'वर्तमान उपयोग', rate_limit_override: 'कस्टम सीमा',
    rate_limit_plan: 'योजना', rate_limit_role: 'भूमिका',
    rate_limit_subtitle: 'API उपयोग निगरानी', rate_limit_tiers: 'दर सीमा स्तर',
    rate_limit_title: 'API दर सीमा', rate_limit_top_users: 'शीर्ष API उपयोगकर्ता',
    rate_limit_user_breakdown: 'उपयोगकर्ता विवरण', rate_limit_your_limit: 'आपकी सीमा',
    rate_limit_your_status: 'आपकी दर सीमा स्थिति',
    recruitment_subtitle: 'नौकरी, आवेदन और साक्षात्कार', recurring_entries_title: 'आवर्ती जर्नल प्रविष्टियां',
    role_mgmt_title: 'भूमिकाएं और अनुमतियां', run_analysis: 'विश्लेषण चलाएं',
    sales_alerts_title: 'बिक्री अलर्ट', sales_forecast_title: 'AI बिक्री विश्लेषण',
    scheduled_reports_title: 'शेड्यूल्ड रिपोर्ट', security_concern: 'सुरक्षा चिंता',
    select_branch: 'शाखा चुनें', select_category: 'श्रेणी चुनें',
    select_date: 'तिथि चुनें', select_status: 'स्थिति चुनें',
    showing: 'दिखा रहा है', staff_perf_subtitle: 'उपस्थिति और कर्तव्य',
    staff_perf_title: 'कर्मचारी प्रदर्शन', start_date: 'प्रारंभ तिथि',
    stock_reorder_title: 'AI स्टॉक विश्लेषण', subtotal: 'उप-कुल',
    success_created: 'सफलतापूर्वक बनाया गया', success_updated: 'सफलतापूर्वक अपडेट किया गया',
    take_tour: 'टूर लें', tax: 'कर', this_month: 'इस महीने', this_week: 'इस सप्ताह',
    time: 'समय', to_date: 'तक', total: 'कुल', total_documents: 'कुल दस्तावेज़',
    total_headcount: 'कुल कर्मचारी', tour_back: 'वापस', tour_completed: 'टूर पूरा! डैशबोर्ड देखें',
    tour_finish: 'समाप्त', tour_next: 'अगला', tour_skip: 'टूर छोड़ें',
    tour_step: 'चरण {current} / {total}', tour_welcome: 'Smarto में आपका स्वागत है!',
    tour_welcome_desc: 'आइए आपको अपने नए व्यापार डैशबोर्ड से परिचित कराएं',
    trial_balance_title: 'ट्रायल बैलेंस', updated_at: 'अपडेट किया गया',
    upload_image: 'छवि अपलोड', xml_invoice: 'XML चालान', yearly: 'वार्षिक', yesterday: 'कल',
  },
  bn: {
    nav_operations: 'কার্যক্রম', nav_finance: 'আর্থিক', nav_people: 'জনবল',
    nav_stock: 'স্টক', nav_reports: 'রিপোর্ট', nav_assets: 'সম্পদ', nav_admin: 'প্রশাসন',
    nav_dashboard: 'ড্যাশবোর্ড', nav_quick_entry: 'দ্রুত এন্ট্রি', nav_live_analytics: 'লাইভ বিশ্লেষণ',
    nav_sales: 'বিক্রয়', nav_invoices: 'চালান', nav_expenses: 'ব্যয়',
    nav_supplier_payments: 'সরবরাহকারী পেমেন্ট', nav_cash_transfers: 'নগদ স্থানান্তর',
    nav_customers: 'গ্রাহক', nav_suppliers: 'সরবরাহকারী', nav_employees: 'কর্মচারী',
    nav_leave_approvals: 'ছুটি অনুমোদন', nav_schedule: 'শিডিউল',
    nav_inventory: 'ইনভেন্টরি', nav_transfers: 'স্থানান্তর', nav_kitchen: 'রান্নাঘর',
    nav_analytics: 'বিশ্লেষণ', nav_visualizations: 'ভিজ্যুয়ালাইজেশন', nav_reports_page: 'রিপোর্ট',
    nav_credit_report: 'ক্রেডিট রিপোর্ট', nav_supplier_report: 'সরবরাহকারী রিপোর্ট',
    nav_category_report: 'ক্যাটাগরি রিপোর্ট', nav_bank_statements: 'ব্যাংক স্টেটমেন্ট',
    nav_reconciliation: 'মিলকরণ', nav_branches: 'শাখা', nav_documents: 'নথিপত্র',
    nav_fines: 'জরিমানা ও শাস্তি', nav_partners: 'অংশীদার', nav_company_loans: 'কোম্পানি ঋণ',
    nav_users: 'ব্যবহারকারী', nav_settings: 'সেটিংস', nav_help: 'সাহায্য ও গাইড',
    nav_sales_revenue: 'বিক্রয় ও রাজস্ব', nav_expenses_payables: 'ব্যয় ও প্রদান',
    nav_hr_workforce: 'HR ও কর্মী', nav_pos_inventory: 'POS ও ইনভেন্টরি',
    nav_accounting: 'হিসাবরক্ষণ',
    help_sales: 'দৈনিক বিক্রয় রেকর্ড করুন, নগদ/কার্ড/ক্রেডিট পেমেন্ট ট্র্যাক করুন',
    help_expenses: 'বিভাগ, সরবরাহকারী এবং পেমেন্ট মোড অনুযায়ী ব্যয় ট্র্যাক করুন',
    help_hr: 'কর্মচারী, বেতন, ছুটি, উপস্থিতি এবং নথি পরিচালনা করুন',
    help_pos: 'আপনার ব্যবসার ধরন অনুযায়ী POS কনফিগার করুন',
    help_accounting: 'জার্নাল এন্ট্রি, ব্যালেন্স শীট এবং আয় বিবরণী',
    help_reports: 'উন্নত বিশ্লেষণ, পূর্বাভাস এবং কাস্টম রিপোর্ট',
    dash_title: 'ড্যাশবোর্ড', dash_subtitle: 'ব্যবসায়িক সংক্ষিপ্ত বিবরণ',
    total_sales: 'মোট বিক্রয়', total_expenses: 'মোট ব্যয়',
    supplier_payments: 'সরবরাহকারী পেমেন্ট', net_profit: 'নিট লাভ',
    pending_credits: 'বকেয়া ক্রেডিট', today_vs_yesterday: 'গতকালের তুলনায়',
    recent_sales: 'সাম্প্রতিক বিক্রয়', expense_breakdown: 'ব্যয় বিভাজন',
    quick_actions: 'দ্রুত কাজ', new_sale: 'নতুন বিক্রয়', new_expense: 'নতুন ব্যয়',
    view_reports: 'রিপোর্ট দেখুন', cash_balance: 'নগদ ব্যালেন্স', bank_balance: 'ব্যাংক ব্যালেন্স',
    customize_widgets: 'উইজেট কাস্টমাইজ', reset_layout: 'লেআউট রিসেট',
    // Reconciliation Wizard
    wiz_title: '৩ ধাপে মিলকরণ',
    wiz_subtitle: 'কাঁচা ব্যাংক স্টেটমেন্টকে স্বয়ংক্রিয় মিল, অডিট ট্রেল এবং AI-বর্ণিত ফরেনসিক গল্পে রূপান্তর করুন।',
    wiz_step: 'ধাপ', wiz_done: 'সম্পন্ন',
    wiz_upload_title: 'স্টেটমেন্ট আপলোড',
    wiz_upload_desc: 'স্মার্ট-ম্যাচ ইঞ্জিন চালাতে CSV / XLSX ব্যাংক স্টেটমেন্ট জমা দিন।',
    wiz_upload_cta: 'আপলোড',
    wiz_review_title: 'স্বয়ংক্রিয় মিল পর্যালোচনা',
    wiz_review_desc: 'ইঞ্জিনের পরামর্শ নিশ্চিত বা প্রত্যাখ্যান করুন — প্রতিটি ক্রিয়া অডিট লগে রেকর্ড হয়।',
    wiz_review_cta: 'পর্যালোচনা',
    wiz_narrate_title: 'অডিট গল্প তৈরি করুন',
    wiz_narrate_desc: '"এই মিলকে গল্প হিসাবে দেখান" এ ক্লিক করে AI-বর্ণিত ফরেনসিক সারাংশ পান।',
    wiz_narrate_cta: 'লগ খুলুন',
    add_widget: 'উইজেট যোগ', remove_widget: 'সরান',
    sales_title: 'বিক্রয় ব্যবস্থাপনা', sales_subtitle: 'সকল বিক্রয় লেনদেন ট্র্যাক করুন',
    add_new_sale: 'নতুন বিক্রয় যোগ', sale_date: 'বিক্রয়ের তারিখ', sale_amount: 'পরিমাণ',
    payment_details: 'পেমেন্ট বিবরণ', payment_mode: 'পেমেন্ট মোড',
    customer_name: 'গ্রাহকের নাম', sale_items: 'আইটেম', sale_notes: 'নোট',
    credit_amount: 'ক্রেডিট পরিমাণ', all_sales: 'সকল বিক্রয়',
    expenses_title: 'ব্যয়', expenses_subtitle: 'ব্যবসায়িক ব্যয় ট্র্যাক করুন',
    add_expense: 'ব্যয় যোগ', expense_date: 'তারিখ', expense_amount: 'পরিমাণ',
    expense_category: 'ক্যাটাগরি', expense_description: 'বিবরণ',
    all_expenses: 'সকল ব্যয়', total_label: 'মোট',
    employees_title: 'কর্মচারী', employees_subtitle: 'আপনার টিম পরিচালনা',
    add_employee: 'কর্মচারী যোগ', employee_name: 'নাম', employee_phone: 'ফোন',
    employee_email: 'ইমেইল', employee_role: 'পদবী', employee_salary: 'বেতন',
    employee_branch: 'শাখা', employee_status: 'অবস্থা', job_titles: 'পদের শিরোনাম',
    active: 'সক্রিয়', inactive: 'নিষ্ক্রিয়',
    stock_title: 'স্টক ব্যবস্থাপনা', stock_subtitle: 'ইনভেন্টরি ট্র্যাকিং ও নিয়ন্ত্রণ',
    add_item: 'আইটেম যোগ', item_name: 'আইটেমের নাম', item_category: 'ক্যাটাগরি',
    item_unit: 'একক', unit_price: 'একক মূল্য', cost_price: 'খরচ মূল্য',
    min_stock: 'সর্বনিম্ন স্টক', current_stock: 'বর্তমান স্টক', stock_in: 'স্টক ইন',
    stock_out: 'স্টক আউট', stock_value: 'স্টক মূল্য',
    invoices_title: 'চালান', invoices_subtitle: 'ZATCA অনুগত চালান তৈরি ও পরিচালনা',
    create_invoice: 'চালান তৈরি', invoice_number: 'চালান নং', invoice_date: 'তারিখ',
    invoice_customer: 'গ্রাহক', invoice_items: 'আইটেম', invoice_total: 'মোট',
    invoice_status: 'অবস্থা', invoice_paid: 'পরিশোধিত', invoice_unpaid: 'অপরিশোধিত',
    scan_invoice: 'চালান স্ক্যান',
    customers_title: 'গ্রাহক', customers_subtitle: 'গ্রাহক ডাটাবেস ও ক্রেডিট ব্যবস্থাপনা',
    add_customer: 'গ্রাহক যোগ', customer_phone: 'ফোন', customer_balance: 'ব্যালেন্স',
    total_customers: 'মোট গ্রাহক', total_credit: 'মোট ক্রেডিট',
    suppliers_title: 'সরবরাহকারী', suppliers_subtitle: 'সরবরাহকারী ব্যবস্থাপনা ও পেমেন্ট',
    add_supplier: 'সরবরাহকারী যোগ', supplier_name: 'সরবরাহকারীর নাম', supplier_phone: 'ফোন',
    supplier_balance: 'ব্যালেন্স', total_suppliers: 'মোট সরবরাহকারী',
    pos_title: 'দ্রুত এন্ট্রি', pos_customer: 'গ্রাহক', pos_item: 'আইটেম',
    pos_quantity: 'পরিমাণ', pos_price: 'মূল্য', pos_discount: 'ছাড়',
    pos_total: 'মোট', pos_add_item: 'আইটেম যোগ', pos_submit: 'বিক্রয় জমা',
    pos_clear: 'মুছুন', pos_payment_mode: 'পেমেন্ট মোড',
    pos_cash: 'নগদ', pos_bank: 'ব্যাংক', pos_online: 'অনলাইন', pos_credit: 'ক্রেডিট',
    settings_title: 'সেটিংস', settings_subtitle: 'অ্যাপ্লিকেশন কনফিগারেশন',
    email_config: 'ইমেইল SMTP কনফিগারেশন', whatsapp_config: 'হোয়াটসঅ্যাপ কনফিগারেশন',
    company_branding: 'কোম্পানি ব্র্যান্ডিং', scheduler_config: 'নির্ধারিত রিপোর্ট',
    data_management: 'ডাটা ব্যবস্থাপনা', notification_settings: 'বিজ্ঞপ্তি সেটিংস',
    partners_title: 'অংশীদার', partners_subtitle: 'অংশীদার বিনিয়োগ ও লাভ ভাগাভাগি',
    add_partner: 'অংশীদার যোগ', partner_name: 'অংশীদারের নাম',
    share_percentage: 'শেয়ার %', total_invested: 'মোট বিনিয়োগ',
    total_withdrawn: 'মোট উত্তোলন', partner_balance: 'ব্যালেন্স',
    reports_title: 'রিপোর্ট', eod_summary: 'দিনশেষ সারাংশ', partner_pnl: 'অংশীদার লাভ-ক্ষতি',
    daily_summary: 'দৈনিক সারাংশ', top_customers: 'শীর্ষ গ্রাহক',
    cashier_performance: 'ক্যাশিয়ার পারফর্ম্যান্স', generate: 'তৈরি করুন',
    print_report: 'রিপোর্ট প্রিন্ট',
    analytics_title: 'উন্নত বিশ্লেষণ', analytics_subtitle: 'AI চালিত ব্যবসায়িক অন্তর্দৃষ্টি',
    predictive_hub: 'পূর্বাভাস বিশ্লেষণ কেন্দ্র',
    expense_forecast: 'ব্যয় পূর্বাভাস', stock_reorder: 'স্টক পুনঃঅর্ডার',
    revenue_trends: 'আয় প্রবণতা', customer_churn: 'গ্রাহক হারানো',
    margin_optimizer: 'মার্জিন অপটিমাইজার', sales_forecast: 'বিক্রয় পূর্বাভাস',
    viz_title: 'ভিজ্যুয়ালাইজেশন', viz_subtitle: 'উন্নত চার্ট ও ডাটা অনুসন্ধান',
    viz_heatmap: 'হিটম্যাপ', viz_funnel: 'ফানেল', viz_treemap: 'ট্রিম্যাপ',
    viz_gauges: 'গেজ', viz_radar: 'রাডার', viz_waterfall: 'ওয়াটারফল',
    viz_money_flow: 'অর্থ প্রবাহ', viz_compare: 'তুলনা',
    viz_export_png: 'PNG এ এক্সপোর্ট', viz_click_drill: 'বিস্তারিত দেখতে ক্লিক করুন',
    loading: 'লোড হচ্ছে...', save: 'সংরক্ষণ', cancel: 'বাতিল', delete: 'মুছুন',
    edit: 'সম্পাদনা', add: 'যোগ', search: 'অনুসন্ধান', filter: 'ফিল্টার',
    export_btn: 'এক্সপোর্ট', print: 'প্রিন্ট', refresh: 'রিফ্রেশ', close: 'বন্ধ',
    confirm: 'নিশ্চিত', actions: 'কার্যক্রম', status: 'অবস্থা', date: 'তারিখ',
    amount: 'পরিমাণ', description: 'বিবরণ', category: 'ক্যাটাগরি',
    branch: 'শাখা', all_branches: 'সকল শাখা', no_data: 'কোন তথ্য পাওয়া যায়নি',
    name: 'নাম', phone: 'ফোন', email: 'ইমেইল', address: 'ঠিকানা',
    submit: 'জমা', update: 'আপডেট', view: 'দেখুন', download: 'ডাউনলোড',
    dark: 'ডার্ক', light: 'লাইট', shortcuts: 'শর্টকাট', logout: 'লগআউট',
    language: 'ভাষা',
    stock_alert_title: 'আইটেম সর্বনিম্ন স্টকের নিচে',
    stock_alert_view: 'বিস্তারিত দেখুন', stock_alert_hide: 'লুকান',
    go_to_inventory: 'ইনভেন্টরিতে যান',
    transactions: 'লেনদেন', items: 'আইটেম', payments: 'পেমেন্ট',
    overview: 'সংক্ষিপ্ত', period: 'সময়কাল', compare: 'তুলনা', trends: 'প্রবণতা',
    item_pnl: 'আইটেম লাভ-ক্ষতি',
    error_occurred: 'একটি ত্রুটি ঘটেছে', try_again: 'আবার চেষ্টা করুন',
    back: 'পিছনে', next: 'পরবর্তী', previous: 'পূর্ববর্তী',
    sort: 'সাজান', export: 'রপ্তানি', import: 'আমদানি', reset: 'রিসেট', apply: 'প্রয়োগ', clear: 'পরিষ্কার',
    time: 'সময়', orders: 'অর্ডার', notes: 'নোট', payment_date: 'পেমেন্টের তারিখ',
    start_date: 'শুরুর তারিখ', end_date: 'শেষ তারিখ',
    success: 'সফল', failed: 'ব্যর্থ', pending: 'অমীমাংসিত', completed: 'সম্পন্ন',
    in_progress: 'চলমান', cancelled: 'বাতিল',
    shift_report_title: 'দৈনিক শিফট রিপোর্ট', shift_report_subtitle: 'ক্যাশিয়ার শিফট, বিক্রয় বিভাজন, ও নগদ মিলকরণ',
    daily_report: 'দৈনিক রিপোর্ট', date_range: 'তারিখ পরিসর', total_shifts: 'মোট শিফট',
    opening_cash: 'শুরুর নগদ', closing_cash: 'শেষের নগদ', expected_cash: 'প্রত্যাশিত নগদ',
    cash_difference: 'নগদ পার্থক্য', shortage: 'ঘাটতি', overage: 'উদ্বৃত্ত', balanced: 'সমতা',
    payment_breakdown: 'পেমেন্ট পদ্ধতি বিভাজন', sales_by_branch: 'শাখা অনুসারে বিক্রয়',
    shift_details: 'শিফট বিবরণ', top_selling_items: 'শীর্ষ বিক্রয় আইটেম',
    daily_trend: 'দৈনিক বিক্রয় প্রবণতা', daily_breakdown: 'দৈনিক বিভাজন',
    avg_sales_day: 'গড় বিক্রয়/দিন', duration: 'সময়কাল', cashier: 'ক্যাশিয়ার',
    bulk_salary_title: 'বাল্ক বেতন পেমেন্ট', bulk_payment_info: 'একসাথে সকল যোগ্য কর্মচারীকে বেতন দিন।',
    preview_select: 'প্রিভিউ ও কর্মচারী নির্বাচন', to_pay: 'পরিশোধ করতে হবে', already_paid: 'ইতিমধ্যে পরিশোধিত',
    total_amount: 'মোট পরিমাণ', employees_to_pay: 'পরিশোধযোগ্য কর্মচারী', select_all: 'সবাই নির্বাচন',
    pay_employees: 'কর্মচারীদের পরিশোধ', payment_completed: 'পেমেন্ট সম্পন্ন', by_branch: 'শাখা অনুসারে',
    skipped_failed: 'বাদ / ব্যর্থ', monthly_salary_payment: 'মাসিক বেতন পেমেন্ট',
    cat_salary: 'বেতন', cat_rent: 'ভাড়া', cat_utilities: 'ইউটিলিটি', cat_vehicle: 'যানবাহন',
    cat_maintenance: 'রক্ষণাবেক্ষণ', cat_supplier: 'সরবরাহকারী', cat_tickets: 'টিকেট',
    cat_id_card: 'আইডি কার্ড', cat_other: 'অন্যান্য',
    cat_basic_salary: 'মৌলিক বেতন', cat_overtime: 'ওভারটাইম', cat_bonus: 'বোনাস',
    cat_office_rent: 'অফিস ভাড়া', cat_warehouse_rent: 'গোদাম ভাড়া', cat_shop_rent: 'দোকান ভাড়া',
    cat_electricity: 'বিদ্যুৎ', cat_water: 'পানি', cat_internet: 'ইন্টারনেট', cat_phone: 'ফোন',
    cat_fuel: 'জ্বালানি', cat_insurance: 'বীমা', cat_office_maintenance: 'অফিস রক্ষণাবেক্ষণ',
    cat_equipment_repair: 'সরঞ্জাম মেরামত',
    widget_stats: 'মূল পরিসংখ্যান', widget_charts: 'দ্রুত চার্ট', widget_cash_bank: 'নগদ ও ব্যাংক',
    widget_payment_mode: 'পেমেন্ট মোড', widget_spending: 'ব্যয় বিবরণ',
    widget_dues: 'বকেয়া ও সতর্কতা', widget_branch_dues: 'শাখা বকেয়া', widget_vat: 'ভ্যাট সারাংশ',
    widget_desc_stats: 'বিক্রয়, ব্যয়, লাভের সংক্ষিপ্ত', widget_desc_charts: 'ব্যয় বিতরণ ও তুলনা',
    widget_desc_cash: 'নগদ ও ব্যাংক ব্যালেন্স', widget_desc_payment: 'নগদ, ব্যাংক, ক্রেডিট বিভাজন',
    widget_desc_spending: 'ব্যয় ক্যাটাগরি ও খরচ', widget_desc_dues: 'সরবরাহকারী বকেয়া, জরিমানা, সতর্কতা',
    widget_desc_branch: 'আন্তঃশাখা ব্যালেন্স', widget_desc_vat: 'ভ্যাট গণনা',
    show_all: 'সব দেখান', minimize: 'ছোট করুন', done: 'সম্পন্ন',
    // AI Widget translations
    ai_low_stock: 'AI: স্টক সতর্কতা', ai_low_stock_desc: 'ফুরিয়ে যাওয়া আইটেম',
    ai_peak_hours: 'AI: ব্যস্ত সময়', ai_peak_hours_desc: 'স্টাফ পরিকল্পনা',
    ai_customer_clv: 'AI: গ্রাহক মূল্য', ai_customer_clv_desc: 'জীবনকালীন মূল্য পূর্বাভাস',
    ai_profit_analysis: 'AI: লাভ বিশ্লেষণ', ai_profit_analysis_desc: 'দৈনিক লাভের প্রবণতা',
    items_at_risk: 'ঝুঁকিতে আইটেম', all_stock_healthy: 'সব স্টক স্তর সুস্থ',
    days_left: 'দিন বাকি', stock_level: 'স্টক', reorder_point: 'রিঅর্ডার',
    based_on_transactions: '{count} লেনদেনের উপর ভিত্তি করে', peak_hours_staff: 'এই সময়ে অতিরিক্ত স্টাফ রাখুন',
    of_traffic: 'ট্রাফিক', projected_revenue: '১২ মাসের প্রত্যাশিত আয়',
    lifetime_value: 'জীবনকালীন মূল্য', orders_active: 'অর্ডার', days_active: 'দিন সক্রিয়',
    add_customers_clv: 'CLV দেখতে গ্রাহক যোগ করুন', avg_daily_profit: 'গড় দৈনিক লাভ',
    trend: 'প্রবণতা', improving: 'উন্নতি', declining: 'অবনতি', stable: 'স্থিতিশীল',
    best_day: 'সেরা', worst_day: 'সবচেয়ে খারাপ', not_enough_data: 'বিশ্লেষণের জন্য পর্যাপ্ত ডেটা নেই',
    // Quick Actions
    quick_actions: 'দ্রুত কাজ', qa_record_sale: 'বিক্রয় রেকর্ড', qa_add_expense: 'ব্যয় যোগ',
    qa_pay_supplier: 'সরবরাহকারী পেমেন্ট', qa_new_invoice: 'নতুন চালান', qa_approve_leave: 'ছুটি অনুমোদন',
    qa_pay_salary: 'বেতন দিন', qa_add_customer: 'গ্রাহক যোগ', qa_view_reports: 'রিপোর্ট দেখুন',
    qa_stock_entry: 'স্টক এন্ট্রি', qa_cctv_live: 'লাইভ ক্যামেরা', qa_available: 'উপলব্ধ',
    qa_no_actions: 'আপনার ভূমিকার জন্য কোনো দ্রুত কাজ উপলব্ধ নেই',
    menu_items: 'মেনু আইটেম', nav_menu_items: 'মেনু আইটেম',
    order_status: 'অর্ডার অবস্থা', preparing: 'প্রস্তুত হচ্ছে', ready_pickup: 'নিতে প্রস্তুত',
    documents_title: 'নথিপত্র', fines_title: 'জরিমানা ও শাস্তি',
    company_loans_title: 'কোম্পানি ঋণ', users_title: 'ব্যবহারকারী',
    branches_title: 'শাখা', schedule_title: 'শিফট শিডিউল',
    leave_title: 'ছুটি অনুমোদন', cash_transfers_title: 'নগদ স্থানান্তর',
    bank_statements_title: 'ব্যাংক স্টেটমেন্ট', reconciliation_title: 'মিলকরণ',
    credit_report_title: 'ক্রেডিট রিপোর্ট', supplier_report_title: 'সরবরাহকারী রিপোর্ট',
    category_report_title: 'ক্যাটাগরি রিপোর্ট', kitchen_title: 'রান্নাঘর ডিসপ্লে',
    notifications_title: 'বিজ্ঞপ্তি', help_title: 'সাহায্য ও গাইড',
    portal_title: 'কর্মচারী পোর্টাল',
    cctv_title: 'CCTV নিরাপত্তা', cctv_subtitle: 'AI চালিত ভিডিও নজরদারি',
    live_view: 'লাইভ ভিউ', face_recognition: 'মুখ শনাক্তকরণ', object_detection: 'বস্তু শনাক্তকরণ',
    people_count: 'জনসংখ্যা গণনা', motion_analysis: 'গতি বিশ্লেষণ', alerts: 'সতর্কতা',
    devices: 'ডিভাইস', register_face: 'মুখ নিবন্ধন', registered_faces: 'নিবন্ধিত মুখ',
    face_attendance: 'মুখ শনাক্তকরণ উপস্থিতি', detect_objects: 'বস্তু শনাক্ত',
    count_people: 'মানুষ গণনা', analyze_motion: 'গতি বিশ্লেষণ',
    crowd_density: 'ভিড়ের ঘনত্ব', motion_detected: 'গতি শনাক্ত', security_concern: 'নিরাপত্তা সংশয়',
    no_cameras: 'কোনো ক্যামেরা কনফিগার করা হয়নি', upload_image: 'ছবি আপলোড', run_analysis: 'বিশ্লেষণ চালান',
    scheduled_monitoring: 'নির্ধারিত AI মনিটরিং', monitoring_interval: 'মনিটরিং ব্যবধান',
    enable_monitoring: 'নির্ধারিত মনিটরিং সক্রিয়', run_now: 'এখনই চালান',
    notification_channels: 'বিজ্ঞপ্তি চ্যানেল', in_app: 'অ্যাপে', whatsapp: 'হোয়াটসঅ্যাপ',
    partner_pl_title: 'অংশীদার লাভ-ক্ষতি রিপোর্ট', partner_pl_subtitle: 'অংশীদার মালিকানা অনুসারে লাভ-ক্ষতি',
    company_summary: 'কোম্পানি সারাংশ', partner_breakdown: 'অংশীদার বিভাজন',
    expense_categories: 'ব্যয় ক্যাটাগরি', payment_modes: 'পেমেন্ট মোড',
    revenue: 'আয়', gross_profit: 'মোট লাভ', operating_expenses: 'পরিচালন ব্যয়',
    profit_share: 'লাভের অংশ', ownership_percentage: 'মালিকানা %', investments: 'বিনিয়োগ',
    withdrawals: 'উত্তোলন', current_balance: 'বর্তমান ব্যালেন্স', available_withdrawal: 'উত্তোলনযোগ্য',
    zatca_phase2: 'ZATCA ফেজ ২', zatca_compliance: 'ZATCA সম্মতি',
    generate_xml: 'XML চালান তৈরি', submit_zatca: 'ZATCA-তে জমা',
    xml_invoice: 'XML চালান', qr_code: 'QR কোড', invoice_uuid: 'চালান UUID',
    digital_signature: 'ডিজিটাল স্বাক্ষর', csid_required: 'CSID প্রয়োজন',
    b2b_invoice: 'B2B ট্যাক্স চালান', b2c_invoice: 'সরলীকৃত ট্যাক্স চালান',
    customize_nav: 'বটম নেভিগেশন কাস্টমাইজ', reset_default: 'ডিফল্টে রিসেট',
    select_items: '৫টি পর্যন্ত আইটেম নির্বাচন করুন', more: 'আরো',
    ai_hub_title: 'AI ব্যবসা হাব', ai_supplier_intel: 'সরবরাহকারী বুদ্ধিমত্তা',
    ai_pricing_opt: 'মূল্য অপ্টিমাইজেশন', ai_churn: 'গ্রাহক ক্ষতি', ai_marketing: 'মার্কেটিং',
    ai_insights: 'AI অন্তর্দৃষ্টি', active: 'সক্রিয়', inactive: 'নিষ্ক্রিয়',
    nav_ai_hub: 'AI হাব', nav_ai_forecast: 'AI পূর্বাভাস', nav_cross_branch: 'ক্রস-শাখা রিপোর্ট',
    // Page titles
    attendance_title: 'উপস্থিতি ড্যাশবোর্ড', payroll_title: 'বেতন ব্যবস্থাপনা',
    performance_title: 'পারফরম্যান্স ও রিভিউ', training_title: 'প্রশিক্ষণ ব্যবস্থাপনা',
    recruitment_title: 'নিয়োগ', leave_cal_title: 'ছুটি ব্যবস্থাপনা',
    emp_docs_title: 'কর্মচারী নথি', hr_analytics_title: 'HR বিশ্লেষণ',
    balance_sheet_title: 'ব্যালেন্স শীট', pnl_title: 'লাভ ও ক্ষতি',
    journal_title: 'জার্নাল এন্ট্রি', coa_title: 'অ্যাকাউন্ট চার্ট',
    bills_title: 'বিল', daily_summary_title: 'দৈনিক সারসংক্ষেপ',
    cashier_pos_title: 'রেস্তোরাঁ POS', activity_logs_title: 'কার্যকলাপ লগ',
    loan_mgmt_title: 'ঋণ ব্যবস্থাপনা', currency_settings_title: 'মুদ্রা সেটিংস',
    // Common
    total_employees: 'মোট কর্মচারী', today: 'আজ', paid: 'পরিশোধিত', unpaid: 'অপরিশোধিত',
    approved: 'অনুমোদিত', rejected: 'প্রত্যাখ্যাত', debit: 'ডেবিট', credit: 'ক্রেডিট',
    balance: 'ব্যালেন্স', revenue: 'রাজস্ব', profit: 'লাভ', loss: 'ক্ষতি',
    monthly: 'মাসিক', weekly: 'সাপ্তাহিক', daily: 'দৈনিক',
    no_results: 'কোনো ফলাফল নেই', details: 'বিস্তারিত', summary: 'সারসংক্ষেপ',
    // Accounting & Reports
    active_employees: 'সক্রিয় কর্মচারী', activity_logs_subtitle: 'ব্যবহারকারীর কার্যকলাপ ট্র্যাক করুন',
    aging_title: 'এজিং রিপোর্ট', ai_action: 'পদক্ষেপ', ai_at_risk_revenue: 'ঝুঁকিতে রাজস্ব',
    ai_audience: 'দর্শক', ai_avg_margin: 'গড় মার্জিন', ai_avg_order: 'গড় অর্ডার',
    ai_avg_value: 'গড় গ্রাহক মান', ai_best_day: 'সেরা দিন', ai_campaign_suggestions: 'প্রচারণা পরামর্শ',
    ai_channel: 'চ্যানেল', ai_churned: 'চলে গেছে', ai_cost: 'খরচ', ai_current: 'বর্তমান',
    ai_customer_risk: 'গ্রাহক ঝুঁকি বিশ্লেষণ', ai_days_inactive: 'নিষ্ক্রিয় দিন', ai_high_risk: 'উচ্চ ঝুঁকি',
    ai_hub_load_error: 'ডেটা লোড হয়নি', ai_hub_subtitle: 'AI ব্যবসা বুদ্ধিমত্তা এবং অপ্টিমাইজেশন',
    ai_item: 'আইটেম', ai_items_analyzed: 'বিশ্লেষিত আইটেম', ai_keep: 'রাখুন', ai_margin: 'মার্জিন',
    ai_price_increase: 'বৃদ্ধি', ai_pricing_recs: 'মূল্য পরামর্শ', ai_revenue_90d: '৯০ দিন রাজস্ব',
    ai_revenue_impact: '৩০ দিন রাজস্ব প্রভাব', ai_risk_distribution: 'ঝুঁকি বিতরণ', ai_risk_level: 'ঝুঁকি',
    ai_sold_90d: '৯০ দিন বিক্রয়', ai_suggested: 'প্রস্তাবিত', ai_supplier_perf: 'সরবরাহকারী কর্মক্ষমতা',
    ai_target: 'লক্ষ্য', ai_top_products: 'শীর্ষ পণ্য (৯০ দিন)', ai_top_suppliers: 'শীর্ষ সরবরাহকারী',
    ai_total_customers: 'মোট গ্রাহক', ai_total_paid: 'মোট প্রদত্ত', ai_total_spent: 'মোট ব্যয়',
    ai_transactions: 'লেনদেন', ai_vip_customers: 'VIP গ্রাহক', ai_worst_day: 'সবচেয়ে খারাপ দিন',
    analyze_motion: 'গতি বিশ্লেষণ', anomaly_subtitle: 'AI বিক্রয় ও ব্যয় স্ক্যানিং', anomaly_title: 'অসঙ্গতি সনাক্তকরণ',
    as_of_date: 'তারিখ পর্যন্ত', audit_trail_title: 'অডিট ট্রেইল',
    b2b_invoice: 'B2B কর চালান', b2c_invoice: 'সরল কর চালান',
    bi_dashboard_title: 'BI ড্যাশবোর্ড', bills_subtitle: 'সরবরাহকারী বিল এবং পেমেন্ট',
    cash_flow_title: 'নগদ প্রবাহ বিবরণী', closed: 'বন্ধ', coa_subtitle: 'অ্যাকাউন্টিং কাঠামো পরিচালনা',
    count_people: 'মানুষ গণনা', country_laws_title: 'দেশ শ্রম আইন',
    created_at: 'তৈরি হয়েছে', created_by: 'তৈরিকারী',
    cross_branch_breakdown: 'শাখা-ভিত্তিক বিবরণ', cross_branch_comparison: 'শাখা তুলনা',
    cross_branch_converted_profit: 'রূপান্তরিত লাভ', cross_branch_converted_sales: 'রূপান্তরিত বিক্রয়',
    cross_branch_local_expenses: 'স্থানীয় ব্যয়', cross_branch_local_sales: 'স্থানীয় বিক্রয়',
    cross_branch_rate: 'হার', cross_branch_revenue_share: 'শাখা অনুসারে রাজস্ব ভাগ',
    cross_branch_subtitle: 'আন্তর্জাতিক শাখা তুলনা', cross_branch_title: 'মাল্টি-ব্রাঞ্চ আর্থিক রিপোর্ট',
    crowd_density: 'ভিড়ের ঘনত্ব', csid_required: 'CSID প্রয়োজন',
    custom_range: 'কাস্টম রেঞ্জ', data_export_title: 'ডেটা রপ্তানি', data_mgmt_title: 'ডেটা ব্যবস্থাপনা',
    detect_objects: 'বস্তু সনাক্তকরণ', digital_signature: 'ডিজিটাল স্বাক্ষর', discount: 'ছাড়',
    draft: 'খসড়া', end_date: 'শেষ তারিখ', entries: 'এন্ট্রি', expenses: 'খরচ',
    face_attendance: 'মুখ চিনতে উপস্থিতি', financial_dashboard_title: 'আর্থিক ড্যাশবোর্ড',
    financial_ratios_title: 'আর্থিক স্বাস্থ্য ড্যাশবোর্ড',
    from_date: 'থেকে', general_ledger_title: 'সাধারণ খাতা', grand_total: 'মোট যোগফল',
    inv_avg_daily: 'গড় দৈনিক বিক্রয়', inv_daily_demand: 'দৈনিক চাহিদা',
    inv_days_left: 'বাকি দিন', inv_demand_reorder: 'চাহিদা ও রি-অর্ডার',
    inv_forecast_subtitle: 'AI চাহিদা পূর্বাভাস', inv_forecast_title: 'AI ইনভেন্টরি পূর্বাভাস',
    inv_items_tracked: 'ট্র্যাক করা আইটেম', inv_need_reorder: 'রি-অর্ডার প্রয়োজন',
    inv_projected_sales: 'প্রত্যাশিত বিক্রয়', inv_reorder_qty: 'রি-অর্ডার পরিমাণ', inv_stock: 'স্টক',
    invoice_uuid: 'চালান UUID', journal_subtitle: 'ডেবিট ও ক্রেডিট এন্ট্রি',
    last_month: 'গত মাস', leave_cal_subtitle: 'ছুটির ক্যালেন্ডার ভিউ',
    loan_mgmt_subtitle: 'কর্মচারী ঋণ ও কিস্তি', menu_analytics_title: 'মেনু বিশ্লেষণ',
    motion_detected: 'গতি সনাক্ত হয়েছে',
    nav_aging_reports: 'এজিং রিপোর্ট', nav_anomaly_detection: 'অসঙ্গতি সনাক্তকরণ', nav_cash_flow: 'নগদ প্রবাহ',
    nav_general_ledger: 'সাধারণ খাতা', nav_pnl_compare: 'P&L তুলনা',
    nav_rate_limits: 'হার সীমা', nav_recurring_entries: 'পুনরাবৃত্তি এন্ট্রি', nav_trial_balance: 'ট্রায়াল ব্যালেন্স',
    no_cameras: 'কোনো ক্যামেরা নেই', notes: 'নোটস', of: 'এর', open: 'খোলা', orders: 'অর্ডার',
    overdue: 'মেয়াদোত্তীর্ণ', partial: 'আংশিক', payment_date: 'পেমেন্ট তারিখ',
    performance_subtitle: 'পর্যালোচনা, লক্ষ্য এবং শৃঙ্খলামূলক পদক্ষেপ', planned: 'পরিকল্পিত',
    pnl_compare_title: 'P&L তুলনা', pos_config_title: 'POS কনফিগারেশন',
    qr_code: 'QR কোড', quantity: 'পরিমাণ',
    rate_limit_current_usage: 'বর্তমান ব্যবহার', rate_limit_override: 'কাস্টম সীমা',
    rate_limit_plan: 'পরিকল্পনা', rate_limit_role: 'ভূমিকা',
    rate_limit_subtitle: 'API ব্যবহার পর্যবেক্ষণ', rate_limit_tiers: 'হার সীমা স্তর',
    rate_limit_title: 'API হার সীমা', rate_limit_top_users: 'শীর্ষ API ব্যবহারকারী',
    rate_limit_user_breakdown: 'ব্যবহারকারী বিবরণ', rate_limit_your_limit: 'আপনার সীমা',
    rate_limit_your_status: 'আপনার হার সীমা অবস্থা',
    recruitment_subtitle: 'চাকরি, আবেদন ও সাক্ষাৎকার', recurring_entries_title: 'পুনরাবৃত্তি জার্নাল এন্ট্রি',
    role_mgmt_title: 'ভূমিকা ও অনুমতি', run_analysis: 'বিশ্লেষণ চালান',
    sales_alerts_title: 'বিক্রয় সতর্কতা', sales_forecast_title: 'AI বিক্রয় বিশ্লেষণ',
    scheduled_reports_title: 'নির্ধারিত রিপোর্ট', security_concern: 'নিরাপত্তা উদ্বেগ',
    select_branch: 'শাখা নির্বাচন', select_category: 'বিভাগ নির্বাচন',
    select_date: 'তারিখ নির্বাচন', select_status: 'অবস্থা নির্বাচন',
    showing: 'দেখাচ্ছে', staff_perf_subtitle: 'উপস্থিতি ও দায়িত্ব',
    staff_perf_title: 'কর্মী কর্মক্ষমতা', start_date: 'শুরুর তারিখ',
    stock_reorder_title: 'AI স্টক বিশ্লেষণ', subtotal: 'উপ-মোট',
    success_created: 'সফলভাবে তৈরি হয়েছে', success_updated: 'সফলভাবে আপডেট হয়েছে',
    take_tour: 'ট্যুর নিন', tax: 'কর', this_month: 'এই মাসে', this_week: 'এই সপ্তাহে',
    time: 'সময়', to_date: 'পর্যন্ত', total: 'মোট', total_documents: 'মোট নথি',
    total_headcount: 'মোট কর্মচারী', tour_back: 'পিছনে', tour_completed: 'ট্যুর সম্পন্ন! ড্যাশবোর্ড দেখুন',
    tour_finish: 'শেষ', tour_next: 'পরবর্তী', tour_skip: 'ট্যুর বাদ দিন',
    tour_step: 'ধাপ {current} / {total}', tour_welcome: 'Smarto-এ স্বাগতম!',
    tour_welcome_desc: 'আসুন আপনার নতুন ব্যবসা ড্যাশবোর্ডের সাথে পরিচিত করাই',
    trial_balance_title: 'ট্রায়াল ব্যালেন্স', updated_at: 'আপডেট হয়েছে',
    upload_image: 'ছবি আপলোড', xml_invoice: 'XML চালান', yearly: 'বার্ষিক', yesterday: 'গতকাল',
    history: 'ইতিহাস', confirm_delete: 'আপনি কি নিশ্চিত মুছে ফেলতে চান?',
    success_saved: 'সফলভাবে সংরক্ষিত', success_deleted: 'সফলভাবে মুছে ফেলা হয়েছে',
  },
  fr: {
    // Navigation
    nav_operations: 'Operations', nav_finance: 'Finance', nav_people: 'Personnel',
    nav_stock: 'Stock', nav_reports: 'Rapports', nav_assets: 'Actifs', nav_admin: 'Admin',
    nav_sales_revenue: 'Ventes & Revenus', nav_expenses_payables: 'Depenses & Paiements',
    nav_hr_workforce: 'RH & Personnel', nav_pos_inventory: 'PDV & Inventaire',
    nav_accounting: 'Comptabilite',
    nav_dashboard: 'Tableau de bord', nav_quick_entry: 'Saisie rapide', nav_live_analytics: 'Analyse en direct',
    nav_sales: 'Ventes', nav_invoices: 'Factures', nav_expenses: 'Depenses',
    nav_supplier_payments: 'Paiements fournisseurs', nav_cash_transfers: 'Transferts',
    nav_customers: 'Clients', nav_suppliers: 'Fournisseurs', nav_employees: 'Employes',
    nav_leave_approvals: 'Conges', nav_schedule: 'Planning',
    nav_inventory: 'Inventaire', nav_transfers: 'Transferts', nav_kitchen: 'Cuisine',
    nav_analytics: 'Analyses', nav_visualizations: 'Visualisations', nav_reports_page: 'Rapports',
    nav_credit_report: 'Rapport credit', nav_supplier_report: 'Rapport fournisseur',
    nav_category_report: 'Rapport categorie', nav_bank_statements: 'Releves bancaires',
    nav_reconciliation: 'Rapprochement', nav_branches: 'Succursales', nav_documents: 'Documents',
    nav_fines: 'Amendes', nav_partners: 'Partenaires', nav_company_loans: 'Prets',
    nav_users: 'Utilisateurs', nav_settings: 'Parametres', nav_help: 'Aide & Guide',
    nav_menu_items: 'Articles du menu',
    // Help
    help_sales: 'Enregistrez les ventes quotidiennes, suivi des paiements especes/carte/credit',
    help_expenses: 'Suivez les depenses par categorie, fournisseur et mode de paiement',
    help_hr: 'Gerez les employes, salaires, conges, presence et documents',
    help_pos: 'Configurez le point de vente selon votre secteur d\'activite',
    help_accounting: 'Journaux comptables, bilan et compte de resultat',
    help_reports: 'Analyses avancees, previsions et rapports personnalises',
    // Dashboard
    dash_title: 'Tableau de bord', dash_subtitle: 'Vue d\'ensemble',
    total_sales: 'Total ventes', total_expenses: 'Total depenses', net_profit: 'Benefice net',
    supplier_payments: 'Paiements fournisseurs', pending_credits: 'Credits en attente',
    today_vs_yesterday: 'vs hier', recent_sales: 'Ventes recentes', expense_breakdown: 'Repartition des depenses',
    quick_actions: 'Actions rapides', new_sale: 'Nouvelle vente', new_expense: 'Nouvelle depense',
    view_reports: 'Voir les rapports', cash_balance: 'Solde especes', bank_balance: 'Solde banque',
    customize_widgets: 'Personnaliser', reset_layout: 'Reinitialiser',
    // Reconciliation Wizard
    wiz_title: 'Réconciliation en 3 étapes',
    wiz_subtitle: 'Transformez les relevés bancaires bruts en correspondances auto, journaux d\'audit et récits forensiques narrés par IA.',
    wiz_step: 'Étape', wiz_done: 'Terminé',
    wiz_upload_title: 'Téléverser un relevé',
    wiz_upload_desc: 'Déposez un relevé bancaire CSV / XLSX pour alimenter le moteur de correspondance intelligent.',
    wiz_upload_cta: 'Téléverser',
    wiz_review_title: 'Vérifier les correspondances auto',
    wiz_review_desc: 'Confirmez ou rejetez les suggestions du moteur — chaque action est journalisée dans l\'audit.',
    wiz_review_cta: 'Vérifier',
    wiz_narrate_title: 'Générer le récit d\'audit',
    wiz_narrate_desc: 'Cliquez sur "Rejouer cette correspondance" pour obtenir un résumé forensique narré par IA.',
    wiz_narrate_cta: 'Ouvrir le journal',
    add_widget: 'Ajouter section', remove_widget: 'Supprimer',
    // Sales
    sales_title: 'Gestion des ventes', sales_subtitle: 'Suivre toutes les transactions',
    add_new_sale: 'Nouvelle vente', sale_date: 'Date', sale_amount: 'Montant',
    payment_details: 'Details du paiement', payment_mode: 'Mode de paiement',
    customer_name: 'Nom du client', sale_items: 'Articles', sale_notes: 'Notes',
    credit_amount: 'Montant credit', all_sales: 'Toutes les ventes',
    // Expenses
    expenses_title: 'Depenses', expenses_subtitle: 'Suivre les depenses',
    add_expense: 'Ajouter depense', expense_date: 'Date', expense_amount: 'Montant',
    expense_category: 'Categorie', expense_description: 'Description',
    all_expenses: 'Toutes les depenses', total_label: 'Total',
    // Employees
    employees_title: 'Employes', employees_subtitle: 'Gerer votre equipe',
    add_employee: 'Ajouter employe', employee_name: 'Nom', employee_phone: 'Telephone',
    employee_email: 'Email', employee_role: 'Role', employee_salary: 'Salaire',
    employee_branch: 'Succursale', employee_status: 'Statut', job_titles: 'Titres de poste',
    active: 'Actif', inactive: 'Inactif',
    // Stock
    stock_title: 'Gestion de stock', stock_subtitle: 'Suivi et controle d\'inventaire',
    add_item: 'Ajouter article', item_name: 'Nom', item_category: 'Categorie',
    item_unit: 'Unite', unit_price: 'Prix de vente', cost_price: 'Prix de revient',
    min_stock: 'Stock min', current_stock: 'Stock actuel', stock_in: 'Entree stock',
    stock_out: 'Sortie stock', stock_value: 'Valeur du stock',
    // Invoices
    invoices_title: 'Factures', invoices_subtitle: 'Gerer les factures',
    create_invoice: 'Creer facture', invoice_number: 'N° facture', invoice_date: 'Date',
    invoice_customer: 'Client', invoice_items: 'Articles', invoice_total: 'Total',
    invoice_status: 'Statut', invoice_paid: 'Payee', invoice_unpaid: 'Impayee',
    scan_invoice: 'Scanner facture',
    // Customers
    customers_title: 'Clients', customers_subtitle: 'Base de donnees clients',
    add_customer: 'Ajouter client', customer_phone: 'Telephone', customer_balance: 'Solde',
    total_customers: 'Total clients', total_credit: 'Total credit',
    // Suppliers
    suppliers_title: 'Fournisseurs', suppliers_subtitle: 'Gestion des fournisseurs',
    add_supplier: 'Ajouter fournisseur', supplier_name: 'Nom', supplier_phone: 'Telephone',
    supplier_balance: 'Solde', total_suppliers: 'Total fournisseurs',
    // POS
    pos_title: 'Saisie rapide', pos_customer: 'Client', pos_item: 'Article',
    pos_quantity: 'Quantite', pos_price: 'Prix', pos_discount: 'Remise',
    pos_total: 'Total', pos_add_item: 'Ajouter article', pos_submit: 'Valider la vente',
    pos_clear: 'Effacer', pos_payment_mode: 'Mode de paiement',
    pos_cash: 'Especes', pos_bank: 'Banque', pos_online: 'En ligne', pos_credit: 'Credit',
    // Settings
    settings_title: 'Parametres', settings_subtitle: 'Configuration',
    email_config: 'Configuration email', whatsapp_config: 'Configuration WhatsApp',
    company_branding: 'Image de marque', scheduler_config: 'Rapports programmes',
    data_management: 'Gestion des donnees', notification_settings: 'Parametres de notification',
    // Partners
    partners_title: 'Partenaires', partners_subtitle: 'Investissements et partage des benefices',
    add_partner: 'Ajouter partenaire', partner_name: 'Nom',
    share_percentage: 'Part %', total_invested: 'Total investi',
    total_withdrawn: 'Total retire', partner_balance: 'Solde',
    // Reports
    reports_title: 'Rapports', eod_summary: 'Resume fin de journee', partner_pnl: 'P&L Partenaires',
    daily_summary: 'Resume quotidien', top_customers: 'Meilleurs clients',
    cashier_performance: 'Performance caissier', generate: 'Generer', print_report: 'Imprimer',
    // Analytics
    analytics_title: 'Analyses avancees', analytics_subtitle: 'Analyses IA',
    predictive_hub: 'Centre d\'analyse predictive',
    expense_forecast: 'Prevision depenses', stock_reorder: 'Reapprovisionnement',
    revenue_trends: 'Tendances revenus', customer_churn: 'Attrition client',
    margin_optimizer: 'Optimiseur de marge', sales_forecast: 'Prevision ventes',
    // Visualizations
    viz_title: 'Visualisations', viz_subtitle: 'Graphiques avances',
    viz_heatmap: 'Carte thermique', viz_funnel: 'Entonnoir', viz_treemap: 'Treemap',
    viz_gauges: 'Jauges', viz_radar: 'Radar', viz_waterfall: 'Cascade',
    viz_money_flow: 'Flux monetaire', viz_compare: 'Comparer',
    viz_export_png: 'Exporter en image', viz_click_drill: 'Cliquer pour details',
    // Common UI
    loading: 'Chargement...', save: 'Enregistrer', cancel: 'Annuler', delete: 'Supprimer',
    edit: 'Modifier', add: 'Ajouter', search: 'Rechercher', filter: 'Filtrer',
    export_btn: 'Exporter', print: 'Imprimer', refresh: 'Actualiser', close: 'Fermer',
    confirm: 'Confirmer', actions: 'Actions', status: 'Statut', date: 'Date',
    amount: 'Montant', description: 'Description', category: 'Categorie',
    branch: 'Succursale', all_branches: 'Toutes les succursales', no_data: 'Aucune donnee',
    name: 'Nom', phone: 'Telephone', email: 'Email', address: 'Adresse',
    submit: 'Soumettre', update: 'Mettre a jour', view: 'Voir', download: 'Telecharger',
    dark: 'Sombre', light: 'Clair', shortcuts: 'Raccourcis', logout: 'Deconnexion',
    language: 'Langue', more: 'Plus',
    error_occurred: 'Une erreur est survenue', try_again: 'Reessayer',
    back: 'Retour', next: 'Suivant', previous: 'Precedent',
    sort: 'Trier', export: 'Exporter', import: 'Importer',
    reset: 'Reinitialiser', apply: 'Appliquer', clear: 'Effacer',
    // Status
    success: 'Succes', failed: 'Echec', pending: 'En attente', completed: 'Termine',
    in_progress: 'En cours', cancelled: 'Annule',
    // Shift Report
    shift_report_title: 'Rapport de quart', shift_report_subtitle: 'Quarts de caisse et reconciliation',
    daily_report: 'Rapport quotidien', date_range: 'Periode', total_shifts: 'Total quarts',
    opening_cash: 'Caisse ouverture', closing_cash: 'Caisse fermeture', expected_cash: 'Caisse attendue',
    cash_difference: 'Ecart de caisse', shortage: 'Deficit', overage: 'Excedent', balanced: 'Equilibre',
    payment_breakdown: 'Repartition des paiements', sales_by_branch: 'Ventes par succursale',
    shift_details: 'Details du quart', top_selling_items: 'Articles les plus vendus',
    daily_trend: 'Tendance quotidienne', daily_breakdown: 'Detail quotidien',
    avg_sales_day: 'Ventes moy./jour', duration: 'Duree', cashier: 'Caissier',
    // Bulk Salary
    bulk_salary_title: 'Paiement groupé des salaires', preview_select: 'Apercu et selection',
    to_pay: 'A payer', already_paid: 'Deja paye', total_amount: 'Montant total',
    employees_to_pay: 'Employes a payer', select_all: 'Tout selectionner',
    pay_employees: 'Payer les employes', payment_completed: 'Paiement effectue', by_branch: 'Par succursale',
    // Expense Categories
    cat_salary: 'Salaire', cat_rent: 'Loyer', cat_utilities: 'Services', cat_vehicle: 'Vehicule',
    cat_maintenance: 'Maintenance', cat_supplier: 'Fournisseur', cat_tickets: 'Billets',
    cat_id_card: 'Carte d\'identite', cat_other: 'Autre',
    cat_basic_salary: 'Salaire de base', cat_overtime: 'Heures sup', cat_bonus: 'Prime',
    cat_office_rent: 'Loyer bureau', cat_warehouse_rent: 'Loyer entrepot', cat_shop_rent: 'Loyer magasin',
    cat_electricity: 'Electricite', cat_water: 'Eau', cat_internet: 'Internet', cat_phone: 'Telephone',
    cat_fuel: 'Carburant', cat_insurance: 'Assurance', cat_office_maintenance: 'Maintenance bureau',
    cat_equipment_repair: 'Reparation equipement',
    // Widgets
    widget_stats: 'Statistiques', widget_charts: 'Graphiques rapides', widget_cash_bank: 'Especes & Banque',
    widget_payment_mode: 'Modes de paiement', widget_spending: 'Details depenses',
    widget_dues: 'Echeances & Alertes', widget_branch_dues: 'Echeances succursales', widget_vat: 'Resume TVA',
    show_all: 'Tout afficher', minimize: 'Reduire', done: 'Termine',
    // AI
    ai_hub_title: 'Hub IA Entreprise', ai_hub_subtitle: 'Intelligence d\'affaires IA',
    ai_supplier_intel: 'Intelligence Fournisseur', ai_pricing_opt: 'Optimisation des Prix',
    ai_churn: 'Attrition Client', ai_marketing: 'Marketing',
    ai_insights: 'Analyses IA', ai_hub_load_error: 'Echec du chargement',
    ai_total_customers: 'Total clients', ai_churned: 'Perdus', ai_high_risk: 'Risque eleve',
    ai_campaign_suggestions: 'Suggestions de campagne', ai_best_day: 'Meilleur jour', ai_worst_day: 'Pire jour',
    nav_ai_hub: 'Hub IA', nav_ai_forecast: 'Previsions IA', nav_cross_branch: 'Rapport Inter-Succursales',
    nav_anomaly_detection: 'Detection d\'anomalies',
    inv_forecast_title: 'Previsions inventaire IA', cross_branch_title: 'Rapport multi-succursales',
    // Page titles
    attendance_title: 'Tableau de Presence', payroll_title: 'Gestion de la Paie',
    performance_title: 'Performance et Evaluations', training_title: 'Formation',
    recruitment_title: 'Recrutement', leave_cal_title: 'Gestion des Conges',
    emp_docs_title: 'Documents Employes', hr_analytics_title: 'Analyses RH',
    balance_sheet_title: 'Bilan', pnl_title: 'Compte de Resultat',
    journal_title: 'Ecritures Comptables', coa_title: 'Plan Comptable',
    bills_title: 'Factures fournisseurs', daily_summary_title: 'Resume Quotidien',
    cashier_pos_title: 'PDV Restaurant', activity_logs_title: 'Journal d\'activite',
    audit_trail_title: 'Piste d\'audit', currency_settings_title: 'Parametres de Devise',
    role_mgmt_title: 'Roles et Permissions', country_laws_title: 'Lois du travail',
    loan_mgmt_title: 'Gestion des Prets', staff_perf_title: 'Performance du personnel',
    anomaly_title: 'Detection d\'anomalies', pos_config_title: 'Configuration PDV',
    data_mgmt_title: 'Gestion des donnees', data_export_title: 'Export de donnees',
    stock_reorder_title: 'Analyse IA du stock', sales_forecast_title: 'Analyse IA des ventes',
    sales_alerts_title: 'Alertes ventes', menu_analytics_title: 'Analyses du menu',
    bi_dashboard_title: 'Tableau BI', financial_dashboard_title: 'Tableau financier',
    financial_ratios_title: 'Tableau de sante financiere',
    scheduled_reports_title: 'Rapports programmes',
    // Common fields
    total_employees: 'Total employes', active_employees: 'Employes actifs',
    today: 'Aujourd\'hui', yesterday: 'Hier', this_week: 'Cette semaine',
    this_month: 'Ce mois', last_month: 'Mois dernier',
    paid: 'Paye', unpaid: 'Impaye', overdue: 'En retard', partial: 'Partiel',
    approved: 'Approuve', rejected: 'Rejete',
    debit: 'Debit', credit: 'Credit', balance: 'Solde',
    revenue: 'Revenus', expenses: 'Depenses', profit: 'Benefice', loss: 'Perte',
    monthly: 'Mensuel', weekly: 'Hebdomadaire', daily: 'Quotidien', yearly: 'Annuel',
    no_results: 'Aucun resultat', details: 'Details', summary: 'Resume', history: 'Historique',
    confirm_delete: 'Etes-vous sur de vouloir supprimer ?',
    success_saved: 'Enregistre avec succes', success_deleted: 'Supprime avec succes',
    success_updated: 'Mis a jour avec succes', success_created: 'Cree avec succes',
    // Other pages
    documents_title: 'Documents', fines_title: 'Amendes et Penalites',
    company_loans_title: 'Prets', users_title: 'Utilisateurs', branches_title: 'Succursales',
    schedule_title: 'Planning des quarts', leave_title: 'Approbation des conges',
    cash_transfers_title: 'Transferts', bank_statements_title: 'Releves bancaires',
    reconciliation_title: 'Rapprochement', credit_report_title: 'Rapport credit',
    supplier_report_title: 'Rapport fournisseur', category_report_title: 'Rapport categorie',
    kitchen_title: 'Affichage cuisine', notifications_title: 'Notifications',
    help_title: 'Aide et Guide', portal_title: 'Portail employe',
    cctv_title: 'Video surveillance', menu_items: 'Articles du menu',
    order_status: 'Statut commande', preparing: 'En preparation', ready_pickup: 'Pret',
    stock_alert_title: 'articles sous le seuil minimum',
    transactions: 'transactions', items: 'articles', payments: 'paiements',
    overview: 'Apercu', period: 'Periode', compare: 'Comparer', trends: 'Tendances',
    nav_rate_limits: 'Limites API',
    rate_limit_title: 'Limites de debit API', rate_limit_subtitle: 'Surveiller et configurer les limites d\'utilisation',
  },
  es: {
    // Navigation
    nav_operations: 'Operaciones', nav_finance: 'Finanzas', nav_people: 'Personal',
    nav_stock: 'Inventario', nav_reports: 'Informes', nav_assets: 'Activos', nav_admin: 'Admin',
    nav_sales_revenue: 'Ventas e Ingresos', nav_expenses_payables: 'Gastos y Pagos',
    nav_hr_workforce: 'RRHH y Personal', nav_pos_inventory: 'TPV e Inventario',
    nav_accounting: 'Contabilidad',
    nav_dashboard: 'Panel', nav_quick_entry: 'Entrada rapida', nav_live_analytics: 'Analisis en vivo',
    nav_sales: 'Ventas', nav_invoices: 'Facturas', nav_expenses: 'Gastos',
    nav_supplier_payments: 'Pagos a proveedores', nav_cash_transfers: 'Transferencias',
    nav_customers: 'Clientes', nav_suppliers: 'Proveedores', nav_employees: 'Empleados',
    nav_leave_approvals: 'Permisos', nav_schedule: 'Horario',
    nav_inventory: 'Inventario', nav_transfers: 'Transferencias', nav_kitchen: 'Cocina',
    nav_analytics: 'Analisis', nav_visualizations: 'Visualizaciones', nav_reports_page: 'Informes',
    nav_credit_report: 'Informe de credito', nav_supplier_report: 'Informe de proveedor',
    nav_category_report: 'Informe de categoria', nav_bank_statements: 'Extractos bancarios',
    nav_reconciliation: 'Conciliacion', nav_branches: 'Sucursales', nav_documents: 'Documentos',
    nav_fines: 'Multas', nav_partners: 'Socios', nav_company_loans: 'Prestamos',
    nav_users: 'Usuarios', nav_settings: 'Configuracion', nav_help: 'Ayuda y Guia',
    nav_menu_items: 'Articulos del menu',
    // Help
    help_sales: 'Registre ventas diarias, seguimiento de pagos efectivo/tarjeta/credito',
    help_expenses: 'Controle gastos por categoria, proveedor y metodo de pago',
    help_hr: 'Gestione empleados, nominas, permisos, asistencia y documentos',
    help_pos: 'Configure el punto de venta segun su tipo de negocio',
    help_accounting: 'Asientos contables, balance general y estado de resultados',
    help_reports: 'Analisis avanzados, previsiones e informes personalizados',
    // Dashboard
    dash_title: 'Panel', dash_subtitle: 'Vista general del negocio',
    total_sales: 'Total ventas', total_expenses: 'Total gastos', net_profit: 'Beneficio neto',
    supplier_payments: 'Pagos proveedores', pending_credits: 'Creditos pendientes',
    today_vs_yesterday: 'vs ayer', recent_sales: 'Ventas recientes', expense_breakdown: 'Desglose de gastos',
    quick_actions: 'Acciones rapidas', new_sale: 'Nueva venta', new_expense: 'Nuevo gasto',
    view_reports: 'Ver informes', cash_balance: 'Saldo efectivo', bank_balance: 'Saldo banco',
    customize_widgets: 'Personalizar', reset_layout: 'Restablecer',
    // Reconciliation Wizard
    wiz_title: 'Conciliación en 3 pasos',
    wiz_subtitle: 'Convierte extractos bancarios en coincidencias auto, registros de auditoría e historias forenses narradas por IA.',
    wiz_step: 'Paso', wiz_done: 'Listo',
    wiz_upload_title: 'Subir extracto',
    wiz_upload_desc: 'Suelta un extracto bancario CSV / XLSX para alimentar el motor inteligente.',
    wiz_upload_cta: 'Subir',
    wiz_review_title: 'Revisar coincidencias',
    wiz_review_desc: 'Confirma o rechaza las sugerencias — cada acción queda en el registro.',
    wiz_review_cta: 'Revisar',
    wiz_narrate_title: 'Generar historia',
    wiz_narrate_desc: 'Haz clic en "Reproducir como historia" para un resumen forense narrado por IA.',
    wiz_narrate_cta: 'Abrir registro',
    add_widget: 'Agregar seccion', remove_widget: 'Eliminar',
    // Sales
    sales_title: 'Gestion de ventas', sales_subtitle: 'Seguimiento de transacciones',
    add_new_sale: 'Nueva venta', sale_date: 'Fecha', sale_amount: 'Monto',
    payment_details: 'Detalles del pago', payment_mode: 'Metodo de pago',
    customer_name: 'Nombre del cliente', sale_items: 'Articulos', sale_notes: 'Notas',
    credit_amount: 'Monto a credito', all_sales: 'Todas las ventas',
    // Expenses
    expenses_title: 'Gastos', expenses_subtitle: 'Control de gastos',
    add_expense: 'Agregar gasto', expense_date: 'Fecha', expense_amount: 'Monto',
    expense_category: 'Categoria', expense_description: 'Descripcion',
    all_expenses: 'Todos los gastos', total_label: 'Total',
    // Employees
    employees_title: 'Empleados', employees_subtitle: 'Gestion de equipo',
    add_employee: 'Agregar empleado', employee_name: 'Nombre', employee_phone: 'Telefono',
    employee_email: 'Email', employee_role: 'Cargo', employee_salary: 'Salario',
    employee_branch: 'Sucursal', employee_status: 'Estado', job_titles: 'Cargos',
    active: 'Activo', inactive: 'Inactivo',
    // Stock
    stock_title: 'Gestion de inventario', stock_subtitle: 'Seguimiento y control',
    add_item: 'Agregar articulo', item_name: 'Nombre', item_category: 'Categoria',
    item_unit: 'Unidad', unit_price: 'Precio de venta', cost_price: 'Precio de costo',
    min_stock: 'Stock min', current_stock: 'Stock actual', stock_in: 'Entrada',
    stock_out: 'Salida', stock_value: 'Valor de inventario',
    // Invoices
    invoices_title: 'Facturas', invoices_subtitle: 'Gestion de facturas',
    create_invoice: 'Crear factura', invoice_number: 'N° factura', invoice_date: 'Fecha',
    invoice_customer: 'Cliente', invoice_items: 'Articulos', invoice_total: 'Total',
    invoice_status: 'Estado', invoice_paid: 'Pagada', invoice_unpaid: 'Impaga',
    scan_invoice: 'Escanear factura',
    // Customers
    customers_title: 'Clientes', customers_subtitle: 'Base de datos de clientes',
    add_customer: 'Agregar cliente', customer_phone: 'Telefono', customer_balance: 'Saldo',
    total_customers: 'Total clientes', total_credit: 'Total credito',
    // Suppliers
    suppliers_title: 'Proveedores', suppliers_subtitle: 'Gestion de proveedores',
    add_supplier: 'Agregar proveedor', supplier_name: 'Nombre', supplier_phone: 'Telefono',
    supplier_balance: 'Saldo', total_suppliers: 'Total proveedores',
    // POS
    pos_title: 'Entrada rapida', pos_customer: 'Cliente', pos_item: 'Articulo',
    pos_quantity: 'Cantidad', pos_price: 'Precio', pos_discount: 'Descuento',
    pos_total: 'Total', pos_add_item: 'Agregar articulo', pos_submit: 'Registrar venta',
    pos_clear: 'Limpiar', pos_payment_mode: 'Metodo de pago',
    pos_cash: 'Efectivo', pos_bank: 'Banco', pos_online: 'En linea', pos_credit: 'Credito',
    // Settings
    settings_title: 'Configuracion', settings_subtitle: 'Parametros del sistema',
    email_config: 'Configuracion de email', whatsapp_config: 'Configuracion de WhatsApp',
    company_branding: 'Marca de la empresa', scheduler_config: 'Informes programados',
    data_management: 'Gestion de datos', notification_settings: 'Configuracion de notificaciones',
    // Partners
    partners_title: 'Socios', partners_subtitle: 'Inversiones y reparto de beneficios',
    add_partner: 'Agregar socio', partner_name: 'Nombre',
    share_percentage: 'Porcentaje %', total_invested: 'Total invertido',
    total_withdrawn: 'Total retirado', partner_balance: 'Saldo',
    // Reports
    reports_title: 'Informes', eod_summary: 'Resumen del dia', partner_pnl: 'P&L Socios',
    daily_summary: 'Resumen diario', top_customers: 'Mejores clientes',
    cashier_performance: 'Rendimiento cajero', generate: 'Generar', print_report: 'Imprimir',
    // Analytics
    analytics_title: 'Analisis avanzados', analytics_subtitle: 'Inteligencia con IA',
    predictive_hub: 'Centro de analisis predictivo',
    expense_forecast: 'Prevision de gastos', stock_reorder: 'Reabastecimiento',
    revenue_trends: 'Tendencias de ingresos', customer_churn: 'Perdida de clientes',
    margin_optimizer: 'Optimizador de margen', sales_forecast: 'Prevision de ventas',
    // Visualizations
    viz_title: 'Visualizaciones', viz_subtitle: 'Graficos avanzados',
    viz_heatmap: 'Mapa de calor', viz_funnel: 'Embudo', viz_treemap: 'Treemap',
    viz_gauges: 'Indicadores', viz_radar: 'Radar', viz_waterfall: 'Cascada',
    viz_money_flow: 'Flujo de dinero', viz_compare: 'Comparar',
    viz_export_png: 'Exportar imagen', viz_click_drill: 'Clic para detalles',
    // Common UI
    loading: 'Cargando...', save: 'Guardar', cancel: 'Cancelar', delete: 'Eliminar',
    edit: 'Editar', add: 'Agregar', search: 'Buscar', filter: 'Filtrar',
    export_btn: 'Exportar', print: 'Imprimir', refresh: 'Actualizar', close: 'Cerrar',
    confirm: 'Confirmar', actions: 'Acciones', status: 'Estado', date: 'Fecha',
    amount: 'Monto', description: 'Descripcion', category: 'Categoria',
    branch: 'Sucursal', all_branches: 'Todas las sucursales', no_data: 'Sin datos',
    name: 'Nombre', phone: 'Telefono', email: 'Email', address: 'Direccion',
    submit: 'Enviar', update: 'Actualizar', view: 'Ver', download: 'Descargar',
    dark: 'Oscuro', light: 'Claro', shortcuts: 'Atajos', logout: 'Cerrar sesion',
    language: 'Idioma', more: 'Mas',
    error_occurred: 'Ocurrio un error', try_again: 'Reintentar',
    back: 'Atras', next: 'Siguiente', previous: 'Anterior',
    sort: 'Ordenar', export: 'Exportar', import: 'Importar',
    reset: 'Restablecer', apply: 'Aplicar', clear: 'Limpiar',
    // Status
    success: 'Exito', failed: 'Fallido', pending: 'Pendiente', completed: 'Completado',
    in_progress: 'En progreso', cancelled: 'Cancelado',
    // Shift Report
    shift_report_title: 'Informe de turno', shift_report_subtitle: 'Turnos de caja y conciliacion',
    daily_report: 'Informe diario', date_range: 'Periodo', total_shifts: 'Total turnos',
    opening_cash: 'Caja apertura', closing_cash: 'Caja cierre', expected_cash: 'Caja esperada',
    cash_difference: 'Diferencia', shortage: 'Deficit', overage: 'Excedente', balanced: 'Equilibrado',
    payment_breakdown: 'Desglose de pagos', sales_by_branch: 'Ventas por sucursal',
    shift_details: 'Detalles del turno', top_selling_items: 'Mas vendidos',
    daily_trend: 'Tendencia diaria', daily_breakdown: 'Detalle diario',
    avg_sales_day: 'Ventas prom./dia', duration: 'Duracion', cashier: 'Cajero',
    // Bulk Salary
    bulk_salary_title: 'Pago masivo de salarios', preview_select: 'Vista previa y seleccion',
    to_pay: 'Por pagar', already_paid: 'Ya pagado', total_amount: 'Monto total',
    employees_to_pay: 'Empleados a pagar', select_all: 'Seleccionar todos',
    pay_employees: 'Pagar empleados', payment_completed: 'Pago completado', by_branch: 'Por sucursal',
    // Expense Categories
    cat_salary: 'Salario', cat_rent: 'Alquiler', cat_utilities: 'Servicios', cat_vehicle: 'Vehiculo',
    cat_maintenance: 'Mantenimiento', cat_supplier: 'Proveedor', cat_tickets: 'Boletos',
    cat_id_card: 'Cedula', cat_other: 'Otro',
    cat_basic_salary: 'Salario base', cat_overtime: 'Horas extra', cat_bonus: 'Bono',
    cat_office_rent: 'Alquiler oficina', cat_warehouse_rent: 'Alquiler almacen', cat_shop_rent: 'Alquiler tienda',
    cat_electricity: 'Electricidad', cat_water: 'Agua', cat_internet: 'Internet', cat_phone: 'Telefono',
    cat_fuel: 'Combustible', cat_insurance: 'Seguro', cat_office_maintenance: 'Mantenimiento oficina',
    cat_equipment_repair: 'Reparacion de equipos',
    // Widgets
    widget_stats: 'Estadisticas', widget_charts: 'Graficos rapidos', widget_cash_bank: 'Efectivo y Banco',
    widget_payment_mode: 'Metodos de pago', widget_spending: 'Detalle de gastos',
    widget_dues: 'Vencimientos', widget_branch_dues: 'Vencimientos sucursal', widget_vat: 'Resumen IVA',
    show_all: 'Mostrar todo', minimize: 'Minimizar', done: 'Listo',
    // AI
    ai_hub_title: 'Hub IA Empresarial', ai_hub_subtitle: 'Inteligencia empresarial IA',
    ai_supplier_intel: 'Inteligencia de Proveedores', ai_pricing_opt: 'Optimizacion de Precios',
    ai_churn: 'Perdida de Clientes', ai_marketing: 'Marketing',
    ai_insights: 'Analisis IA', ai_hub_load_error: 'Error al cargar',
    ai_total_customers: 'Total clientes', ai_churned: 'Perdidos', ai_high_risk: 'Alto riesgo',
    ai_campaign_suggestions: 'Sugerencias de campana', ai_best_day: 'Mejor dia', ai_worst_day: 'Peor dia',
    nav_ai_hub: 'Hub IA', nav_ai_forecast: 'Pronostico IA', nav_cross_branch: 'Informe Inter-Sucursales',
    nav_anomaly_detection: 'Deteccion de anomalias',
    inv_forecast_title: 'Prevision de inventario IA', cross_branch_title: 'Informe multi-sucursal',
    // Page titles
    attendance_title: 'Panel de Asistencia', payroll_title: 'Gestion de Nomina',
    performance_title: 'Rendimiento y Evaluaciones', training_title: 'Capacitacion',
    recruitment_title: 'Reclutamiento', leave_cal_title: 'Gestion de Permisos',
    emp_docs_title: 'Documentos de Empleados', hr_analytics_title: 'Analisis de RRHH',
    balance_sheet_title: 'Balance General', pnl_title: 'Estado de Resultados',
    journal_title: 'Asientos Contables', coa_title: 'Plan de Cuentas',
    bills_title: 'Facturas de proveedores', daily_summary_title: 'Resumen Diario',
    cashier_pos_title: 'TPV Restaurante', activity_logs_title: 'Registro de Actividad',
    audit_trail_title: 'Pista de auditoria', currency_settings_title: 'Configuracion de Moneda',
    role_mgmt_title: 'Roles y Permisos', country_laws_title: 'Leyes laborales',
    loan_mgmt_title: 'Gestion de Prestamos', staff_perf_title: 'Rendimiento del personal',
    anomaly_title: 'Deteccion de anomalias', pos_config_title: 'Configuracion TPV',
    data_mgmt_title: 'Gestion de datos', data_export_title: 'Exportar datos',
    stock_reorder_title: 'Analisis IA de stock', sales_forecast_title: 'Analisis IA de ventas',
    // Common
    total_employees: 'Total empleados', today: 'Hoy', yesterday: 'Ayer',
    this_month: 'Este mes', last_month: 'Mes anterior',
    paid: 'Pagado', unpaid: 'Sin pagar', overdue: 'Vencido',
    approved: 'Aprobado', rejected: 'Rechazado',
    debit: 'Debito', credit: 'Credito', balance: 'Saldo',
    revenue: 'Ingresos', expenses: 'Gastos', profit: 'Ganancia', loss: 'Perdida',
    monthly: 'Mensual', weekly: 'Semanal', daily: 'Diario',
    no_results: 'Sin resultados', details: 'Detalles', summary: 'Resumen', history: 'Historial',
    confirm_delete: 'Esta seguro de que desea eliminar?',
    success_saved: 'Guardado con exito', success_deleted: 'Eliminado con exito',
    // Other pages
    documents_title: 'Documentos', fines_title: 'Multas y Penalidades',
    company_loans_title: 'Prestamos', users_title: 'Usuarios', branches_title: 'Sucursales',
    schedule_title: 'Horario de turnos', leave_title: 'Aprobacion de permisos',
    cash_transfers_title: 'Transferencias', bank_statements_title: 'Extractos bancarios',
    reconciliation_title: 'Conciliacion', credit_report_title: 'Informe de credito',
    supplier_report_title: 'Informe de proveedor', category_report_title: 'Informe de categoria',
    kitchen_title: 'Pantalla de cocina', notifications_title: 'Notificaciones',
    help_title: 'Ayuda y Guia', portal_title: 'Portal del empleado',
    cctv_title: 'Videovigilancia', menu_items: 'Articulos del menu',
    order_status: 'Estado del pedido', preparing: 'Preparando', ready_pickup: 'Listo',
    stock_alert_title: 'articulos bajo stock minimo',
    transactions: 'transacciones', items: 'articulos', payments: 'pagos',
    overview: 'Vista general', period: 'Periodo', compare: 'Comparar', trends: 'Tendencias',
    nav_rate_limits: 'Limites API',
    rate_limit_title: 'Limites de velocidad API', rate_limit_subtitle: 'Monitorear y configurar limites de uso',
  },
  tr: {
    // Navigation
    nav_operations: 'Islemler', nav_finance: 'Finans', nav_people: 'Personel',
    nav_stock: 'Stok', nav_reports: 'Raporlar', nav_assets: 'Varliklar', nav_admin: 'Yonetim',
    nav_sales_revenue: 'Satis ve Gelir', nav_expenses_payables: 'Gider ve Odemeler',
    nav_hr_workforce: 'IK ve Personel', nav_pos_inventory: 'POS ve Envanter',
    nav_accounting: 'Muhasebe',
    nav_dashboard: 'Kontrol Paneli', nav_quick_entry: 'Hizli Giris', nav_live_analytics: 'Canli Analiz',
    nav_sales: 'Satislar', nav_invoices: 'Faturalar', nav_expenses: 'Giderler',
    nav_supplier_payments: 'Tedarikci Odemeleri', nav_cash_transfers: 'Transferler',
    nav_customers: 'Musteriler', nav_suppliers: 'Tedarikciler', nav_employees: 'Calisanlar',
    nav_leave_approvals: 'Izin Onaylari', nav_schedule: 'Vardiya',
    nav_inventory: 'Envanter', nav_transfers: 'Transferler', nav_kitchen: 'Mutfak',
    nav_analytics: 'Analizler', nav_visualizations: 'Gorsellestirme', nav_reports_page: 'Raporlar',
    nav_credit_report: 'Kredi Raporu', nav_supplier_report: 'Tedarikci Raporu',
    nav_category_report: 'Kategori Raporu', nav_bank_statements: 'Banka Ekstresi',
    nav_reconciliation: 'Mutabakat', nav_branches: 'Subeler', nav_documents: 'Belgeler',
    nav_fines: 'Cezalar', nav_partners: 'Ortaklar', nav_company_loans: 'Krediler',
    nav_users: 'Kullanicilar', nav_settings: 'Ayarlar', nav_help: 'Yardim ve Rehber',
    nav_menu_items: 'Menu Ogeler',
    // Help
    help_sales: 'Gunluk satislari kaydedin, nakit/kart/kredi odemelerini takip edin',
    help_expenses: 'Giderleri kategori, tedarikci ve odeme yontemine gore izleyin',
    help_hr: 'Calisanlari, maas bordrosu, izin, devamlilik ve belgeleri yonetin',
    help_pos: 'POS sisteminizi is turunuze gore yapilandirin',
    help_accounting: 'Muhasebe kayitlari, bilanco ve gelir tablosu',
    help_reports: 'Gelismis analizler, tahminler ve ozel raporlar',
    // Dashboard
    dash_title: 'Kontrol Paneli', dash_subtitle: 'Is ozeti',
    total_sales: 'Toplam satis', total_expenses: 'Toplam gider', net_profit: 'Net kar',
    supplier_payments: 'Tedarikci odemeleri', pending_credits: 'Bekleyen krediler',
    today_vs_yesterday: 'vs dun', recent_sales: 'Son satislar', expense_breakdown: 'Gider dagilimi',
    quick_actions: 'Hizli islemler', new_sale: 'Yeni satis', new_expense: 'Yeni gider',
    view_reports: 'Raporlari gor', cash_balance: 'Nakit bakiye', bank_balance: 'Banka bakiye',
    customize_widgets: 'Ozellestir', reset_layout: 'Sifirla',
    // Reconciliation Wizard
    wiz_title: '3 adimda mutabakat',
    wiz_subtitle: 'Ham banka ekstrelerini otomatik eslesme, denetim kayitlari ve YZ-anlatimli adli hikayelere donusturun.',
    wiz_step: 'Adim', wiz_done: 'Tamam',
    wiz_upload_title: 'Ekstre yukle',
    wiz_upload_desc: 'Akilli eslesme motoru icin bir CSV / XLSX banka ekstresi birakin.',
    wiz_upload_cta: 'Yukle',
    wiz_review_title: 'Otomatik eslesmeleri incele',
    wiz_review_desc: 'Motorun onerilerini onayla veya reddet — her islem denetim kaydina yazilir.',
    wiz_review_cta: 'Incele',
    wiz_narrate_title: 'Denetim hikayesi olustur',
    wiz_narrate_desc: '"Bu eslesmeyi hikaye olarak tekrarla" icin tikla, YZ-anlatimli adli ozet al.',
    wiz_narrate_cta: 'Kaydi ac',
    add_widget: 'Bolum ekle', remove_widget: 'Kaldir',
    // Sales
    sales_title: 'Satis yonetimi', sales_subtitle: 'Tum islemleri takip edin',
    add_new_sale: 'Yeni satis', sale_date: 'Tarih', sale_amount: 'Tutar',
    payment_details: 'Odeme detaylari', payment_mode: 'Odeme yontemi',
    customer_name: 'Musteri adi', sale_items: 'Urunler', sale_notes: 'Notlar',
    credit_amount: 'Kredi tutari', all_sales: 'Tum satislar',
    // Expenses
    expenses_title: 'Giderler', expenses_subtitle: 'Giderleri takip edin',
    add_expense: 'Gider ekle', expense_date: 'Tarih', expense_amount: 'Tutar',
    expense_category: 'Kategori', expense_description: 'Aciklama',
    all_expenses: 'Tum giderler', total_label: 'Toplam',
    // Employees
    employees_title: 'Calisanlar', employees_subtitle: 'Ekibinizi yonetin',
    add_employee: 'Calisan ekle', employee_name: 'Ad', employee_phone: 'Telefon',
    employee_email: 'E-posta', employee_role: 'Gorev', employee_salary: 'Maas',
    employee_branch: 'Sube', employee_status: 'Durum', job_titles: 'Unvanlar',
    active: 'Aktif', inactive: 'Pasif',
    // Stock
    stock_title: 'Stok yonetimi', stock_subtitle: 'Envanter takip ve kontrol',
    add_item: 'Urun ekle', item_name: 'Urun adi', item_category: 'Kategori',
    item_unit: 'Birim', unit_price: 'Satis fiyati', cost_price: 'Maliyet fiyati',
    min_stock: 'Min stok', current_stock: 'Mevcut stok', stock_in: 'Stok girisi',
    stock_out: 'Stok cikisi', stock_value: 'Stok degeri',
    // Invoices
    invoices_title: 'Faturalar', invoices_subtitle: 'Fatura yonetimi',
    create_invoice: 'Fatura olustur', invoice_number: 'Fatura no', invoice_date: 'Tarih',
    invoice_customer: 'Musteri', invoice_items: 'Kalemler', invoice_total: 'Toplam',
    invoice_status: 'Durum', invoice_paid: 'Odendi', invoice_unpaid: 'Odenmedi',
    scan_invoice: 'Fatura tara',
    // Customers
    customers_title: 'Musteriler', customers_subtitle: 'Musteri veritabani',
    add_customer: 'Musteri ekle', customer_phone: 'Telefon', customer_balance: 'Bakiye',
    total_customers: 'Toplam musteri', total_credit: 'Toplam kredi',
    // Suppliers
    suppliers_title: 'Tedarikciler', suppliers_subtitle: 'Tedarikci yonetimi',
    add_supplier: 'Tedarikci ekle', supplier_name: 'Ad', supplier_phone: 'Telefon',
    supplier_balance: 'Bakiye', total_suppliers: 'Toplam tedarikci',
    // POS
    pos_title: 'Hizli giris', pos_customer: 'Musteri', pos_item: 'Urun',
    pos_quantity: 'Miktar', pos_price: 'Fiyat', pos_discount: 'Indirim',
    pos_total: 'Toplam', pos_add_item: 'Urun ekle', pos_submit: 'Satisi kaydet',
    pos_clear: 'Temizle', pos_payment_mode: 'Odeme yontemi',
    pos_cash: 'Nakit', pos_bank: 'Banka', pos_online: 'Online', pos_credit: 'Kredi',
    // Settings
    settings_title: 'Ayarlar', settings_subtitle: 'Sistem ayarlari',
    email_config: 'E-posta ayarlari', whatsapp_config: 'WhatsApp ayarlari',
    company_branding: 'Sirket markasi', scheduler_config: 'Zamanlanmis raporlar',
    data_management: 'Veri yonetimi', notification_settings: 'Bildirim ayarlari',
    // Partners
    partners_title: 'Ortaklar', partners_subtitle: 'Yatirim ve kar paylasimi',
    add_partner: 'Ortak ekle', partner_name: 'Ad',
    share_percentage: 'Pay %', total_invested: 'Toplam yatirim',
    total_withdrawn: 'Toplam cekim', partner_balance: 'Bakiye',
    // Reports
    reports_title: 'Raporlar', eod_summary: 'Gun sonu ozeti', partner_pnl: 'Ortak K&Z',
    daily_summary: 'Gunluk ozet', top_customers: 'En iyi musteriler',
    cashier_performance: 'Kasiyer performansi', generate: 'Olustur', print_report: 'Yazdir',
    // Analytics
    analytics_title: 'Gelismis analizler', analytics_subtitle: 'Yapay zeka destekli analizler',
    predictive_hub: 'Tahmin merkezi',
    expense_forecast: 'Gider tahmini', stock_reorder: 'Stok yenileme',
    revenue_trends: 'Gelir trendleri', customer_churn: 'Musteri kaybi',
    margin_optimizer: 'Marj optimizasyonu', sales_forecast: 'Satis tahmini',
    // Visualizations
    viz_title: 'Gorsellestirme', viz_subtitle: 'Gelismis grafikler',
    viz_heatmap: 'Isi haritasi', viz_funnel: 'Huni', viz_treemap: 'Agac haritasi',
    viz_gauges: 'Gostergeler', viz_radar: 'Radar', viz_waterfall: 'Selale',
    viz_money_flow: 'Para akisi', viz_compare: 'Karsilastir',
    viz_export_png: 'Gorsel olarak aktar', viz_click_drill: 'Detay icin tikla',
    // Common UI
    loading: 'Yukleniyor...', save: 'Kaydet', cancel: 'Iptal', delete: 'Sil',
    edit: 'Duzenle', add: 'Ekle', search: 'Ara', filter: 'Filtrele',
    export_btn: 'Disari aktar', print: 'Yazdir', refresh: 'Yenile', close: 'Kapat',
    confirm: 'Onayla', actions: 'Islemler', status: 'Durum', date: 'Tarih',
    amount: 'Tutar', description: 'Aciklama', category: 'Kategori',
    branch: 'Sube', all_branches: 'Tum subeler', no_data: 'Veri yok',
    name: 'Ad', phone: 'Telefon', email: 'E-posta', address: 'Adres',
    submit: 'Gonder', update: 'Guncelle', view: 'Goruntule', download: 'Indir',
    dark: 'Karanlik', light: 'Aydinlik', shortcuts: 'Kisayollar', logout: 'Cikis',
    language: 'Dil', more: 'Daha fazla',
    error_occurred: 'Bir hata olustu', try_again: 'Tekrar dene',
    back: 'Geri', next: 'Ileri', previous: 'Onceki',
    sort: 'Sirala', export: 'Disari aktar', import: 'Iceri aktar',
    reset: 'Sifirla', apply: 'Uygula', clear: 'Temizle',
    // Status
    success: 'Basarili', failed: 'Basarisiz', pending: 'Beklemede', completed: 'Tamamlandi',
    in_progress: 'Devam ediyor', cancelled: 'Iptal edildi',
    // Shift Report
    shift_report_title: 'Vardiya raporu', shift_report_subtitle: 'Kasa vardiyeleri ve mutabakat',
    daily_report: 'Gunluk rapor', date_range: 'Tarih araligi', total_shifts: 'Toplam vardiya',
    opening_cash: 'Acilis kasasi', closing_cash: 'Kapanis kasasi', expected_cash: 'Beklenen kasa',
    cash_difference: 'Kasa farki', shortage: 'Acik', overage: 'Fazla', balanced: 'Dengeli',
    payment_breakdown: 'Odeme dagilimi', sales_by_branch: 'Subelere gore satislar',
    shift_details: 'Vardiya detaylari', top_selling_items: 'En cok satanlar',
    daily_trend: 'Gunluk trend', daily_breakdown: 'Gunluk detay',
    avg_sales_day: 'Ort. satis/gun', duration: 'Sure', cashier: 'Kasiyer',
    // Bulk Salary
    bulk_salary_title: 'Toplu maas odemesi', preview_select: 'Onizle ve sec',
    to_pay: 'Odenecek', already_paid: 'Odenmis', total_amount: 'Toplam tutar',
    employees_to_pay: 'Odenecek calisanlar', select_all: 'Tumunu sec',
    pay_employees: 'Calisanlara ode', payment_completed: 'Odeme tamamlandi', by_branch: 'Subeye gore',
    // Expense Categories
    cat_salary: 'Maas', cat_rent: 'Kira', cat_utilities: 'Faturalar', cat_vehicle: 'Arac',
    cat_maintenance: 'Bakim', cat_supplier: 'Tedarikci', cat_tickets: 'Biletler',
    cat_id_card: 'Kimlik', cat_other: 'Diger',
    cat_basic_salary: 'Temel maas', cat_overtime: 'Fazla mesai', cat_bonus: 'Prim',
    cat_office_rent: 'Ofis kirasi', cat_warehouse_rent: 'Depo kirasi', cat_shop_rent: 'Dukkan kirasi',
    cat_electricity: 'Elektrik', cat_water: 'Su', cat_internet: 'Internet', cat_phone: 'Telefon',
    cat_fuel: 'Yakit', cat_insurance: 'Sigorta', cat_office_maintenance: 'Ofis bakimi',
    cat_equipment_repair: 'Ekipman onarimi',
    // Widgets
    widget_stats: 'Istatistikler', widget_charts: 'Hizli grafikler', widget_cash_bank: 'Nakit & Banka',
    widget_payment_mode: 'Odeme yontemleri', widget_spending: 'Gider detaylari',
    widget_dues: 'Vadeler ve Uyarilar', widget_branch_dues: 'Sube vadeleri', widget_vat: 'KDV ozeti',
    show_all: 'Tumunu goster', minimize: 'Kucult', done: 'Bitti',
    // AI
    ai_hub_title: 'AI Is Merkezi', ai_hub_subtitle: 'AI destekli is zekasi',
    ai_supplier_intel: 'Tedarikci Zekasi', ai_pricing_opt: 'Fiyat Optimizasyonu',
    ai_churn: 'Musteri Kaybi', ai_marketing: 'Pazarlama',
    ai_insights: 'AI Analizleri', ai_hub_load_error: 'Yukleme hatasi',
    ai_total_customers: 'Toplam musteri', ai_churned: 'Kaybedilen', ai_high_risk: 'Yuksek risk',
    ai_campaign_suggestions: 'Kampanya onerileri', ai_best_day: 'En iyi gun', ai_worst_day: 'En kotu gun',
    nav_ai_hub: 'AI Merkezi', nav_ai_forecast: 'AI Tahmin', nav_cross_branch: 'Sube Arasi Rapor',
    nav_anomaly_detection: 'Anomali tespiti',
    inv_forecast_title: 'AI envanter tahmini', cross_branch_title: 'Coklu sube raporu',
    // Page titles
    attendance_title: 'Devamlilik Paneli', payroll_title: 'Maas Bordrosu',
    performance_title: 'Performans ve Degerlendirme', training_title: 'Egitim',
    recruitment_title: 'Ise Alim', leave_cal_title: 'Izin Yonetimi',
    emp_docs_title: 'Calisan Belgeleri', hr_analytics_title: 'IK Analizleri',
    balance_sheet_title: 'Bilanco', pnl_title: 'Gelir Tablosu',
    journal_title: 'Muhasebe Kayitlari', coa_title: 'Hesap Plani',
    bills_title: 'Tedarikci faturalari', daily_summary_title: 'Gunluk Ozet',
    cashier_pos_title: 'Restoran POS', activity_logs_title: 'Etkinlik Gunlugu',
    audit_trail_title: 'Denetim izi', currency_settings_title: 'Para Birimi Ayarlari',
    role_mgmt_title: 'Roller ve Yetkiler', country_laws_title: 'Is kanunlari',
    loan_mgmt_title: 'Kredi Yonetimi', staff_perf_title: 'Personel performansi',
    anomaly_title: 'Anomali tespiti', pos_config_title: 'POS yapilandirmasi',
    data_mgmt_title: 'Veri yonetimi', data_export_title: 'Veri aktarimi',
    stock_reorder_title: 'AI stok analizi', sales_forecast_title: 'AI satis analizi',
    // Common
    total_employees: 'Toplam Calisan', today: 'Bugun', yesterday: 'Dun',
    this_month: 'Bu ay', last_month: 'Gecen ay',
    paid: 'Odendi', unpaid: 'Odenmedi', overdue: 'Gecikmi',
    approved: 'Onaylandi', rejected: 'Reddedildi',
    debit: 'Borc', credit: 'Alacak', balance: 'Bakiye',
    revenue: 'Gelir', expenses: 'Giderler', profit: 'Kar', loss: 'Zarar',
    monthly: 'Aylik', weekly: 'Haftalik', daily: 'Gunluk',
    no_results: 'Sonuc bulunamadi', details: 'Detaylar', summary: 'Ozet', history: 'Gecmis',
    confirm_delete: 'Silmek istediginize emin misiniz?',
    success_saved: 'Basariyla kaydedildi', success_deleted: 'Basariyla silindi',
    // Other pages
    documents_title: 'Belgeler', fines_title: 'Cezalar',
    company_loans_title: 'Krediler', users_title: 'Kullanicilar', branches_title: 'Subeler',
    schedule_title: 'Vardiya plani', leave_title: 'Izin onaylari',
    cash_transfers_title: 'Transferler', bank_statements_title: 'Banka ekstresi',
    reconciliation_title: 'Mutabakat', credit_report_title: 'Kredi raporu',
    supplier_report_title: 'Tedarikci raporu', category_report_title: 'Kategori raporu',
    kitchen_title: 'Mutfak ekrani', notifications_title: 'Bildirimler',
    help_title: 'Yardim ve Rehber', portal_title: 'Calisan portali',
    cctv_title: 'Guvenlik kamerasi', menu_items: 'Menu ogeler',
    order_status: 'Siparis durumu', preparing: 'Hazirlaniyor', ready_pickup: 'Hazir',
    stock_alert_title: 'minimum seviyenin altindaki urunler',
    transactions: 'islemler', items: 'urunler', payments: 'odemeler',
    overview: 'Genel bakis', period: 'Donem', compare: 'Karsilastir', trends: 'Trendler',
    nav_rate_limits: 'API Limitleri',
    rate_limit_title: 'API Hiz Limitleri', rate_limit_subtitle: 'Kullanim limitlerini izle ve yapilandir',
  },
  tl: {
    // Navigation
    nav_operations: 'Operasyon', nav_finance: 'Pananalapi', nav_people: 'Mga Tao',
    nav_stock: 'Imbentaryo', nav_reports: 'Mga Ulat', nav_assets: 'Mga Ari-arian', nav_admin: 'Admin',
    nav_sales_revenue: 'Benta at Kita', nav_expenses_payables: 'Gastos at Bayarin',
    nav_hr_workforce: 'HR at Manggagawa', nav_pos_inventory: 'POS at Imbentaryo',
    nav_accounting: 'Accounting',
    nav_dashboard: 'Dashboard', nav_quick_entry: 'Mabilisang Entry', nav_live_analytics: 'Live Analytics',
    nav_sales: 'Benta', nav_invoices: 'Invoice', nav_expenses: 'Gastos',
    nav_supplier_payments: 'Bayad sa Supplier', nav_cash_transfers: 'Cash Transfer',
    nav_customers: 'Mga Customer', nav_suppliers: 'Mga Supplier', nav_employees: 'Mga Empleyado',
    nav_leave_approvals: 'Leave Approval', nav_schedule: 'Iskedyul',
    nav_inventory: 'Imbentaryo', nav_transfers: 'Transfer', nav_kitchen: 'Kusina',
    nav_analytics: 'Analytics', nav_visualizations: 'Visualization', nav_reports_page: 'Mga Ulat',
    nav_credit_report: 'Credit Report', nav_supplier_report: 'Supplier Report',
    nav_category_report: 'Category Report', nav_bank_statements: 'Bank Statement',
    nav_reconciliation: 'Reconciliation', nav_branches: 'Mga Branch', nav_documents: 'Mga Dokumento',
    nav_fines: 'Mga Multa', nav_partners: 'Mga Partner', nav_company_loans: 'Mga Utang',
    nav_users: 'Mga User', nav_settings: 'Settings', nav_help: 'Tulong at Gabay',
    nav_menu_items: 'Mga Item sa Menu',
    // Help
    help_sales: 'I-record ang araw-araw na benta, subaybayan ang cash/card/credit na bayad',
    help_expenses: 'Subaybayan ang gastos ayon sa kategorya, supplier at paraan ng bayad',
    help_hr: 'Pamahalaan ang empleyado, sahod, leave, attendance at dokumento',
    help_pos: 'I-configure ang POS ayon sa uri ng negosyo',
    help_accounting: 'Journal entries, balance sheet at income statement',
    help_reports: 'Advanced analytics, forecast at custom na mga ulat',
    // Dashboard
    dash_title: 'Dashboard', dash_subtitle: 'Buod ng negosyo',
    total_sales: 'Kabuuang benta', total_expenses: 'Kabuuang gastos', net_profit: 'Netong kita',
    supplier_payments: 'Bayad sa supplier', pending_credits: 'Nakabinbing kredit',
    today_vs_yesterday: 'vs kahapon', recent_sales: 'Mga kamakailang benta',
    expense_breakdown: 'Detalye ng gastos',
    quick_actions: 'Mabilisang aksyon', new_sale: 'Bagong benta', new_expense: 'Bagong gastos',
    view_reports: 'Tingnan ang mga ulat', cash_balance: 'Cash balance', bank_balance: 'Bank balance',
    customize_widgets: 'I-customize', reset_layout: 'I-reset',
    // Reconciliation Wizard
    wiz_title: 'Pagkakatugma sa 3 hakbang',
    wiz_subtitle: 'I-convert ang raw bank statements sa auto-matched, audit-ready, AI-narrated forensic stories.',
    wiz_step: 'Hakbang', wiz_done: 'Tapos',
    wiz_upload_title: 'I-upload ang statement',
    wiz_upload_desc: 'Mag-drop ng CSV / XLSX bank statement para sa smart-match engine.',
    wiz_upload_cta: 'I-upload',
    wiz_review_title: 'Suriin ang auto-matches',
    wiz_review_desc: 'Kumpirmahin o tanggihan ang mga suggestion — lahat ng aksyon naka-log.',
    wiz_review_cta: 'Suriin',
    wiz_narrate_title: 'Bumuo ng audit story',
    wiz_narrate_desc: 'I-click ang "Replay this match as a story" para sa AI-narrated summary.',
    wiz_narrate_cta: 'Buksan ang log',
    add_widget: 'Magdagdag ng section', remove_widget: 'Alisin',
    // Sales
    sales_title: 'Pamamahala ng benta', sales_subtitle: 'Subaybayan ang lahat ng transaksyon',
    add_new_sale: 'Bagong benta', sale_date: 'Petsa', sale_amount: 'Halaga',
    payment_details: 'Detalye ng bayad', payment_mode: 'Paraan ng bayad',
    customer_name: 'Pangalan ng customer', sale_items: 'Mga item', sale_notes: 'Mga tala',
    credit_amount: 'Halagang credit', all_sales: 'Lahat ng benta',
    // Expenses
    expenses_title: 'Gastos', expenses_subtitle: 'Subaybayan ang mga gastos',
    add_expense: 'Magdagdag ng gastos', expense_date: 'Petsa', expense_amount: 'Halaga',
    expense_category: 'Kategorya', expense_description: 'Paglalarawan',
    all_expenses: 'Lahat ng gastos', total_label: 'Kabuuan',
    // Employees
    employees_title: 'Mga Empleyado', employees_subtitle: 'Pamahalaan ang iyong team',
    add_employee: 'Magdagdag ng empleyado', employee_name: 'Pangalan', employee_phone: 'Telepono',
    employee_email: 'Email', employee_role: 'Posisyon', employee_salary: 'Sahod',
    employee_branch: 'Branch', employee_status: 'Katayuan', job_titles: 'Mga posisyon',
    active: 'Aktibo', inactive: 'Hindi aktibo',
    // Stock
    stock_title: 'Pamamahala ng stock', stock_subtitle: 'Pagsubaybay at kontrol ng imbentaryo',
    add_item: 'Magdagdag ng item', item_name: 'Pangalan ng item', item_category: 'Kategorya',
    item_unit: 'Unit', unit_price: 'Presyo ng benta', cost_price: 'Presyo ng gastos',
    min_stock: 'Min stock', current_stock: 'Kasalukuyang stock', stock_in: 'Stock in',
    stock_out: 'Stock out', stock_value: 'Halaga ng stock',
    // Invoices
    invoices_title: 'Mga Invoice', invoices_subtitle: 'Pamahalaan ang mga invoice',
    create_invoice: 'Gumawa ng invoice', invoice_number: 'Invoice no.', invoice_date: 'Petsa',
    invoice_customer: 'Customer', invoice_items: 'Mga item', invoice_total: 'Kabuuan',
    invoice_status: 'Katayuan', invoice_paid: 'Bayad na', invoice_unpaid: 'Hindi pa bayad',
    scan_invoice: 'I-scan ang invoice',
    // Customers
    customers_title: 'Mga Customer', customers_subtitle: 'Database ng mga customer',
    add_customer: 'Magdagdag ng customer', customer_phone: 'Telepono', customer_balance: 'Balanse',
    total_customers: 'Kabuuang customer', total_credit: 'Kabuuang kredit',
    // Suppliers
    suppliers_title: 'Mga Supplier', suppliers_subtitle: 'Pamamahala ng mga supplier',
    add_supplier: 'Magdagdag ng supplier', supplier_name: 'Pangalan', supplier_phone: 'Telepono',
    supplier_balance: 'Balanse', total_suppliers: 'Kabuuang supplier',
    // POS
    pos_title: 'Mabilisang entry', pos_customer: 'Customer', pos_item: 'Item',
    pos_quantity: 'Dami', pos_price: 'Presyo', pos_discount: 'Diskwento',
    pos_total: 'Kabuuan', pos_add_item: 'Magdagdag ng item', pos_submit: 'I-record ang benta',
    pos_clear: 'I-clear', pos_payment_mode: 'Paraan ng bayad',
    pos_cash: 'Cash', pos_bank: 'Bangko', pos_online: 'Online', pos_credit: 'Kredit',
    // Settings
    settings_title: 'Settings', settings_subtitle: 'Mga setting ng sistema',
    email_config: 'Email settings', whatsapp_config: 'WhatsApp settings',
    company_branding: 'Branding', scheduler_config: 'Mga naka-schedule na ulat',
    data_management: 'Pamamahala ng data', notification_settings: 'Setting ng notification',
    // Partners
    partners_title: 'Mga Partner', partners_subtitle: 'Pamumuhunan at hatian ng kita',
    add_partner: 'Magdagdag ng partner', partner_name: 'Pangalan',
    share_percentage: 'Bahagi %', total_invested: 'Kabuuang puhunan',
    total_withdrawn: 'Kabuuang withdrawal', partner_balance: 'Balanse',
    // Reports
    reports_title: 'Mga Ulat', eod_summary: 'Buod ng araw', partner_pnl: 'Partner P&L',
    daily_summary: 'Araw-araw na buod', top_customers: 'Nangungunang customer',
    cashier_performance: 'Performance ng cashier', generate: 'Gumawa', print_report: 'I-print',
    // Analytics
    analytics_title: 'Advanced analytics', analytics_subtitle: 'AI-powered na mga insight',
    predictive_hub: 'Predictive analysis center',
    expense_forecast: 'Gastos forecast', stock_reorder: 'Stock reorder',
    revenue_trends: 'Revenue trends', customer_churn: 'Customer churn',
    margin_optimizer: 'Margin optimizer', sales_forecast: 'Sales forecast',
    // Visualizations
    viz_title: 'Mga Visualization', viz_subtitle: 'Advanced na mga chart',
    viz_heatmap: 'Heatmap', viz_funnel: 'Funnel', viz_treemap: 'Treemap',
    viz_gauges: 'Gauges', viz_radar: 'Radar', viz_waterfall: 'Waterfall',
    viz_money_flow: 'Money flow', viz_compare: 'Ihambing',
    viz_export_png: 'I-export bilang larawan', viz_click_drill: 'I-click para sa detalye',
    // Common UI
    loading: 'Naglo-load...', save: 'I-save', cancel: 'Kanselahin', delete: 'Burahin',
    edit: 'I-edit', add: 'Idagdag', search: 'Maghanap', filter: 'I-filter',
    export_btn: 'I-export', print: 'I-print', refresh: 'I-refresh', close: 'Isara',
    confirm: 'Kumpirmahin', actions: 'Mga aksyon', status: 'Katayuan', date: 'Petsa',
    amount: 'Halaga', description: 'Paglalarawan', category: 'Kategorya',
    branch: 'Branch', all_branches: 'Lahat ng branch', no_data: 'Walang data',
    name: 'Pangalan', phone: 'Telepono', email: 'Email', address: 'Address',
    submit: 'Isumite', update: 'I-update', view: 'Tingnan', download: 'I-download',
    dark: 'Madilim', light: 'Maliwanag', shortcuts: 'Mga shortcut', logout: 'Mag-logout',
    language: 'Wika', more: 'Iba pa',
    error_occurred: 'May naganap na error', try_again: 'Subukan ulit',
    back: 'Bumalik', next: 'Susunod', previous: 'Nakaraan',
    sort: 'Ayusin', export: 'I-export', import: 'I-import',
    reset: 'I-reset', apply: 'Ilapat', clear: 'I-clear',
    // Status
    success: 'Matagumpay', failed: 'Nabigo', pending: 'Nakabinbin', completed: 'Tapos na',
    in_progress: 'Isinasagawa', cancelled: 'Kinansela',
    // Shift Report
    shift_report_title: 'Ulat ng shift', shift_report_subtitle: 'Mga shift ng cashier at reconciliation',
    daily_report: 'Araw-araw na ulat', date_range: 'Saklaw ng petsa', total_shifts: 'Kabuuang shift',
    opening_cash: 'Panimulang cash', closing_cash: 'Pangwakas na cash', expected_cash: 'Inaasahang cash',
    cash_difference: 'Pagkakaiba ng cash', shortage: 'Kulang', overage: 'Labis', balanced: 'Balanse',
    payment_breakdown: 'Detalye ng bayad', sales_by_branch: 'Benta ayon sa branch',
    shift_details: 'Detalye ng shift', top_selling_items: 'Pinakamaraming nabenta',
    daily_trend: 'Araw-araw na trend', daily_breakdown: 'Araw-araw na detalye',
    avg_sales_day: 'Ave. benta/araw', duration: 'Tagal', cashier: 'Cashier',
    // Bulk Salary
    bulk_salary_title: 'Maramihang sahod', preview_select: 'Preview at piliin',
    to_pay: 'Babayaran', already_paid: 'Bayad na', total_amount: 'Kabuuang halaga',
    employees_to_pay: 'Mga babayaran', select_all: 'Piliin lahat',
    pay_employees: 'Magbayad', payment_completed: 'Bayad na', by_branch: 'Ayon sa branch',
    // Expense Categories
    cat_salary: 'Sahod', cat_rent: 'Upa', cat_utilities: 'Utilities', cat_vehicle: 'Sasakyan',
    cat_maintenance: 'Maintenance', cat_supplier: 'Supplier', cat_tickets: 'Tiket',
    cat_id_card: 'ID Card', cat_other: 'Iba pa',
    cat_basic_salary: 'Batayang sahod', cat_overtime: 'Overtime', cat_bonus: 'Bonus',
    cat_office_rent: 'Upa ng opisina', cat_warehouse_rent: 'Upa ng bodega', cat_shop_rent: 'Upa ng tindahan',
    cat_electricity: 'Kuryente', cat_water: 'Tubig', cat_internet: 'Internet', cat_phone: 'Telepono',
    cat_fuel: 'Gasolina', cat_insurance: 'Insurance', cat_office_maintenance: 'Maintenance ng opisina',
    cat_equipment_repair: 'Repair ng equipment',
    // Widgets
    widget_stats: 'Mga istatistika', widget_charts: 'Mabilisang chart', widget_cash_bank: 'Cash at Bangko',
    widget_payment_mode: 'Paraan ng bayad', widget_spending: 'Detalye ng gastos',
    widget_dues: 'Mga due at alerto', widget_branch_dues: 'Branch dues', widget_vat: 'Buod ng buwis',
    show_all: 'Ipakita lahat', minimize: 'I-minimize', done: 'Tapos',
    // AI
    ai_hub_title: 'AI Business Hub', ai_hub_subtitle: 'AI-powered na business intelligence',
    ai_supplier_intel: 'Supplier Intelligence', ai_pricing_opt: 'Price Optimization',
    ai_churn: 'Customer Churn', ai_marketing: 'Marketing',
    ai_insights: 'AI Insights', ai_hub_load_error: 'Hindi na-load',
    ai_total_customers: 'Kabuuang customer', ai_churned: 'Nawala', ai_high_risk: 'Mataas na panganib',
    ai_campaign_suggestions: 'Mga suhestyon', ai_best_day: 'Pinakamainam na araw', ai_worst_day: 'Pinakamasamang araw',
    nav_ai_hub: 'AI Hub', nav_ai_forecast: 'AI Forecast', nav_cross_branch: 'Cross-Branch Report',
    nav_anomaly_detection: 'Anomaly Detection',
    inv_forecast_title: 'AI Inventory Forecast', cross_branch_title: 'Multi-branch report',
    // Page titles
    attendance_title: 'Attendance Dashboard', payroll_title: 'Payroll Management',
    performance_title: 'Performance at Reviews', training_title: 'Training Management',
    recruitment_title: 'Recruitment', leave_cal_title: 'Leave Management',
    emp_docs_title: 'Employee Documents', hr_analytics_title: 'HR Analytics',
    balance_sheet_title: 'Balance Sheet', pnl_title: 'Profit & Loss',
    journal_title: 'Journal Entries', coa_title: 'Chart of Accounts',
    bills_title: 'Mga Bill', daily_summary_title: 'Daily Summary',
    cashier_pos_title: 'Restaurant POS', activity_logs_title: 'Activity Logs',
    audit_trail_title: 'Audit Trail', currency_settings_title: 'Currency Settings',
    role_mgmt_title: 'Mga Role at Pahintulot', country_laws_title: 'Batas pangmanggagawa',
    loan_mgmt_title: 'Loan Management', staff_perf_title: 'Staff Performance',
    anomaly_title: 'Anomaly Detection', pos_config_title: 'POS Configuration',
    data_mgmt_title: 'Data Management', data_export_title: 'Data Export',
    stock_reorder_title: 'AI Stock Analysis', sales_forecast_title: 'AI Sales Analysis',
    // Common
    total_employees: 'Kabuuang Empleyado', today: 'Ngayon', yesterday: 'Kahapon',
    this_month: 'Ngayong buwan', last_month: 'Nakaraang buwan',
    paid: 'Bayad na', unpaid: 'Hindi pa bayad',
    approved: 'Aprubado', rejected: 'Tinanggihan',
    debit: 'Debit', credit: 'Kredit', balance: 'Balanse',
    revenue: 'Kita', expenses: 'Gastos', profit: 'Tubo', loss: 'Pagkalugi',
    monthly: 'Buwanang', weekly: 'Lingguhang', daily: 'Araw-araw',
    no_results: 'Walang resulta', details: 'Detalye', summary: 'Buod', history: 'Kasaysayan',
    confirm_delete: 'Sigurado ka bang gusto mong burahin?',
    success_saved: 'Matagumpay na na-save', success_deleted: 'Matagumpay na nabura',
    // Other pages
    documents_title: 'Mga Dokumento', fines_title: 'Mga Multa at Parusa',
    company_loans_title: 'Mga Utang', users_title: 'Mga User', branches_title: 'Mga Branch',
    schedule_title: 'Iskedyul ng shift', leave_title: 'Leave approval',
    cash_transfers_title: 'Mga Transfer', bank_statements_title: 'Bank statement',
    reconciliation_title: 'Reconciliation', credit_report_title: 'Credit report',
    supplier_report_title: 'Supplier report', category_report_title: 'Category report',
    kitchen_title: 'Kitchen display', notifications_title: 'Mga Notification',
    help_title: 'Tulong at Gabay', portal_title: 'Employee Portal',
    cctv_title: 'CCTV Security', menu_items: 'Mga Item sa Menu',
    order_status: 'Status ng order', preparing: 'Inihahanda', ready_pickup: 'Handa na',
    stock_alert_title: 'mga item na mababa ang stock',
    transactions: 'mga transaksyon', items: 'mga item', payments: 'mga bayad',
    overview: 'Pangkalahatang-tanaw', period: 'Panahon', compare: 'Ihambing', trends: 'Mga trend',
    nav_rate_limits: 'API Limits',
    rate_limit_title: 'Mga Limitasyon ng API', rate_limit_subtitle: 'I-monitor at i-configure ang mga limitasyon',
  },
  ml: {
    // Navigation
    nav_operations: 'പ്രവര്ത്തനങ്ങള്', nav_finance: 'ധനകാര്യം', nav_people: 'ആളുകള്',
    nav_stock: 'സ്റ്റോക്ക്', nav_reports: 'റിപ്പോര്ട്ടുകള്', nav_assets: 'ആസ്തികള്', nav_admin: 'അഡ്മിന്',
    nav_sales_revenue: 'വില്പ്പനയും വരുമാനവും', nav_expenses_payables: 'ചെലവുകളും പേയ്മെന്റുകളും',
    nav_hr_workforce: 'HR & ജീവനക്കാര്', nav_pos_inventory: 'POS & ഇന്വെന്ററി',
    nav_accounting: 'അക്കൗണ്ടിംഗ്',
    nav_dashboard: 'ഡാഷ്ബോര്ഡ്', nav_quick_entry: 'ക്വിക്ക് എന്ട്രി', nav_live_analytics: 'ലൈവ് അനലിറ്റിക്സ്',
    nav_sales: 'വില്പ്പന', nav_invoices: 'ഇന്വോയ്സ്', nav_expenses: 'ചെലവുകള്',
    nav_supplier_payments: 'വിതരണക്കാരന്റെ പേയ്മെന്റ്', nav_cash_transfers: 'ക്യാഷ് ട്രാന്സ്ഫര്',
    nav_customers: 'ഉപഭോക്താക്കള്', nav_suppliers: 'വിതരണക്കാര്', nav_employees: 'ജീവനക്കാര്',
    nav_leave_approvals: 'ലീവ് അനുമതി', nav_schedule: 'ഷെഡ്യൂള്',
    nav_inventory: 'ഇന്വെന്ററി', nav_transfers: 'ട്രാന്സ്ഫര്', nav_kitchen: 'അടുക്കള',
    nav_analytics: 'അനലിറ്റിക്സ്', nav_visualizations: 'വിഷ്വലൈസേഷന്', nav_reports_page: 'റിപ്പോര്ട്ടുകള്',
    nav_credit_report: 'ക്രെഡിറ്റ് റിപ്പോര്ട്ട്', nav_supplier_report: 'വിതരണക്കാരന്റെ റിപ്പോര്ട്ട്',
    nav_category_report: 'വിഭാഗം റിപ്പോര്ട്ട്', nav_bank_statements: 'ബാങ്ക് സ്റ്റേറ്റ്മെന്റ്',
    nav_reconciliation: 'റീകണ്സിലിയേഷന്', nav_branches: 'ശാഖകള്', nav_documents: 'രേഖകള്',
    nav_fines: 'പിഴകള്', nav_partners: 'പങ്കാളികള്', nav_company_loans: 'വായ്പകള്',
    nav_users: 'ഉപയോക്താക്കള്', nav_settings: 'സെറ്റിംഗ്സ്', nav_help: 'സഹായവും ഗൈഡും',
    nav_menu_items: 'മെനു ഐറ്റങ്ങള്',
    // Help
    help_sales: 'ദൈനംദിന വില്പ്പന രേഖപ്പെടുത്തുക, ക്യാഷ്/കാര്ഡ്/ക്രെഡിറ്റ് പേയ്മെന്റ് ട്രാക്ക് ചെയ്യുക',
    help_expenses: 'വിഭാഗം, വിതരണക്കാരന്, പേയ്മെന്റ് രീതി അനുസരിച്ച് ചെലവുകള് ട്രാക്ക് ചെയ്യുക',
    help_hr: 'ജീവനക്കാര്, ശമ്പളം, ലീവ്, ഹാജര്, രേഖകള് നിയന്ത്രിക്കുക',
    help_pos: 'നിങ്ങളുടെ ബിസിനസ് തരം അനുസരിച്ച് POS കോണ്ഫിഗര് ചെയ്യുക',
    help_accounting: 'ജേണല് എന്ട്രികള്, ബാലന്സ് ഷീറ്റ്, വരുമാന പ്രസ്താവന',
    help_reports: 'വിപുലമായ അനലിറ്റിക്സ്, പ്രവചനങ്ങള്, ഇഷ്ടാനുസൃത റിപ്പോര്ട്ടുകള്',
    // Dashboard
    dash_title: 'ഡാഷ്ബോര്ഡ്', dash_subtitle: 'ബിസിനസ് അവലോകനം',
    total_sales: 'ആകെ വില്പ്പന', total_expenses: 'ആകെ ചെലവ്', net_profit: 'അറ്റ ലാഭം',
    supplier_payments: 'വിതരണക്കാരന് പേയ്മെന്റ്', pending_credits: 'ബാക്കി ക്രെഡിറ്റുകള്',
    today_vs_yesterday: 'vs ഇന്നലെ', recent_sales: 'സമീപകാല വില്പ്പന',
    expense_breakdown: 'ചെലവ് വിശദാംശങ്ങള്',
    quick_actions: 'ദ്രുത നടപടികള്', new_sale: 'പുതിയ വില്പ്പന', new_expense: 'പുതിയ ചെലവ്',
    view_reports: 'റിപ്പോര്ട്ടുകള് കാണുക', cash_balance: 'ക്യാഷ് ബാലന്സ്', bank_balance: 'ബാങ്ക് ബാലന്സ്',
    customize_widgets: 'ഇഷ്ടാനുസൃതമാക്കുക', reset_layout: 'റീസെറ്റ്',
    // Reconciliation Wizard
    wiz_title: '3 ഘട്ടത്തിൽ പൊരുത്തപ്പെടുത്തൽ',
    wiz_subtitle: 'ബാങ്ക് സ്റ്റേറ്റ്‌മെൻ്റുകൾ സ്വയം പൊരുത്തപ്പെടുത്തലുകൾ, ഓഡിറ്റ് ട്രെയിലുകൾ, AI വിവരണ കഥകളാക്കി മാറ്റുക.',
    wiz_step: 'ഘട്ടം', wiz_done: 'പൂർത്തിയായി',
    wiz_upload_title: 'സ്റ്റേറ്റ്‌മെൻ്റ് അപ്‌ലോഡ്',
    wiz_upload_desc: 'സ്മാർട്ട്-മാച്ച് എഞ്ചിനായി CSV / XLSX ബാങ്ക് സ്റ്റേറ്റ്‌മെൻ്റ് ഇടുക.',
    wiz_upload_cta: 'അപ്‌ലോഡ്',
    wiz_review_title: 'സ്വയം പൊരുത്തപ്പെടുത്തലുകൾ പരിശോധിക്കുക',
    wiz_review_desc: 'നിർദ്ദേശങ്ങൾ സ്ഥിരീകരിക്കുക/നിരസിക്കുക — ഓരോ പ്രവൃത്തിയും ഓഡിറ്റ് ലോഗിൽ.',
    wiz_review_cta: 'പരിശോധിക്കുക',
    wiz_narrate_title: 'ഓഡിറ്റ് കഥ സൃഷ്ടിക്കുക',
    wiz_narrate_desc: '"ഈ പൊരുത്തം കഥയായി പ്ലേ ചെയ്യുക" ക്ലിക്ക് ചെയ്ത് AI സംഗ്രഹം നേടുക.',
    wiz_narrate_cta: 'ലോഗ് തുറക്കുക',
    // Sales
    sales_title: 'വില്പ്പന മാനേജ്മെന്റ്', sales_subtitle: 'എല്ലാ ഇടപാടുകളും ട്രാക്ക് ചെയ്യുക',
    add_new_sale: 'പുതിയ വില്പ്പന', sale_date: 'തീയതി', sale_amount: 'തുക',
    payment_details: 'പേയ്മെന്റ് വിശദാംശങ്ങള്', payment_mode: 'പേയ്മെന്റ് രീതി',
    customer_name: 'ഉപഭോക്തൃ പേര്', sale_items: 'ഐറ്റങ്ങള്', sale_notes: 'കുറിപ്പുകള്',
    credit_amount: 'ക്രെഡിറ്റ് തുക', all_sales: 'എല്ലാ വില്പ്പനയും',
    // Expenses
    expenses_title: 'ചെലവുകള്', expenses_subtitle: 'ചെലവുകള് ട്രാക്ക് ചെയ്യുക',
    add_expense: 'ചെലവ് ചേര്ക്കുക', expense_date: 'തീയതി', expense_amount: 'തുക',
    expense_category: 'വിഭാഗം', expense_description: 'വിവരണം',
    all_expenses: 'എല്ലാ ചെലവുകളും', total_label: 'ആകെ',
    // Employees
    employees_title: 'ജീവനക്കാര്', employees_subtitle: 'നിങ്ങളുടെ ടീമിനെ നിയന്ത്രിക്കുക',
    add_employee: 'ജീവനക്കാരനെ ചേര്ക്കുക', employee_name: 'പേര്', employee_phone: 'ഫോണ്',
    employee_email: 'ഇമെയില്', employee_role: 'തസ്തിക', employee_salary: 'ശമ്പളം',
    employee_branch: 'ശാഖ', employee_status: 'സ്ഥിതി', job_titles: 'ജോലി ശീര്ഷകങ്ങള്',
    active: 'സജീവം', inactive: 'നിഷ്ക്രിയം',
    // Stock
    stock_title: 'സ്റ്റോക്ക് മാനേജ്മെന്റ്', stock_subtitle: 'ഇന്വെന്ററി ട്രാക്കിംഗ്',
    add_item: 'ഐറ്റം ചേര്ക്കുക', item_name: 'ഐറ്റം പേര്', item_category: 'വിഭാഗം',
    item_unit: 'യൂണിറ്റ്', unit_price: 'വില്പ്പന വില', cost_price: 'ചെലവ് വില',
    min_stock: 'മിനിമം', current_stock: 'നിലവിലെ സ്റ്റോക്ക്', stock_in: 'സ്റ്റോക്ക് ഇന്',
    stock_out: 'സ്റ്റോക്ക് ഔട്ട്', stock_value: 'സ്റ്റോക്ക് മൂല്യം',
    // Invoices
    invoices_title: 'ഇന്വോയ്സുകള്', invoices_subtitle: 'ഇന്വോയ്സുകള് നിയന്ത്രിക്കുക',
    create_invoice: 'ഇന്വോയ്സ് സൃഷ്ടിക്കുക', invoice_number: 'ഇന്വോയ്സ് നമ്പര്',
    invoice_date: 'തീയതി', invoice_customer: 'ഉപഭോക്താവ്', invoice_items: 'ഐറ്റങ്ങള്',
    invoice_total: 'ആകെ', invoice_status: 'സ്ഥിതി',
    invoice_paid: 'അടച്ചു', invoice_unpaid: 'അടച്ചിട്ടില്ല',
    // Common UI
    loading: 'ലോഡ് ചെയ്യുന്നു...', save: 'സേവ്', cancel: 'റദ്ദാക്കുക', delete: 'ഇല്ലാതാക്കുക',
    edit: 'എഡിറ്റ്', add: 'ചേര്ക്കുക', search: 'തിരയുക', filter: 'ഫില്റ്റര്',
    export_btn: 'എക്സ്പോര്ട്ട്', print: 'പ്രിന്റ്', refresh: 'റീഫ്രഷ്', close: 'അടയ്ക്കുക',
    confirm: 'സ്ഥിരീകരിക്കുക', actions: 'നടപടികള്', status: 'സ്ഥിതി', date: 'തീയതി',
    amount: 'തുക', description: 'വിവരണം', category: 'വിഭാഗം',
    branch: 'ശാഖ', all_branches: 'എല്ലാ ശാഖകളും', no_data: 'ഡാറ്റ ഇല്ല',
    name: 'പേര്', phone: 'ഫോണ്', email: 'ഇമെയില്', address: 'വിലാസം',
    submit: 'സമര്പ്പിക്കുക', update: 'അപ്ഡേറ്റ്', view: 'കാണുക', download: 'ഡൗണ്ലോഡ്',
    dark: 'ഇരുണ്ട', light: 'തെളിച്ചം', shortcuts: 'കുറുക്കുവഴികള്', logout: 'ലോഗൗട്ട്',
    language: 'ഭാഷ', more: 'കൂടുതല്',
    error_occurred: 'ഒരു പിശക് സംഭവിച്ചു', try_again: 'വീണ്ടും ശ്രമിക്കുക',
    back: 'മടങ്ങുക', next: 'അടുത്തത്', previous: 'മുമ്പത്തേത്',
    // Status
    success: 'വിജയം', failed: 'പരാജയം', pending: 'ബാക്കിയുള്ളത്', completed: 'പൂര്ത്തിയായി',
    in_progress: 'പുരോഗതിയില്', cancelled: 'റദ്ദാക്കി',
    // AI
    ai_hub_title: 'AI ബിസിനസ് ഹബ്', ai_hub_subtitle: 'AI പവേഡ് ബിസിനസ് ഇന്റലിജന്സ്',
    ai_supplier_intel: 'വിതരണക്കാരന്റെ ബുദ്ധിമത്ത', ai_pricing_opt: 'വില ഒപ്റ്റിമൈസേഷന്',
    ai_churn: 'ഉപഭോക്തൃ നഷ്ടം', ai_marketing: 'മാര്ക്കറ്റിംഗ്',
    ai_insights: 'AI ഉള്ക്കാഴ്ചകള്', ai_hub_load_error: 'ലോഡ് ചെയ്യാനായില്ല',
    nav_ai_hub: 'AI ഹബ്', nav_ai_forecast: 'AI പ്രവചനം', nav_cross_branch: 'ക്രോസ്-ശാഖ റിപ്പോര്ട്ട്',
    nav_anomaly_detection: 'അപാകത കണ്ടെത്തല്',
    // Page titles
    attendance_title: 'ഹാജര് ഡാഷ്ബോര്ഡ്', payroll_title: 'ശമ്പള നിര്വഹണം',
    performance_title: 'പ്രകടനവും അവലോകനവും', training_title: 'പരിശീലന നിര്വഹണം',
    recruitment_title: 'റിക്രൂട്ട്മെന്റ്', leave_cal_title: 'ലീവ് നിര്വഹണം',
    emp_docs_title: 'ജീവനക്കാരുടെ രേഖകള്', hr_analytics_title: 'HR വിശകലനം',
    balance_sheet_title: 'ബാലന്സ് ഷീറ്റ്', pnl_title: 'ലാഭനഷ്ട പ്രസ്താവന',
    journal_title: 'ജേണല് എന്ട്രികള്', coa_title: 'അക്കൗണ്ട്സ് ചാര്ട്ട്',
    bills_title: 'ബില്ലുകള്', daily_summary_title: 'ദൈനംദിന സംഗ്രഹം',
    cashier_pos_title: 'റെസ്റ്റോറന്റ് POS', activity_logs_title: 'പ്രവര്ത്തന ലോഗ്',
    audit_trail_title: 'ഓഡിറ്റ് ട്രെയ്ല്', currency_settings_title: 'കറന്സി സെറ്റിംഗ്സ്',
    role_mgmt_title: 'റോളുകളും അനുമതികളും', country_laws_title: 'തൊഴില് നിയമങ്ങള്',
    loan_mgmt_title: 'വായ്പ നിര്വഹണം', staff_perf_title: 'ജീവനക്കാരുടെ പ്രകടനം',
    anomaly_title: 'അപാകത കണ്ടെത്തല്', pos_config_title: 'POS കോണ്ഫിഗറേഷന്',
    data_mgmt_title: 'ഡാറ്റ മാനേജ്മെന്റ്', data_export_title: 'ഡാറ്റ എക്സ്പോര്ട്ട്',
    stock_reorder_title: 'AI സ്റ്റോക്ക് വിശകലനം', sales_forecast_title: 'AI വില്പ്പന വിശകലനം',
    inv_forecast_title: 'AI ഇന്വെന്ററി പ്രവചനം', cross_branch_title: 'മള്ട്ടി-ശാഖ റിപ്പോര്ട്ട്',
    // Common
    total_employees: 'ആകെ ജീവനക്കാര്', today: 'ഇന്ന്', yesterday: 'ഇന്നലെ',
    this_month: 'ഈ മാസം', last_month: 'കഴിഞ്ഞ മാസം',
    paid: 'അടച്ചു', unpaid: 'അടച്ചിട്ടില്ല',
    approved: 'അംഗീകരിച്ചു', rejected: 'നിരസിച്ചു',
    debit: 'ഡെബിറ്റ്', credit: 'ക്രെഡിറ്റ്', balance: 'ബാലന്സ്',
    revenue: 'വരുമാനം', expenses: 'ചെലവുകള്', profit: 'ലാഭം', loss: 'നഷ്ടം',
    monthly: 'മാസം', weekly: 'ആഴ്ച', daily: 'ദിവസം',
    no_results: 'ഫലമില്ല', details: 'വിശദാംശങ്ങള്', summary: 'സംഗ്രഹം', history: 'ചരിത്രം',
    confirm_delete: 'ഇല്ലാതാക്കണമെന്ന് ഉറപ്പാണോ?',
    success_saved: 'വിജയകരമായി സേവ് ചെയ്തു', success_deleted: 'വിജയകരമായി ഇല്ലാതാക്കി',
    // Other pages
    documents_title: 'രേഖകള്', fines_title: 'പിഴകള്',
    company_loans_title: 'വായ്പകള്', users_title: 'ഉപയോക്താക്കള്', branches_title: 'ശാഖകള്',
    schedule_title: 'ഷിഫ്റ്റ് ഷെഡ്യൂള്', leave_title: 'ലീവ് അനുമതി',
    cash_transfers_title: 'ട്രാന്സ്ഫറുകള്', bank_statements_title: 'ബാങ്ക് സ്റ്റേറ്റ്മെന്റ്',
    reconciliation_title: 'റീകണ്സിലിയേഷന്', credit_report_title: 'ക്രെഡിറ്റ് റിപ്പോര്ട്ട്',
    supplier_report_title: 'വിതരണക്കാരന്റെ റിപ്പോര്ട്ട്', category_report_title: 'വിഭാഗ റിപ്പോര്ട്ട്',
    kitchen_title: 'അടുക്കള ഡിസ്പ്ലേ', notifications_title: 'അറിയിപ്പുകള്',
    help_title: 'സഹായവും ഗൈഡും', portal_title: 'ജീവനക്കാരന്റെ പോര്ട്ടല്',
    cctv_title: 'CCTV സെക്യൂരിറ്റി', menu_items: 'മെനു ഐറ്റങ്ങള്',
    order_status: 'ഓര്ഡര് സ്ഥിതി', preparing: 'തയ്യാറാക്കുന്നു', ready_pickup: 'തയ്യാറാണ്',
    stock_alert_title: 'മിനിമം ലെവലിന് താഴെ',
    transactions: 'ഇടപാടുകള്', items: 'ഐറ്റങ്ങള്', payments: 'പേയ്മെന്റുകള്',
    overview: 'അവലോകനം', period: 'കാലഘട്ടം', compare: 'താരതമ്യം', trends: 'ട്രെന്ഡുകള്',
    nav_rate_limits: 'API പരിധികള്',
    rate_limit_title: 'API നിരക്ക് പരിധികള്', rate_limit_subtitle: 'ഉപയോഗ പരിധികള് നിരീക്ഷിക്കുക',
  },
};

const navLabelToKey = {
  'Operations': 'nav_operations', 'Finance': 'nav_finance', 'People': 'nav_people',
  'Stock': 'nav_stock', 'Reports': 'nav_reports', 'Assets': 'nav_assets', 'Admin': 'nav_admin',
  'Sales & Revenue': 'nav_sales_revenue', 'Expenses & Payables': 'nav_expenses_payables',
  'HR & Workforce': 'nav_hr_workforce', 'POS & Inventory': 'nav_pos_inventory',
  'Accounting': 'nav_accounting',
  'Dashboard': 'nav_dashboard', 'Quick Entry': 'nav_quick_entry', 'Live Analytics': 'nav_live_analytics',
  'Sales': 'nav_sales', 'Invoices': 'nav_invoices', 'Expenses': 'nav_expenses',
  'Supplier Payments': 'nav_supplier_payments', 'Cash Transfers': 'nav_cash_transfers',
  'Customers': 'nav_customers', 'Suppliers': 'nav_suppliers', 'Employees': 'nav_employees',
  'Leave Approvals': 'nav_leave_approvals', 'Schedule': 'nav_schedule',
  'Inventory': 'nav_inventory', 'Transfers': 'nav_transfers', 'Kitchen': 'nav_kitchen',
  'Menu Items': 'nav_menu_items', 'Shift Report': 'shift_report_title',
  'Analytics': 'nav_analytics', 'Visualizations': 'nav_visualizations',
  'Credit Report': 'nav_credit_report', 'Supplier Report': 'nav_supplier_report',
  'Category Report': 'nav_category_report', 'Bank Statements': 'nav_bank_statements',
  'Reconciliation': 'nav_reconciliation', 'Branches': 'nav_branches', 'Documents': 'nav_documents',
  'Fines & Penalties': 'nav_fines', 'Partners': 'nav_partners', 'Company Loans': 'nav_company_loans',
  'Users': 'nav_users', 'Settings': 'nav_settings', 'Help & Guide': 'nav_help',
  'CCTV': 'cctv_title', 'Partner P&L': 'partner_pl_title',
  'AI Hub': 'nav_ai_hub', 'AI Forecast': 'nav_ai_forecast', 'Cross-Branch Report': 'nav_cross_branch',
  'Anomaly Detection': 'nav_anomaly_detection',
  'Rate Limits': 'nav_rate_limits',
  'Trial Balance': 'nav_trial_balance',
  'Cash Flow': 'nav_cash_flow',
  'General Ledger': 'nav_general_ledger',
  'AR/AP Aging': 'nav_aging_reports',
  'P&L Compare': 'nav_pnl_compare',
  'Recurring Entries': 'nav_recurring_entries',
};

const LANGUAGES = [
  { code: 'en', label: 'English', flag: 'EN', rtl: false },
  { code: 'ar', label: 'العربية', flag: 'عر', rtl: true },
  { code: 'ur', label: 'اردو', flag: 'ار', rtl: true },
  { code: 'hi', label: 'हिन्दी', flag: 'हि', rtl: false },
  { code: 'bn', label: 'বাংলা', flag: 'বা', rtl: false },
  { code: 'fr', label: 'Francais', flag: 'FR', rtl: false },
  { code: 'es', label: 'Espanol', flag: 'ES', rtl: false },
  { code: 'tr', label: 'Turkce', flag: 'TR', rtl: false },
  { code: 'tl', label: 'Filipino', flag: 'TL', rtl: false },
  { code: 'ml', label: 'Malayalam', flag: 'ML', rtl: false },
];

// Late-binding keys (NEW badge, What's New drawer, Feature tour) — merged
// here so adding new strings doesn't require editing 10 separate places.
import { WHATS_NEW_I18N } from './i18nWhatsNew';
for (const [lang, keys] of Object.entries(WHATS_NEW_I18N)) {
  if (translations[lang]) Object.assign(translations[lang], keys);
}

export { translations, navLabelToKey, LANGUAGES };
